import * as o from "@apollo/client";
import { gql as i } from "@apollo/client";
const n = {}, Du = i`
    fragment ApiToken on ApiToken {
  token
  id
  name
  createdAt
  revoked
}
    `, Qn = i`
    fragment AvailableDataPartner on AvailableDataPartner {
  id
  dataPartnerName
  dataPartnerDescription
  dataPartnerLogo
  dataPartnerId
  requestRecipientId
  allowLookalike
  allowInsights
  allowRetargeting
  allowExclusionTargeting
  allowRuleBasedAudiences
  marketIds
  matchingIdFormat
  matchingIdHashingAlgorithm
  participants
}
    `, Pn = i`
    fragment AvailablePublisher on AvailablePublisher {
  id
  publisherId
  publisherName
  publisherDescription
  publisherLogo
  allowLookalike
  allowInsights
  allowRetargeting
  allowExclusionTargeting
  allowRuleBasedAudiences
  matchingIdFormat
  matchingIdHashingAlgorithm
  publisherParticipants
  requestRecipientId
  marketIds
  allowMeasurements
}
    `, In = i`
    fragment DraftNodeConnectionId on DraftNodeConnection {
  draftNode {
    id
  }
}
    `, hu = i`
    fragment PublishedNodeConnectionId on PublishedNodeConnection {
  computeNodeId
}
    `, fu = i`
    fragment CreateDraftDataRoom on DraftDataRoom {
  id
  title
  description
}
    `, d = i`
    fragment DataConnectorJob on DataConnectorJob {
  id
  type
  name
  status
  config
  dataRoomId
  computeJobNode
  computeJobId
  driverAttestationHash
  createdAt
  finishedAt
  targetType
  commitId
  datasetName
  datasetDescription
  sourceType
}
    `, l = i`
    fragment DataConnectorJobResult on DataConnectorJob {
  id
  status
  finishedAt
  result @client {
    success
    error
  }
}
    `, Nn = i`
    fragment DataPartnerUsageConfiguration on DataPartnerUsageConfiguration {
  id
  name
  matchingIdFormat
  matchingIdHashingAlgorithm
  allowInsights
  allowLookalike
  allowRetargeting
  allowExclusionTargeting
  allowRuleBasedAudiences
  matchAnyDomain
  participants
  advertiserDomains
}
    `, y = i`
    fragment DataPartnerDisplayConfiguration on DataPartnerDisplayConfiguration {
  id
  name
  description
  logo
  marketIds
  collaborationRequestUsers
}
    `, c = i`
    fragment DataRoomUserSettings on DataRoomUserSettings {
  id
  isArchived
  isFavorite
}
    `, Su = i`
    fragment DataRoomOverview on DataRoom {
  id
  name: title
  createdAt
  owner {
    id
    email
  }
  userSettings {
    ...DataRoomUserSettings
  }
}
    `, bu = i`
    fragment Dataset on Dataset {
  id
  createdAt
  description
  manifestHash
  name
  owner {
    id
    email
  }
  size
  statistics
}
    `, gu = i`
    fragment DraftComputationNodeName on DraftComputationNode {
  id
  name
}
    `, Nu = i`
    fragment DraftDataRoomPassword on DraftDataRoom {
  password @client
}
    `, Ru = i`
    fragment DraftLeafNodeName on DraftLeafNode {
  id
  name
}
    `, Qu = i`
    fragment DraftParticipantUserEmail on DraftParticipant {
  id
  userEmail
}
    `, Pu = i`
    fragment ExternalInvitation on UserInvitation {
  id
  user {
    id
    email
    logo
  }
  lastInvitedAt
  lastInvitedBy {
    id
    email
  }
}
    `, Rn = i`
    fragment FullActivationConfiguration on ActivationConfiguration {
  id
  name
  allowInsights
  allowLookalike
  allowRetargeting
  allowExclusionTargeting
  allowRuleBasedAudiences
  allowMeasurements
  matchingIdFormat
  matchingIdHashingAlgorithm
  advertiserDomains
  matchAnyDomain
  publisherParticipants
}
    `, a = i`
    fragment FullDataLab on DataLab {
  id
  name
  highLevelRepresentationAsString
  isValidated
  requireDemographicsDataset
  requireEmbeddingsDataset
  requireSegmentsDataset
  numEmbeddings
  matchingIdFormat
  forceSparkValidation
  matchingIdHashingAlgorithm
  usersDataset {
    id
    manifestHash
    name
  }
  segmentsDataset {
    id
    manifestHash
    name
  }
  demographicsDataset {
    id
    manifestHash
    name
  }
  embeddingsDataset {
    id
    manifestHash
    name
  }
  createdAt
  updatedAt
  jobsDriverAttestationHash
  validationComputeJobId
  statisticsComputeJobId
  statistics
}
    `, D = i`
    fragment LookalikeMediaComputeJobComplete on MediaComputeJob {
  jobIdHex
  publishedDataRoomId
  computeNodeName
  jobType
  cacheKey
  createdAt
}
    `, vn = i`
    fragment MediaInsightsComputeJobComplete on MediaComputeJob {
  jobIdHex
  publishedDataRoomId
  computeNodeName
  jobType
  cacheKey
  createdAt
}
    `, s = i`
    fragment NavigationDrawerDraftDataRoom on DraftDataRoom {
  id
  name: title
  requirePassword @client
}
    `, u = i`
    fragment NavigationDrawerPublishedDataRoom on PublishedDataRoom {
  id
  name: title
  isStopped
  requirePassword
  deactivatedAt
  kind
}
    `, p = i`
    fragment NavigationDrawerPublishedLookalikeMediaDataRoom on PublishedLookalikeMediaDataRoom {
  id
  name: title
  isStopped
  deactivatedAt
  requirePassword
  kind
}
    `, r = i`
    fragment NavigationDrawerPublishedMediaDataRoom on PublishedMediaDataRoom {
  id
  name: title
  isStopped
  requirePassword
  deactivatedAt
  kind
}
    `, m = i`
    fragment NavigationDrawerPublishedMediaInsightsDcr on PublishedMediaInsightsDcr {
  id
  name: title
  isStopped
  deactivatedAt
  requirePassword
  kind
}
    `, $n = i`
    fragment Organization on Organization {
  id
  createdAt
  createdBy {
    id
    email
  }
  updatedAt
  name
  logo
  workerTypes {
    nodes {
      id
      name
      shortName
    }
  }
  domains
  state
  hasAdvertiserFeatures
  hasAnalyticsFeatures
  hasPublisherFeatures
  users {
    nodes {
      id
      email
      userRole
      isDemoUser
      createdAt
    }
    totalCount
  }
  participatingDataRooms {
    totalCount
  }
}
    `, Iu = i`
    fragment PublishedDataRoomPassword on PublishedDataRoom {
  password @client
}
    `, vu = i`
    fragment PublishedDataRoomPasswordRequirements on PublishedDataRoom {
  id
  requirePassword
  password @client
}
    `, $u = i`
    fragment PublishedDataRoomTestingFragment on PublishedDataRoom {
  id
  testing
}
    `, Cu = i`
    fragment PublishedPreviewNodeQuotas on PublishedPreviewNode {
  id
  usedQuotaBytes
  remainingQuotaBytes
  totalQuotaBytes
}
    `, Au = i`
    fragment StaticScript on DraftScript {
  id
  name
  content
  isMainScript
}
    `, Cn = i`
    fragment User on User {
  id
  email
  logo
  userRole
  createdAt
  isDemoUser
}
    `, h = i`
    query AccessToken($tokenId: String!) {
  myself {
    accessTokenById(id: $tokenId) @client {
      token
      id
      name
      createdAt
      revoked
    }
  }
}
    `;
function Mu(e) {
  const t = { ...n, ...e };
  return o.useQuery(h, t);
}
function Lu(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(h, t);
}
function zu(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(h, t);
}
const f = i`
    query AccessTokens {
  myself {
    id
    apiTokens {
      nodes {
        token
        revoked
        id
        name
        createdAt
      }
    }
  }
}
    `;
function Hu(e) {
  const t = { ...n, ...e };
  return o.useQuery(f, t);
}
function qu(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(f, t);
}
function Tu(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(f, t);
}
const S = i`
    query AccessTokensNames {
  myself {
    id
    apiTokens {
      nodes {
        id
        name
      }
    }
  }
}
    `;
function wu(e) {
  const t = { ...n, ...e };
  return o.useQuery(S, t);
}
function ku(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(S, t);
}
function Fu(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(S, t);
}
const An = i`
    mutation ActivateConsentlessAudience($input: MediaActivateConsentlessAudienceInput!) {
  mediaActivateConsentlessAudience(input: $input) @client {
    audienceId
  }
}
    `;
function Uu(e) {
  const t = { ...n, ...e };
  return o.useMutation(An, t);
}
const Mn = i`
    mutation ActivateDirectAudience($input: MediaActivateDirectAudienceInput!) {
  mediaActivateDirectAudience(input: $input) @client {
    audienceTypes
  }
}
    `;
function Ou(e) {
  const t = { ...n, ...e };
  return o.useMutation(Mn, t);
}
const b = i`
    query ActivationConfigurations($id: String!, $isAdmin: Boolean!) {
  ownOrganization: myself {
    organization {
      activationConfigurations {
        nodes {
          ...FullActivationConfiguration
        }
        totalCount
      }
    }
  }
  otherOrganization: organization(id: $id) @include(if: $isAdmin) {
    activationConfigurations {
      nodes {
        ...FullActivationConfiguration
      }
      totalCount
    }
  }
}
    ${Rn}`;
function Eu(e) {
  const t = { ...n, ...e };
  return o.useQuery(b, t);
}
function Ju(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(b, t);
}
function xu(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(b, t);
}
const g = i`
    query MediaDataRoomActivationDownloadConfig($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    activationType @client
    activationDownloadByAdvertiser @client
    activationDownloadByPublisher @client
  }
}
    `;
function Bu(e) {
  const t = { ...n, ...e };
  return o.useQuery(g, t);
}
function _u(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(g, t);
}
function ju(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(g, t);
}
const N = i`
    query ActiveMarkets {
  publisherMarkets {
    nodes {
      id
      rank
      name
    }
  }
}
    `;
function Wu(e) {
  const t = { ...n, ...e };
  return o.useQuery(N, t);
}
function Gu(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(N, t);
}
function Vu(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(N, t);
}
const Ln = i`
    mutation AddRequestParticipant($input: CreateDraftParticipantInput!, $requestId: String!) {
  dataRoomRequest {
    addParticipant(input: $input, dataRoomRequestId: $requestId) {
      id
      userEmail
    }
  }
}
    `;
function Zu(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ln, t);
}
const zn = i`
    mutation AddScriptingNodeDependency($computeNodeId: String!, $dependencyId: NodeId!) {
  draftScriptingNode {
    addDependency(id: $computeNodeId, dependencyId: $dependencyId) {
      id
      dependencies {
        nodes {
          ... on DraftNodeConnection {
            draftNode {
              id
              name
            }
          }
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
    }
  }
}
    `;
function Ku(e) {
  const t = { ...n, ...e };
  return o.useMutation(zn, t);
}
const Hn = i`
    mutation AddSubmittedDataRoomRequestSignature($input: CreateDataRoomRequestSignatureInput!) {
  submittedDataRoomRequest {
    addSignature(input: $input) {
      id
      signers {
        nodes {
          id
          signature
          userEmail
          user {
            id
            email
          }
        }
      }
    }
  }
}
    `;
function Xu(e) {
  const t = { ...n, ...e };
  return o.useMutation(Hn, t);
}
const qn = i`
    mutation AddSyntheticNodeColumn($id: String!, $column: CreateSyntheticNodeColumnForSyntheticNodeInput!) {
  draftSyntheticNode {
    insertSyntheticNodeColumn(
      draftSyntheticNodeId: $id
      syntheticNodeColumn: $column
    ) {
      id
      columns {
        nodes {
          id
          index
          name
          maskType
          dataType
          shouldMaskColumn
        }
      }
    }
  }
}
    `;
function Yu(e) {
  const t = { ...n, ...e };
  return o.useMutation(qn, t);
}
const R = i`
    query AdminPortalOrganizationUsers($organizationId: String!) {
  organization(id: $organizationId) {
    id
    users {
      nodes {
        id
        email
        logo
        organization {
          id
          name
        }
        userRole
        isDemoUser
        createdAt
      }
    }
  }
}
    `;
function er(e) {
  const t = { ...n, ...e };
  return o.useQuery(R, t);
}
function tr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(R, t);
}
function or(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(R, t);
}
const Q = i`
    query ConsentlessAudiences($input: MediaRetrieveConsentlessAudiencesInput!, $id: String!) {
  mediaRetrieveConsentlessAudiences(input: $input) @client {
    nodes {
      id
      name
      precision
      size
      activated
      downloaded
      owner
    }
  }
  publishedMediaDataRoom(id: $id) {
    id
    activationDownloadByPublisher @client
  }
}
    `;
function nr(e) {
  const t = { ...n, ...e };
  return o.useQuery(Q, t);
}
function ir(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Q, t);
}
function ar(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Q, t);
}
const P = i`
    query AdvertiserMarketFilters {
  publisherMarkets {
    nodes {
      id
      rank
      name
    }
  }
  advertiserMarketFilters
}
    `;
function sr(e) {
  const t = { ...n, ...e };
  return o.useQuery(P, t);
}
function ur(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(P, t);
}
function rr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(P, t);
}
const Tn = i`
    mutation ApproveSubmittedDataRoomRequest($input: ApproveSubmittedDataRoomRequestLocalInput!) {
  approveSubmittedDataRoomRequest(input: $input) @client {
    signature
    status
  }
}
    `;
function dr(e) {
  const t = { ...n, ...e };
  return o.useMutation(Tn, t);
}
const wn = i`
    mutation ArchiveOrganization($organizationId: String!) {
  organization {
    archive(id: $organizationId) {
      record {
        ... on Organization {
          ...Organization
        }
      }
    }
  }
}
    ${$n}`;
function cr(e) {
  const t = { ...n, ...e };
  return o.useMutation(wn, t);
}
const I = i`
    query AudienceInsights($input: MediaCalculateOverlapInsightsInput!) {
  mediaCalculateOverlapInsights(input: $input) @client {
    insightsCsv
  }
}
    `;
function pr(e) {
  const t = { ...n, ...e };
  return o.useQuery(I, t);
}
function mr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(I, t);
}
function lr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(I, t);
}
const v = i`
    query AudienceInsightsAdvertiser($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    enclaveId: id
    driverAttestationHash
    advertiserDatasetHash @client
    publisherDatasetHash @client
  }
}
    `;
function yr(e) {
  const t = { ...n, ...e };
  return o.useQuery(v, t);
}
function Dr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(v, t);
}
function hr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(v, t);
}
const $ = i`
    query AudienceInsightsAdvertiserStatistics($input: MediaCalculateStatisticsInput!) {
  mediaCalculateStatistics(input: $input) @client {
    advertiserSize
    advertiserNumberOfAudiences
  }
}
    `;
function fr(e) {
  const t = { ...n, ...e };
  return o.useQuery($, t);
}
function Sr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery($, t);
}
function br(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery($, t);
}
const C = i`
    query AudienceInsightsPublisher($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    enclaveId: id
    driverAttestationHash
    publisherDatasetHash @client
    advertiserDatasetHash @client
  }
}
    `;
function gr(e) {
  const t = { ...n, ...e };
  return o.useQuery(C, t);
}
function Nr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(C, t);
}
function Rr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(C, t);
}
const A = i`
    query AudienceInsightsPublisherStatistics($input: MediaCalculateStatisticsInput!) {
  mediaCalculateStatistics(input: $input) @client {
    publisherNumberOfSegments
  }
}
    `;
function Qr(e) {
  const t = { ...n, ...e };
  return o.useQuery(A, t);
}
function Pr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(A, t);
}
function Ir(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(A, t);
}
const M = i`
    query AudienceInsightsStatistics($dataRoomId: String!, $driverAttestationHash: String!) {
  mediaCalculateStatistics(
    input: {dataRoomId: $dataRoomId, driverAttestationHash: $driverAttestationHash}
  ) @client {
    advertiserSize
  }
  mediaCalculateOverlapByAudience(
    input: {dataRoomId: $dataRoomId, driverAttestationHash: $driverAttestationHash}
  ) @client {
    overlapCsv
  }
}
    `;
function vr(e) {
  const t = { ...n, ...e };
  return o.useQuery(M, t);
}
function $r(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(M, t);
}
function Cr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(M, t);
}
const L = i`
    query AudienceTypes($input: MediaRetrieveAudienceTypesInput!) {
  mediaRetrieveAudienceTypes(input: $input) @client {
    audienceTypes
  }
}
    `;
function Ar(e) {
  const t = { ...n, ...e };
  return o.useQuery(L, t);
}
function Mr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(L, t);
}
function Lr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(L, t);
}
const z = i`
    query AuditLogs($dcrHash: HexString!, $driverAttestationHash: HexString!) {
  auditLog(dcrHash: $dcrHash, driverAttestationHash: $driverAttestationHash) @client {
    log
  }
}
    `;
function zr(e) {
  const t = { ...n, ...e };
  return o.useQuery(z, t);
}
function Hr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(z, t);
}
function qr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(z, t);
}
const H = i`
    query AvailableDataPartners {
  availableDataPartners {
    nodes {
      ...AvailableDataPartner
    }
    totalCount
  }
}
    ${Qn}`;
function Tr(e) {
  const t = { ...n, ...e };
  return o.useQuery(H, t);
}
function wr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(H, t);
}
function kr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(H, t);
}
const q = i`
    query AvailablePublishers {
  availablePublishers {
    nodes {
      ...AvailablePublisher
    }
    totalCount
  }
}
    ${Pn}`;
function Fr(e) {
  const t = { ...n, ...e };
  return o.useQuery(q, t);
}
function Ur(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(q, t);
}
function Or(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(q, t);
}
const T = i`
    query CollaboratingOrganizations($organizationId: String!, $filter: CollaboratingOrganizationFilter) {
  organization(id: $organizationId) {
    id
    collaboratingOrganizations(filter: $filter) {
      nodes {
        numberOfCommonDataRooms
        organization {
          id
          name
        }
      }
    }
  }
}
    `;
function Er(e) {
  const t = { ...n, ...e };
  return o.useQuery(T, t);
}
function Jr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(T, t);
}
function xr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(T, t);
}
const w = i`
    query CommittedComputeNodeActions($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    name
    permissions {
      ... on PublishedAnalystPermission {
        participant {
          userEmail
        }
      }
    }
    ... on PublishedSqlNode {
      computationType
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedSqliteNode {
      computationType
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedMatchNode {
      computationType
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedPostNode {
      computationType
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedPreviewNode {
      computationType
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedScriptingNode {
      computationType
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedSyntheticNode {
      computationType
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedS3SinkNode {
      computationType
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
  }
}
    `;
function Br(e) {
  const t = { ...n, ...e };
  return o.useQuery(w, t);
}
function _r(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(w, t);
}
function jr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(w, t);
}
const kn = i`
    mutation CompleteComputeJobFailure($id: String!) {
  computeJob {
    failed(id: $id) {
      record {
        __typename
        id
        enclaveComputeJobId
        status
        updatedAt
        createdAt
      }
    }
  }
}
    `;
function Wr(e) {
  const t = { ...n, ...e };
  return o.useMutation(kn, t);
}
const Fn = i`
    mutation CompleteComputeJobSuccess($id: String!) {
  computeJob {
    succeded(id: $id) {
      record {
        __typename
        id
        enclaveComputeJobId
        status
        updatedAt
        createdAt
      }
    }
  }
}
    `;
function Gr(e) {
  const t = { ...n, ...e };
  return o.useMutation(Fn, t);
}
const k = i`
    query CompleteDataRoomRequest($id: String!) {
  dataRoomRequest(id: $id) {
    id
    participants {
      nodes {
        id
        userEmail
        permissions {
          nodes {
            ... on DraftAnalystPermission {
              node {
                id
              }
            }
            ... on DraftDataOwnerPermission {
              node {
                id
              }
            }
          }
        }
      }
    }
    draftNode {
      __typename
      id
      createdAt
      updatedAt
      permissions {
        nodes {
          ... on DraftAnalystPermission {
            participant {
              id
              userEmail
            }
          }
        }
      }
      ... on DraftMatchNode {
        name
        config
        computationType
        dependencies {
          nodes {
            ... on PublishedNodeConnection {
              computeNodeId
              publishedDataRoomId
            }
          }
        }
      }
      ... on DraftSqlNode {
        name
        statement
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
      }
      ... on DraftSqliteNode {
        name
        statement
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
      }
      ... on DraftSyntheticNode {
        name
        accuracy
        includeReportWithStats
        dependency {
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
      ... on DraftPostNode {
        name
        computationType
        dependency {
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
      ... on DraftPreviewNode {
        name
        quotaBytes
        computationType
        dependency {
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
      ... on DraftScriptingNode {
        name
        computationType
        scripts {
          nodes {
            id
            name
            content
            isMainScript
          }
        }
        dependencies {
          nodes {
            ... on PublishedNodeConnection {
              computeNodeId
              publishedDataRoomId
            }
          }
        }
        output
        scriptingLanguage
      }
      ... on DraftSyntheticNode {
        name
        accuracy
        computationType
        includeReportWithStats
        columns {
          nodes {
            id
            index
            name
            maskType
            dataType
            shouldMaskColumn
          }
        }
        dependency {
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
    }
  }
}
    `;
function Vr(e) {
  const t = { ...n, ...e };
  return o.useQuery(k, t);
}
function Zr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(k, t);
}
function Kr(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(k, t);
}
const F = i`
    query CompleteDraftDataRoom($id: String!) {
  draftDataRoom(id: $id) {
    id
    title
    description
    enableDevelopment
    enableInteractivity
    showOrganizationLogo
    owner {
      id
      email
    }
    participants {
      nodes {
        id
        userEmail
        permissions {
          nodes {
            ... on DraftAnalystPermission {
              node {
                id
              }
            }
            ... on DraftDataOwnerPermission {
              node {
                id
              }
            }
          }
        }
      }
    }
    draftNodes {
      nodes {
        __typename
        id
        name
        createdAt
        updatedAt
        ... on DraftScriptingNode {
          output
          scriptingLanguage
          computationType
          scripts {
            nodes {
              name
              content
              isMainScript
            }
          }
          dependencies {
            nodes {
              ...DraftNodeConnectionId
            }
          }
        }
        ... on DraftMatchNode {
          config
          computationType
          dependencies {
            nodes {
              ...DraftNodeConnectionId
            }
          }
        }
        ... on DraftSqlNode {
          statement
          computationType
          privacyFilter {
            minimumRows
            isEnabled
          }
          dependencies {
            nodes {
              ...DraftNodeConnectionId
            }
          }
        }
        ... on DraftSqliteNode {
          statement
          computationType
          privacyFilter {
            minimumRows
            isEnabled
          }
          dependencies {
            nodes {
              ...DraftNodeConnectionId
            }
          }
        }
        ... on DraftSyntheticNode {
          accuracy
          computationType
          includeReportWithStats
          columns {
            nodes {
              index
              name
              maskType
              dataType
              shouldMaskColumn
            }
          }
          dependency {
            ...DraftNodeConnectionId
          }
        }
        ... on DraftPostNode {
          computationType
          dependency {
            ...DraftNodeConnectionId
          }
        }
        ... on DraftPreviewNode {
          computationType
          quotaBytes
          dependency {
            ...DraftNodeConnectionId
          }
        }
        ... on DraftS3SinkNode {
          computationType
          endpoint
          region
          credentialsDependency {
            ...DraftNodeConnectionId
          }
          uploadDependency {
            ...DraftNodeConnectionId
          }
        }
        ... on DraftRawLeafNode {
          isRequired
        }
        ... on DraftTableLeafNode {
          isRequired
          uniqueColumnIds
          columnsOrder
          minRows
          maxRows
          allowEmpty
          columns {
            nodes {
              id
              name
              dataType
              formatType
              isNullable
              hashWith
            }
          }
        }
      }
    }
    computeNodesOrder
    dataNodesOrder
  }
}
    ${In}`;
function Xr(e) {
  const t = { ...n, ...e };
  return o.useQuery(F, t);
}
function Yr(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(F, t);
}
function ed(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(F, t);
}
const U = i`
    query CompleteMediaDataRoom($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    name @client
    activationType @client
    publisherUserEmails @client
    enableAuditLogRetrieval @client
    advertiserUserEmails @client
    observerUserEmails @client
    agencyUserEmails @client
    advertiserDatasetHash @client
    publisherDatasetHash @client
    activationDownloadByAdvertiser @client
    activationDownloadByPublisher @client
    isStopped
    deactivatedAt
  }
}
    `;
function td(e) {
  const t = { ...n, ...e };
  return o.useQuery(U, t);
}
function od(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(U, t);
}
function nd(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(U, t);
}
const O = i`
    query CompletePlayground($id: String!) {
  playground(id: $id) {
    id
    draftNode {
      __typename
      id
      createdAt
      updatedAt
      ... on DraftMatchNode {
        name
        config
        computationType
        dependencies {
          nodes {
            ... on PublishedNodeConnection {
              computeNodeId
              publishedDataRoomId
            }
          }
        }
      }
      ... on DraftSqlNode {
        name
        statement
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
      }
      ... on DraftSqliteNode {
        name
        statement
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
      }
      ... on DraftSyntheticNode {
        name
        accuracy
        includeReportWithStats
        dependency {
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
      ... on DraftPostNode {
        name
        computationType
        dependency {
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
      ... on DraftPreviewNode {
        name
        quotaBytes
        computationType
        dependency {
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
      ... on DraftScriptingNode {
        name
        computationType
        scripts {
          nodes {
            id
            name
            content
            isMainScript
          }
        }
        dependencies {
          nodes {
            ... on PublishedNodeConnection {
              computeNodeId
              publishedDataRoomId
            }
          }
        }
        output
        scriptingLanguage
      }
      ... on DraftSyntheticNode {
        name
        accuracy
        computationType
        includeReportWithStats
        columns {
          nodes {
            id
            index
            name
            maskType
            dataType
            shouldMaskColumn
          }
        }
        dependency {
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
    }
  }
}
    `;
function id(e) {
  const t = { ...n, ...e };
  return o.useQuery(O, t);
}
function ad(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(O, t);
}
function sd(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(O, t);
}
const E = i`
    query CompletePublishedDataRoom($id: String!) {
  publishedDataRoom(id: $id) {
    id
    name: title
    description @client
    owner {
      __typename
      email
    }
    driverAttestationHash
    enableInteractivity @client
    enableDevelopment @client
    isStopped
    deactivatedAt
    isOwner @client
    publishedNodes @client {
      __typename
      id
      dataRoomId
      name
      dcrHash
      driverAttestationHash
      commitId
      permissions {
        ... on PublishedAnalystPermission {
          participant {
            userEmail
          }
        }
        ... on PublishedDataOwnerPermission {
          participant {
            userEmail
          }
        }
      }
      ... on PublishedScriptingNode {
        computationType
        output
        scriptingLanguage
        usesCustomPythonEnv
        scripts {
          name
          content
          isMainScript
        }
        dependencies {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedSqlNode {
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
        dependencies {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
        }
        statement
      }
      ... on PublishedSqliteNode {
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
        dependencies {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
        }
        statement
      }
      ... on PublishedMatchNode {
        computationType
        dependencies {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
        }
        config
      }
      ... on PublishedSyntheticNode {
        computationType
        accuracy
        includeReportWithStats
        columns {
          name
          shouldMaskColumn
          index
          maskType
          dataType
        }
        dependency {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedPostNode {
        computationType
        dependency {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedPreviewNode {
        computationType
        usedQuotaBytes
        remainingQuotaBytes
        totalQuotaBytes
        dependency {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedS3SinkNode {
        endpoint
        computationType
        region
        credentialsDependency {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
        }
        uploadDependency {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedPreviewNode {
        computationType
        usedQuotaBytes
        remainingQuotaBytes
        totalQuotaBytes
        dependency {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedRawLeafNode {
        isRequired
        dataset {
          datasetHash
          leafId
          timestamp
          user
        }
        testDataset {
          datasetHash
          leafId
          timestamp
          user
        }
      }
      ... on PublishedTableLeafNode {
        isRequired
        allowEmpty
        minRows
        maxRows
        uniqueColumnIds
        columns {
          name
          dataType
          isNullable
          formatType
          hashWith
        }
        dataset {
          datasetHash
          leafId
          timestamp
          user
        }
        testDataset {
          datasetHash
          leafId
          timestamp
          user
        }
      }
    }
    participants @client {
      userEmail
      permissions {
        ... on PublishedAnalystPermission {
          node {
            __typename
            id
            dcrHash
            driverAttestationHash
            commitId
          }
        }
        ... on PublishedDataOwnerPermission {
          node {
            __typename
            id
            dcrHash
            driverAttestationHash
            commitId
          }
        }
      }
    }
    source @client
    enableAutomergeFeature @client
    enableServersideWasmValidation @client
    enableTestDatasets @client
    enableSqliteWorker @client
    enablePostWorker @client
    enableAirlock @client
  }
}
    `;
function ud(e) {
  const t = { ...n, ...e };
  return o.useQuery(E, t);
}
function rd(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(E, t);
}
function dd(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(E, t);
}
const J = i`
    query CompleteSubmittedDataRoomRequest($id: String!) {
  submittedDataRoomRequest(id: $id) {
    id
    node @client {
      __typename
      id
      dataRoomId
      name
      dcrHash
      driverAttestationHash
      commitId
      permissions {
        ... on PublishedAnalystPermission {
          participant {
            userEmail
          }
        }
        ... on PublishedDataOwnerPermission {
          participant {
            userEmail
          }
        }
      }
      ... on PublishedScriptingNode {
        computationType
        output
        scriptingLanguage
        usesCustomPythonEnv
        scripts {
          name
          content
          isMainScript
        }
        dependencies {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedSqlNode {
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
        dependencies {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
        statement
      }
      ... on PublishedSqliteNode {
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
        dependencies {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
        statement
      }
      ... on PublishedMatchNode {
        computationType
        dependencies {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
        config
      }
      ... on PublishedSyntheticNode {
        computationType
        accuracy
        includeReportWithStats
        columns {
          name
          shouldMaskColumn
          index
          maskType
          dataType
        }
        dependency {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedPostNode {
        computationType
        dependency {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedPreviewNode {
        computationType
        dependency {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedS3SinkNode {
        endpoint
        computationType
        region
        credentialsDependency {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
        uploadDependency {
          __typename
          id
          dcrHash
          driverAttestationHash
          commitId
        }
      }
      ... on PublishedRawLeafNode {
        isRequired
      }
      ... on PublishedTableLeafNode {
        isRequired
        columns {
          name
          dataType
          isNullable
          formatType
          hashWith
        }
      }
    }
  }
}
    `;
function cd(e) {
  const t = { ...n, ...e };
  return o.useQuery(J, t);
}
function pd(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(J, t);
}
function md(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(J, t);
}
const Un = i`
    mutation ComputeNodeRun($dcrHash: HexString!, $driverAttestationHash: HexString!, $computeNodeId: String!, $dataRoomId: String!, $autoFetching: Boolean, $testDatasets: [TestDataset!]) {
  runComputation(
    input: {dcrHash: $dcrHash, driverAttestationHash: $driverAttestationHash, computeNodeId: $computeNodeId, dataRoomId: $dataRoomId, autoFetching: $autoFetching, testDatasets: $testDatasets}
  ) @client {
    id
    enclaveComputeJobId
    status
    updatedAt
    createdAt
    autoFetching @client
  }
}
    `;
function ld(e) {
  const t = { ...n, ...e };
  return o.useMutation(Un, t);
}
const x = i`
    query ConsentlessActivatedAudiences($input: MediaRetrieveConsentlessActivatedAudiencesInput!, $id: String!) {
  mediaRetrieveConsentlessActivatedAudiences(input: $input) @client {
    nodes {
      id
      name
      size
      downloaded
      owner
    }
  }
  publishedMediaDataRoom(id: $id) {
    id
    activationDownloadByPublisher @client
  }
}
    `;
function yd(e) {
  const t = { ...n, ...e };
  return o.useQuery(x, t);
}
function Dd(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(x, t);
}
function hd(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(x, t);
}
const On = i`
    mutation CreateAccessToken($input: CreateApiTokenInput!) {
  apiToken {
    create(input: $input) {
      id
      token
      name
      createdAt
      revoked
    }
  }
}
    `;
function fd(e) {
  const t = { ...n, ...e };
  return o.useMutation(On, t);
}
const En = i`
    mutation CreateActivationConfiguration($input: CreateActivationConfigurationInput!) {
  activationConfiguration {
    create(input: $input) {
      record {
        ...FullActivationConfiguration
      }
    }
  }
}
    ${Rn}`;
function Sd(e) {
  const t = { ...n, ...e };
  return o.useMutation(En, t);
}
const Jn = i`
    mutation CreateComputeJob($input: CreateComputeJobInput!) {
  computeJob {
    create(input: $input) {
      record {
        id
        enclaveComputeJobId
        enclaveComputeJobHandleBase64
        status
        createdAt
        updatedAt
        dataRoomHash
        driverAttestationHash
        purpose
      }
    }
  }
}
    `;
function bd(e) {
  const t = { ...n, ...e };
  return o.useMutation(Jn, t);
}
const xn = i`
    mutation CreateDataConnectorJob($input: CreateDataConnectorJobInput!) {
  dataConnectorJob {
    create(input: $input) {
      record {
        ...DataConnectorJob
      }
    }
  }
}
    ${d}`;
function gd(e) {
  const t = { ...n, ...e };
  return o.useMutation(xn, t);
}
const Bn = i`
    mutation CreateDataLab($input: CreateDataLabInput!) {
  dataLab {
    create(input: $input) {
      record {
        ...FullDataLab
      }
    }
  }
}
    ${a}`;
function Nd(e) {
  const t = { ...n, ...e };
  return o.useMutation(Bn, t);
}
const _n = i`
    mutation CreateDataPartnerDisplayConfiguration($input: CreateDataPartnerDisplayConfigurationInput!) {
  dataPartnerDisplayConfiguration {
    create(input: $input) {
      record {
        ...DataPartnerDisplayConfiguration
      }
    }
  }
}
    ${y}`;
function Rd(e) {
  const t = { ...n, ...e };
  return o.useMutation(_n, t);
}
const jn = i`
    mutation CreateDataPartnerUsageConfiguration($input: CreateDataPartnerUsageConfigurationInput!) {
  dataPartnerUsageConfiguration {
    create(input: $input) {
      record {
        ...DataPartnerUsageConfiguration
      }
    }
  }
}
    ${Nn}`;
function Qd(e) {
  const t = { ...n, ...e };
  return o.useMutation(jn, t);
}
const Wn = i`
    mutation CreateDataRoomPlayground($input: CreateDataRoomPlaygroundInput!) {
  playground {
    create(input: $input) {
      id
    }
  }
}
    `;
function Pd(e) {
  const t = { ...n, ...e };
  return o.useMutation(Wn, t);
}
const Gn = i`
    mutation CreateDataRoomRequest($input: CreateDataRoomRequestInput!) {
  dataRoomRequest {
    create(input: $input) {
      id
    }
  }
}
    `;
function Id(e) {
  const t = { ...n, ...e };
  return o.useMutation(Gn, t);
}
const Vn = i`
    mutation CreateDatasetExport($input: ExportDatasetInput!) {
  createDatasetExport(input: $input) @client {
    dataConnectorJob {
      ...DataConnectorJob
    }
  }
}
    ${d}`;
function vd(e) {
  const t = { ...n, ...e };
  return o.useMutation(Vn, t);
}
const Zn = i`
    mutation CreateDatasetImport($input: ImportDatasetInput!) {
  createDatasetImport(input: $input) @client {
    dataConnectorJob {
      ...DataConnectorJob
    }
  }
}
    ${d}`;
function $d(e) {
  const t = { ...n, ...e };
  return o.useMutation(Zn, t);
}
const Kn = i`
    mutation CreateDemoUser($input: CreateDemoUserInput!) {
  organization {
    createDemoUser(input: $input) {
      record {
        id
        email
        logo
        userRole
        createdAt
        isDemoUser
      }
    }
  }
}
    `;
function Cd(e) {
  const t = { ...n, ...e };
  return o.useMutation(Kn, t);
}
const Xn = i`
    mutation CreateDraftDataRoom($input: CreateDraftDataRoomInput!) {
  draftDataRoom {
    create(input: $input) {
      record {
        id
        title
        description
        owner {
          id
          email
        }
        logo
        enableInteractivity
        enableDevelopment
        userSettings {
          id
          isArchived
          isFavorite
        }
        createdAt
        draftNodes {
          nodes {
            id
            name
          }
        }
        editors {
          nodes {
            user {
              id
              email
            }
            role
          }
        }
        dataNodesOrder
        computeNodesOrder
        participants {
          nodes {
            id
            userEmail
            permissions {
              nodes {
                ... on DraftDataOwnerPermission {
                  node {
                    id
                    name
                  }
                }
                ... on DraftAnalystPermission {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
        query {
          dataRooms(
            filter: {isArchived: {equalTo: false}, isFavorite: {equalTo: false}, isOwnedByUser: {equalTo: true}}
            sortBy: {updatedAt: DESCENDING}
          ) {
            nodes {
              ... on DraftDataRoom {
                ...NavigationDrawerDraftDataRoom
              }
              ... on PublishedDataRoom {
                ...NavigationDrawerPublishedDataRoom
              }
              ... on PublishedMediaDataRoom {
                ...NavigationDrawerPublishedMediaDataRoom
              }
              ... on PublishedLookalikeMediaDataRoom {
                ...NavigationDrawerPublishedLookalikeMediaDataRoom
              }
              ... on PublishedMediaInsightsDcr {
                ...NavigationDrawerPublishedMediaInsightsDcr
              }
            }
          }
        }
      }
    }
  }
}
    ${s}
${u}
${r}
${p}
${m}`;
function Ad(e) {
  const t = { ...n, ...e };
  return o.useMutation(Xn, t);
}
const Yn = i`
    mutation CreateDraftDataRoomIsFavorite($draftDataRoomId: String!, $isFavorite: Boolean!) {
  draftDataRoom {
    createUserSettings(
      input: {draftDataRoomId: $draftDataRoomId, isFavorite: $isFavorite, isArchived: false}
    ) {
      id
      isFavorite
      query {
        draftDataRoom(id: $draftDataRoomId) {
          id
          userSettings {
            id
          }
        }
      }
    }
  }
}
    `;
function Md(e) {
  const t = { ...n, ...e };
  return o.useMutation(Yn, t);
}
const ei = i`
    mutation CreateDraftDataRoomIsHidden($draftDataRoomId: String!, $isHidden: Boolean!) {
  draftDataRoom {
    createUserSettings(
      input: {draftDataRoomId: $draftDataRoomId, isArchived: $isHidden, isFavorite: false}
    ) {
      id
      isArchived
      isFavorite
      query {
        draftDataRoom(id: $draftDataRoomId) {
          id
          userSettings {
            id
          }
        }
      }
    }
  }
}
    `;
function Ld(e) {
  const t = { ...n, ...e };
  return o.useMutation(ei, t);
}
const ti = i`
    mutation CreateDraftRawLeafNode($input: CreateDraftRawLeafNodeInput!) {
  dataNode: draftRawLeafNode {
    create(input: $input) {
      id
      name
      isRequired
    }
  }
}
    `;
function zd(e) {
  const t = { ...n, ...e };
  return o.useMutation(ti, t);
}
const oi = i`
    mutation CreateDraftTableLeafNode($input: CreateDraftTableLeafNodeInput!) {
  dataNode: draftTableLeafNode {
    create(input: $input) {
      id
      name
      isRequired
      columns {
        nodes {
          id
          name
          dataType
          isNullable
        }
      }
    }
  }
}
    `;
function Hd(e) {
  const t = { ...n, ...e };
  return o.useMutation(oi, t);
}
const ni = i`
    mutation CreateDraftTableLeafNodeColumn($id: String!, $input: CreateDraftTableLeafNodeColumnInput!) {
  draftTableLeafNode {
    addColumn(id: $id, input: $input) {
      id
      name
      isNullable
      dataType
      formatType
    }
  }
}
    `;
function qd(e) {
  const t = { ...n, ...e };
  return o.useMutation(ni, t);
}
const ii = i`
    mutation CreateLookalikeMediaComputeJob($input: CreateMediaComputeJobInput!) {
  mediaComputeJob {
    create(input: $input) {
      record {
        ...LookalikeMediaComputeJobComplete
      }
    }
  }
}
    ${D}`;
function Td(e) {
  const t = { ...n, ...e };
  return o.useMutation(ii, t);
}
const ai = i`
    mutation CreateMediaInsightsComputeJob($input: CreateMediaComputeJobInput!) {
  mediaComputeJob {
    create(input: $input) {
      record {
        ...MediaInsightsComputeJobComplete
      }
    }
  }
}
    ${vn}`;
function wd(e) {
  const t = { ...n, ...e };
  return o.useMutation(ai, t);
}
const si = i`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  organization {
    create(input: $input) {
      id
      createdAt
      createdBy {
        id
        email
      }
      updatedAt
      name
      logo
      workerTypes {
        nodes {
          id
          name
          shortName
        }
      }
      state
      hasAdvertiserFeatures
      hasAnalyticsFeatures
      hasPublisherFeatures
      hasDataPartnerFeatures
      canViewDataPartners
      domains
      users {
        nodes {
          id
          email
          userRole
          isDemoUser
          createdAt
        }
        totalCount
      }
      participatingDataRooms {
        totalCount
      }
    }
  }
}
    `;
function kd(e) {
  const t = { ...n, ...e };
  return o.useMutation(si, t);
}
const ui = i`
    mutation CreateOrganizationUser($input: CreateInternalUserInput!) {
  organization {
    createInternalUser(input: $input) {
      record {
        id
        email
        logo
        userRole
        createdAt
        isDemoUser
      }
    }
  }
}
    `;
function Fd(e) {
  const t = { ...n, ...e };
  return o.useMutation(ui, t);
}
const ri = i`
    mutation CreatePublishedDataRoomIsFavorite($publishedDataRoomId: String!, $isFavorite: Boolean!) {
  publishedDataRoom {
    createUserSettings(
      input: {publishedDataRoomId: $publishedDataRoomId, isFavorite: $isFavorite, isArchived: false}
    ) {
      id
      isFavorite
      isArchived
    }
  }
}
    `;
function Ud(e) {
  const t = { ...n, ...e };
  return o.useMutation(ri, t);
}
const di = i`
    mutation CreatePublishedDataRoomIsHidden($publishedDataRoomId: String!, $isHidden: Boolean!) {
  publishedDataRoom {
    createUserSettings(
      input: {publishedDataRoomId: $publishedDataRoomId, isArchived: $isHidden, isFavorite: false}
    ) {
      id
      isArchived
      isFavorite
    }
  }
}
    `;
function Od(e) {
  const t = { ...n, ...e };
  return o.useMutation(di, t);
}
const ci = i`
    mutation CreateSubmittedDataRoomRequest($input: SubmitDataRoomRequestInput!) {
  dataRoomRequest {
    submitForApproval(input: $input) {
      id
      signers {
        nodes {
          id
          signature
          userEmail
          user {
            id
            email
          }
        }
      }
      publishedDataRoom {
        id
      }
    }
  }
}
    `;
function Ed(e) {
  const t = { ...n, ...e };
  return o.useMutation(ci, t);
}
const pi = i`
    mutation CreatePublisherDisplayConfiguration($input: CreatePublisherDisplayConfigurationInput!) {
  publisherDisplayConfiguration {
    create(input: $input) {
      record {
        id
        publisherName
        description
        logo
        collaborationRequestUsers
      }
    }
  }
}
    `;
function Jd(e) {
  const t = { ...n, ...e };
  return o.useMutation(pi, t);
}
const mi = i`
    mutation CreateRequestFromPlayground($playgroundId: String!) {
  dataRoomRequest {
    createFromPlayground(playgroundId: $playgroundId) {
      id
      draftNode {
        id
        name
        ... on DraftSyntheticNode {
          computationType
        }
        ... on DraftPostNode {
          computationType
        }
        ... on DraftPreviewNode {
          computationType
        }
        ... on DraftS3SinkNode {
          computationType
        }
        ... on DraftScriptingNode {
          computationType
        }
        ... on DraftSqlNode {
          computationType
        }
        ... on DraftSqliteNode {
          computationType
        }
        ... on DraftMatchNode {
          computationType
        }
      }
    }
  }
}
    `;
function xd(e) {
  const t = { ...n, ...e };
  return o.useMutation(mi, t);
}
const li = i`
    mutation CreateStaticScript($input: CreateDraftScriptInput!) {
  draftScriptingNode {
    createScript(input: $input) {
      record {
        id
        name
        content
        isMainScript
      }
    }
  }
}
    `;
function Bd(e) {
  const t = { ...n, ...e };
  return o.useMutation(li, t);
}
const B = i`
    query CurrentUserDomain {
  myself {
    id
    organizationLogo
    organization {
      name
    }
  }
}
    `;
function _d(e) {
  const t = { ...n, ...e };
  return o.useQuery(B, t);
}
function jd(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(B, t);
}
function Wd(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(B, t);
}
const yi = i`
    mutation DeleteDraftRawLeafNode($id: String!) {
  dataNode: draftRawLeafNode {
    delete(id: $id)
  }
}
    `;
function Gd(e) {
  const t = { ...n, ...e };
  return o.useMutation(yi, t);
}
const _ = i`
    query DataConnectorJob($id: String!) {
  dataConnectorJob(id: $id) {
    ...DataConnectorJob
  }
}
    ${d}`;
function Vd(e) {
  const t = { ...n, ...e };
  return o.useQuery(_, t);
}
function Zd(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(_, t);
}
function Kd(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(_, t);
}
const j = i`
    query DataConnectorJobResult($id: String!) {
  dataConnectorJob(id: $id) {
    ...DataConnectorJobResult
  }
}
    ${l}`;
function Xd(e) {
  const t = { ...n, ...e };
  return o.useQuery(j, t);
}
function Yd(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(j, t);
}
function ec(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(j, t);
}
const W = i`
    query DataConnectorJobSecret($id: String!) {
  dataConnectorJob(id: $id) {
    id
    secretId
  }
}
    `;
function tc(e) {
  const t = { ...n, ...e };
  return o.useQuery(W, t);
}
function oc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(W, t);
}
function nc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(W, t);
}
const Di = i`
    mutation DataConnectorJobSetToFailure($id: String!) {
  dataConnectorJob {
    setJobToFailed(id: $id) {
      record {
        ...DataConnectorJobResult
      }
    }
  }
}
    ${l}`;
function ic(e) {
  const t = { ...n, ...e };
  return o.useMutation(Di, t);
}
const hi = i`
    mutation DataConnectorJobSetToSuccess($id: String!) {
  dataConnectorJob {
    setJobToSuccess(id: $id) {
      record {
        ...DataConnectorJobResult
      }
    }
  }
}
    ${l}`;
function ac(e) {
  const t = { ...n, ...e };
  return o.useMutation(hi, t);
}
const G = i`
    query DataConnectorJobs($filter: DataConnectorJobFilter) {
  dataConnectorJobs(filter: $filter) {
    nodes {
      ...DataConnectorJob
    }
  }
}
    ${d}`;
function sc(e) {
  const t = { ...n, ...e };
  return o.useQuery(G, t);
}
function uc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(G, t);
}
function rc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(G, t);
}
const V = i`
    query DataConnectorJobsSecrets($filter: DataConnectorJobFilter) {
  dataConnectorJobs(filter: $filter) {
    nodes {
      id
      secretId
    }
  }
}
    `;
function dc(e) {
  const t = { ...n, ...e };
  return o.useQuery(V, t);
}
function cc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(V, t);
}
function pc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(V, t);
}
const Z = i`
    query DataLab($id: String!) {
  dataLab(id: $id) {
    ...FullDataLab
  }
}
    ${a}`;
function mc(e) {
  const t = { ...n, ...e };
  return o.useQuery(Z, t);
}
function lc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Z, t);
}
function yc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Z, t);
}
const K = i`
    query DataLabs {
  dataLabs {
    nodes {
      ...FullDataLab
    }
  }
}
    ${a}`;
function Dc(e) {
  const t = { ...n, ...e };
  return o.useQuery(K, t);
}
function hc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(K, t);
}
function fc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(K, t);
}
const X = i`
    query DataPartnerDisplayConfiguration($id: String!, $isAdmin: Boolean!) {
  ownOrganization: myself @skip(if: $isAdmin) {
    organization {
      dataPartnerDisplayConfiguration {
        ...DataPartnerDisplayConfiguration
      }
    }
  }
  otherOrganization: organization(id: $id) @include(if: $isAdmin) {
    dataPartnerDisplayConfiguration {
      ...DataPartnerDisplayConfiguration
    }
  }
}
    ${y}`;
function Sc(e) {
  const t = { ...n, ...e };
  return o.useQuery(X, t);
}
function bc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(X, t);
}
function gc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(X, t);
}
const Y = i`
    query DataPartnerUsageConfigurations($id: String!, $isAdmin: Boolean!) {
  ownOrganization: myself @skip(if: $isAdmin) {
    organization {
      dataPartnerUsageConfigurations {
        nodes {
          ...DataPartnerUsageConfiguration
        }
        totalCount
      }
    }
  }
  otherOrganization: organization(id: $id) @include(if: $isAdmin) {
    dataPartnerUsageConfigurations {
      nodes {
        ...DataPartnerUsageConfiguration
      }
      totalCount
    }
  }
}
    ${Nn}`;
function Nc(e) {
  const t = { ...n, ...e };
  return o.useQuery(Y, t);
}
function Rc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Y, t);
}
function Qc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Y, t);
}
const ee = i`
    query DataRoomAttestationSpecs($dcrHash: HexString!, $driverAttestationHash: HexString!) {
  dataRoomAttestationSpecs(
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
  ) @client {
    id
    name
    hash
    isInsecure
    isUnavailable
  }
}
    `;
function Pc(e) {
  const t = { ...n, ...e };
  return o.useQuery(ee, t);
}
function Ic(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ee, t);
}
function vc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ee, t);
}
const te = i`
    query DataRoomRequestComputeNodeTypename($requestId: String!) {
  dataRoomRequest(id: $requestId) {
    id
    draftNode {
      id
    }
  }
}
    `;
function $c(e) {
  const t = { ...n, ...e };
  return o.useQuery(te, t);
}
function Cc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(te, t);
}
function Ac(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(te, t);
}
const oe = i`
    query DataRoomRequestTempApprovers($id: String!) {
  dataRoomRequest(id: $id) {
    id
    tempApprovers @client
  }
}
    `;
function Mc(e) {
  const t = { ...n, ...e };
  return o.useQuery(oe, t);
}
function Lc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(oe, t);
}
function zc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(oe, t);
}
const ne = i`
    query DataRoomsList {
  dataRooms {
    nodes {
      ... on DraftDataRoom {
        ...NavigationDrawerDraftDataRoom
      }
      ... on PublishedDataRoom {
        ...NavigationDrawerPublishedDataRoom
      }
      ... on PublishedMediaDataRoom {
        ...NavigationDrawerPublishedMediaDataRoom
      }
      ... on PublishedLookalikeMediaDataRoom {
        ...NavigationDrawerPublishedLookalikeMediaDataRoom
      }
      ... on PublishedMediaInsightsDcr {
        ...NavigationDrawerPublishedMediaInsightsDcr
      }
      createdAt
      updatedAt
      owner {
        id
        email
        organization {
          id
          name
        }
      }
      userSettings {
        ...DataRoomUserSettings
      }
    }
  }
}
    ${s}
${u}
${r}
${p}
${m}
${c}`;
function Hc(e) {
  const t = { ...n, ...e };
  return o.useQuery(ne, t);
}
function qc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ne, t);
}
function Tc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ne, t);
}
const ie = i`
    query DatasetByHash($manifestHash: HexString!) {
  datasetByManifestHash(manifestHash: $manifestHash) {
    id
    name
    isUploader @client
    owner {
      id
      email
    }
    datasetImport {
      config
    }
    createdAt
    statistics
    manifestHash
    description
    size
    sourceType
    publications {
      nodes {
        dataRoom {
          ... on PublishedDataRoom {
            driverAttestationHash
          }
          ... on PublishedMediaDataRoom {
            driverAttestationHash
          }
          ... on PublishedLookalikeMediaDataRoom {
            driverAttestationHash
          }
          ... on PublishedMediaInsightsDcr {
            driverAttestationHash
          }
          id
          title
        }
        leaf
        publisher {
          id
          email
        }
      }
    }
  }
}
    `;
function wc(e) {
  const t = { ...n, ...e };
  return o.useQuery(ie, t);
}
function kc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ie, t);
}
function Fc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ie, t);
}
const ae = i`
    query DatasetPublicationsByHash($manifestHash: HexString!) {
  datasetByManifestHash(manifestHash: $manifestHash) {
    id
    manifestHash
    publications {
      nodes {
        dataRoom {
          id
          ... on PublishedDataRoom {
            driverAttestationHash
          }
          ... on PublishedMediaDataRoom {
            driverAttestationHash
          }
          ... on PublishedLookalikeMediaDataRoom {
            driverAttestationHash
          }
          ... on PublishedMediaInsightsDcr {
            driverAttestationHash
          }
        }
        leaf
        publisher {
          id
          email
        }
      }
    }
  }
}
    `;
function Uc(e) {
  const t = { ...n, ...e };
  return o.useQuery(ae, t);
}
function Oc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ae, t);
}
function Ec(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ae, t);
}
const se = i`
    query DatasetSchema($datasetId: String!) {
  dataset(id: $datasetId) {
    id
    statistics
  }
}
    `;
function Jc(e) {
  const t = { ...n, ...e };
  return o.useQuery(se, t);
}
function xc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(se, t);
}
function Bc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(se, t);
}
const ue = i`
    query DatasetSecretsByHash($manifestHash: HexString!) {
  datasetByManifestHash(manifestHash: $manifestHash) {
    id
    encryptionKeySecretId
    metadataSecretId
  }
}
    `;
function _c(e) {
  const t = { ...n, ...e };
  return o.useQuery(ue, t);
}
function jc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ue, t);
}
function Wc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ue, t);
}
const re = i`
    query Datasets {
  datasets {
    nodes {
      id
      name
      owner {
        email
        id
      }
      createdAt
      datasetImport {
        config
      }
      statistics
      manifestHash
      description
      size
      sourceType
    }
    totalCount @client
  }
}
    `;
function Gc(e) {
  const t = { ...n, ...e };
  return o.useQuery(re, t);
}
function Vc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(re, t);
}
function Zc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(re, t);
}
const de = i`
    query DatasetsSecrets {
  datasets {
    nodes {
      id
      encryptionKeySecretId
      metadataSecretId
    }
    totalCount @client
  }
}
    `;
function Kc(e) {
  const t = { ...n, ...e };
  return o.useQuery(de, t);
}
function Xc(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(de, t);
}
function Yc(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(de, t);
}
const fi = i`
    mutation DeactivateDataRoom($dataRoomId: String!) {
  publishedDataRoom {
    deactivate(id: $dataRoomId) {
      id
      deactivatedAt
      isStopped
      isActive
    }
  }
}
    `;
function ep(e) {
  const t = { ...n, ...e };
  return o.useMutation(fi, t);
}
const Si = i`
    mutation DeleteAccount($id: String!) {
  organization {
    deleteUser(id: $id) {
      id
    }
  }
}
    `;
function tp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Si, t);
}
const bi = i`
    mutation DeleteActivationConfiguration($id: String!) {
  activationConfiguration {
    delete(id: $id)
  }
}
    `;
function op(e) {
  const t = { ...n, ...e };
  return o.useMutation(bi, t);
}
const gi = i`
    mutation DeleteConsentlessAudience($input: MediaDeleteConsentlessAudienceInput!) {
  mediaDeleteConsentlessAudience(input: $input) @client {
    audienceId
  }
}
    `;
function np(e) {
  const t = { ...n, ...e };
  return o.useMutation(gi, t);
}
const Ni = i`
    mutation DeleteDataLab($id: String!) {
  dataLab {
    deleteById(id: $id)
  }
}
    `;
function ip(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ni, t);
}
const Ri = i`
    mutation DeleteDataPartnerDisplayConfiguration($id: String!) {
  dataPartnerDisplayConfiguration {
    delete(id: $id)
  }
}
    `;
function ap(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ri, t);
}
const Qi = i`
    mutation DeleteDataPartnerUsageConfiguration($id: String!) {
  dataPartnerUsageConfiguration {
    delete(id: $id)
  }
}
    `;
function sp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Qi, t);
}
const Pi = i`
    mutation DeleteDataRoom($dataRoomId: String!) {
  draftDataRoom {
    delete(id: $dataRoomId)
  }
}
    `;
function up(e) {
  const t = { ...n, ...e };
  return o.useMutation(Pi, t);
}
const Ii = i`
    mutation DeleteDataset($input: DeleteDatasetInput!) {
  deleteDataset(input: $input) @client {
    id
  }
}
    `;
function rp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ii, t);
}
const vi = i`
    mutation DeleteDraftTableLeafNode($id: String!) {
  dataNode: draftTableLeafNode {
    delete(id: $id)
  }
}
    `;
function dp(e) {
  const t = { ...n, ...e };
  return o.useMutation(vi, t);
}
const $i = i`
    mutation DeleteDraftTableLeafNodeColumn($id: String!) {
  draftTableLeafNode {
    removeColumn(id: $id)
  }
}
    `;
function cp(e) {
  const t = { ...n, ...e };
  return o.useMutation($i, t);
}
const Ci = i`
    mutation DeletePlayground($id: String!) {
  playground {
    delete(id: $id)
  }
}
    `;
function pp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ci, t);
}
const Ai = i`
    mutation DeletePublisherDisplayConfiguration($id: String!) {
  publisherDisplayConfiguration {
    delete(id: $id)
  }
}
    `;
function mp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ai, t);
}
const Mi = i`
    mutation DeleteRequest($id: String!) {
  dataRoomRequest {
    delete(dataRoomRequestId: $id)
  }
}
    `;
function lp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Mi, t);
}
const Li = i`
    mutation DeleteRequestParticipant($id: String!) {
  draftParticipant {
    delete(id: $id)
  }
}
    `;
function yp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Li, t);
}
const zi = i`
    mutation DeleteStaticScript($scriptId: String!) {
  draftScriptingNode {
    deleteScript(id: $scriptId) {
      id
      scripts {
        nodes {
          id
          name
          content
          isMainScript
        }
      }
    }
  }
}
    `;
function Dp(e) {
  const t = { ...n, ...e };
  return o.useMutation(zi, t);
}
const Hi = i`
    mutation DeleteSyntheticNodeColumn($id: String!) {
  draftSyntheticNode {
    deleteSyntheticNodeColumn(syntheticNodeColumnId: $id)
  }
}
    `;
function hp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Hi, t);
}
const qi = i`
    mutation DeleteTestModePublication($nodeId: NodeId!) {
  testModePublication {
    delete(nodeId: $nodeId) {
      myself {
        id
      }
    }
  }
}
    `;
function fp(e) {
  const t = { ...n, ...e };
  return o.useMutation(qi, t);
}
const Ti = i`
    mutation DeleteUser($userId: String!) {
  organization {
    deleteUser(id: $userId) {
      id
    }
  }
}
    `;
function Sp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ti, t);
}
const wi = i`
    mutation DeprovisionDataLab($dataRoomId: String!) {
  dataLab {
    deprovisionDataLab(lookalikeMediaDcrId: $dataRoomId) {
      id
    }
  }
}
    `;
function bp(e) {
  const t = { ...n, ...e };
  return o.useMutation(wi, t);
}
const ki = i`
    mutation DeprovisionDataLabFromMediaInsightsDcr($dataRoomId: String!) {
  dataLab {
    deprovisionDataLabFromMediaInsightsDcr(mediaInsightsDcrId: $dataRoomId) {
      id
    }
  }
}
    `;
function gp(e) {
  const t = { ...n, ...e };
  return o.useMutation(ki, t);
}
const ce = i`
    query DevComputeNodeActions($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    id
    name
    ... on DraftMatchNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
    ... on DraftSqlNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
    ... on DraftSqliteNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
    ... on DraftPostNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
    ... on DraftPreviewNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
    ... on DraftScriptingNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
    ... on DraftSyntheticNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
    ... on DraftS3SinkNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
  }
}
    `;
function Np(e) {
  const t = { ...n, ...e };
  return o.useQuery(ce, t);
}
function Rp(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ce, t);
}
function Qp(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ce, t);
}
const pe = i`
    query DevComputeNodeJob($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    id
    ... on DraftMatchNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
    ... on DraftSqlNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
    ... on DraftSqliteNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
    ... on DraftSqliteNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
    ... on DraftPostNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
    ... on DraftPreviewNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
    ... on DraftScriptingNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
    ... on DraftSyntheticNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
    ... on DraftS3SinkNode {
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
        enclaveComputeJobHandleBase64
      }
    }
  }
}
    `;
function Pp(e) {
  const t = { ...n, ...e };
  return o.useQuery(pe, t);
}
function Ip(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(pe, t);
}
function vp(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(pe, t);
}
const Fi = i`
    mutation DevComputeNodeRun($input: RunDevComputationInput!) {
  runDevComputation(input: $input) @client {
    id
    enclaveComputeJobId
    status
    createdAt
  }
}
    `;
function $p(e) {
  const t = { ...n, ...e };
  return o.useMutation(Fi, t);
}
const me = i`
    query DevComputeNodeTypename($playgroundId: String!) {
  playground(id: $playgroundId) {
    id
    draftNode {
      id
    }
  }
}
    `;
function Cp(e) {
  const t = { ...n, ...e };
  return o.useQuery(me, t);
}
function Ap(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(me, t);
}
function Mp(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(me, t);
}
const le = i`
    query DevComputeNodes($id: String!) {
  publishedDataRoom(id: $id) {
    id
    playgrounds {
      nodes {
        id
        owner {
          email
        }
        draftNode {
          id
          name
          ... on DraftMatchNode {
            computationType
          }
          ... on DraftSyntheticNode {
            computationType
          }
          ... on DraftPostNode {
            computationType
          }
          ... on DraftPreviewNode {
            computationType
          }
          ... on DraftS3SinkNode {
            computationType
          }
          ... on DraftScriptingNode {
            scriptingLanguage
            computationType
          }
          ... on DraftSqlNode {
            computationType
            privacyFilter {
              minimumRows
            }
          }
          ... on DraftSqliteNode {
            computationType
            privacyFilter {
              minimumRows
            }
          }
        }
      }
    }
  }
}
    `;
function Lp(e) {
  const t = { ...n, ...e };
  return o.useQuery(le, t);
}
function zp(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(le, t);
}
function Hp(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(le, t);
}
const ye = i`
    query DevComputeNodesForReport($id: String!) {
  publishedDataRoom(id: $id) {
    id
    playgrounds {
      nodes {
        id
        owner {
          email
        }
        draftNode {
          id
          name
          permissions {
            nodes {
              ... on DraftAnalystPermission {
                participant {
                  id
                  userEmail
                }
              }
            }
          }
          ... on DraftSyntheticNode {
            id
            accuracy
            computationType
            includeReportWithStats
            columns {
              nodes {
                id
                index
                name
                maskType
                dataType
                shouldMaskColumn
              }
            }
            dependencyUpdatedAt
            dependency {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
              ... on PublishedNodeConnection {
                computeNodeId
                publishedDataRoomId
              }
            }
          }
          ... on DraftPostNode {
            id
            name
            computationType
            dependency {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
              ... on PublishedNodeConnection {
                computeNodeId
                publishedDataRoomId
              }
            }
          }
          ... on DraftPreviewNode {
            id
            name
            computationType
            quotaBytes
            dependency {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
              ... on PublishedNodeConnection {
                computeNodeId
                publishedDataRoomId
              }
            }
          }
          ... on DraftMatchNode {
            id
            config
            computationType
            dependencies {
              nodes {
                ... on DraftNodeConnection {
                  draftNode {
                    id
                    name
                  }
                }
                ... on PublishedNodeConnection {
                  computeNodeId
                }
              }
            }
          }
          ... on DraftS3SinkNode {
            computationType
          }
          ... on DraftScriptingNode {
            id
            name
            computationType
            scripts {
              nodes {
                id
                name
                content
                isMainScript
              }
            }
            dependencies {
              nodes {
                ... on DraftNodeConnection {
                  draftNode {
                    id
                    name
                  }
                }
                ... on PublishedNodeConnection {
                  computeNodeId
                  publishedDataRoomId
                }
              }
            }
            output
            scriptingLanguage
          }
          ... on DraftSqlNode {
            id
            name
            statement
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
          }
          ... on DraftSqliteNode {
            id
            name
            statement
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
          }
          ... on DraftSyntheticNode {
            id
            accuracy
            computationType
            includeReportWithStats
            columns {
              nodes {
                id
                index
                name
                maskType
                dataType
                shouldMaskColumn
              }
            }
            dependencyUpdatedAt
            dependency {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
              ... on PublishedNodeConnection {
                computeNodeId
                publishedDataRoomId
              }
            }
          }
        }
      }
    }
  }
}
    `;
function qp(e) {
  const t = { ...n, ...e };
  return o.useQuery(ye, t);
}
function Tp(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ye, t);
}
function wp(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ye, t);
}
const De = i`
    query DirectActivatedAudiences($input: MediaRetrieveDirectActivatedAudiencesInput!, $id: String!) {
  mediaRetrieveDirectActivatedAudiences(input: $input) @client {
    nodes {
      name
      size
      downloaded
    }
  }
  publishedMediaDataRoom(id: $id) {
    id
    activationDownloadByPublisher @client
  }
}
    `;
function kp(e) {
  const t = { ...n, ...e };
  return o.useQuery(De, t);
}
function Fp(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(De, t);
}
function Up(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(De, t);
}
const he = i`
    query DirectAudiences($input: MediaRetrieveDirectAudiencesInput!, $id: String!) {
  mediaRetrieveDirectAudiences(input: $input) @client {
    nodes {
      name
      size
      activated
      downloaded
    }
  }
  publishedMediaDataRoom(id: $id) {
    id
    activationDownloadByPublisher @client
  }
}
    `;
function Op(e) {
  const t = { ...n, ...e };
  return o.useQuery(he, t);
}
function Ep(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(he, t);
}
function Jp(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(he, t);
}
const Ui = i`
    mutation DownloadActivatedConsentlessAudience($input: MediaDownloadConsentlessActivatedAudienceInput!) {
  mediaDownloadActivatedConsentlessAudience(input: $input) @client {
    audienceId
    audienceCsv
  }
}
    `;
function xp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ui, t);
}
const Oi = i`
    mutation DownloadActivatedDirectAudience($input: MediaDownloadDirectActivatedAudienceInput!) {
  mediaDownloadActivatedDirectAudience(input: $input) @client {
    audienceType
    audienceCsv
  }
}
    `;
function Bp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Oi, t);
}
const Ei = i`
    mutation DownloadComputeNodeResultAsCsv($input: RetrieveComputeJobResultFileInput!) {
  retrieveComputeJobResultFileAsCsv(input: $input) @client {
    resultCsv
  }
}
    `;
function _p(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ei, t);
}
const Ji = i`
    mutation DownloadComputeNodeResultAsZip($input: RetrieveComputeJobResultFileInput!) {
  retrieveComputeJobResultFileAsZip(input: $input) @client {
    resultZip
  }
}
    `;
function jp(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ji, t);
}
const fe = i`
    query DraftComputeNode($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    id
    name
    ... on DraftMatchNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on DraftSqlNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on DraftSqliteNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        dataRoomHash
        purpose
        driverAttestationHash
      }
    }
    ... on DraftPostNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on DraftPreviewNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on DraftScriptingNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on DraftSyntheticNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on DraftS3SinkNode {
      computationType
      job @client {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
  }
}
    `;
function Wp(e) {
  const t = { ...n, ...e };
  return o.useQuery(fe, t);
}
function Gp(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(fe, t);
}
function Vp(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(fe, t);
}
const Se = i`
    query DraftComputeNodeEditor($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    id
  }
}
    `;
function Zp(e) {
  const t = { ...n, ...e };
  return o.useQuery(Se, t);
}
function Kp(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Se, t);
}
function Xp(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Se, t);
}
const be = i`
    query DraftComputeNodeName($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    id
    name
  }
}
    `;
function Yp(e) {
  const t = { ...n, ...e };
  return o.useQuery(be, t);
}
function em(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(be, t);
}
function tm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(be, t);
}
const ge = i`
    query DraftComputeNodeParticipants($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    permissions {
      nodes {
        ... on DraftAnalystPermission {
          participant {
            id
            userEmail
          }
        }
      }
    }
  }
}
    `;
function om(e) {
  const t = { ...n, ...e };
  return o.useQuery(ge, t);
}
function nm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ge, t);
}
function im(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ge, t);
}
const Ne = i`
    query DraftComputeNodeType($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    id
    name
    ... on DraftScriptingNode {
      computationType
    }
    ... on DraftSyntheticNode {
      computationType
    }
    ... on DraftPostNode {
      computationType
    }
    ... on DraftPreviewNode {
      computationType
    }
    ... on DraftS3SinkNode {
      computationType
    }
    ... on DraftMatchNode {
      computationType
    }
    ... on DraftSqlNode {
      computationType
      privacyFilter {
        minimumRows
      }
    }
    ... on DraftSqliteNode {
      computationType
      privacyFilter {
        minimumRows
      }
    }
  }
}
    `;
function am(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ne, t);
}
function sm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ne, t);
}
function um(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ne, t);
}
const Re = i`
    query DraftComputeNodeTypename($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    id
    name
  }
}
    `;
function rm(e) {
  const t = { ...n, ...e };
  return o.useQuery(Re, t);
}
function dm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Re, t);
}
function cm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Re, t);
}
const Qe = i`
    query DraftDataRoom($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    id
    name: title
    description
    enableInteractivity
    enableDevelopment
    hasImportedNativeSql
    owner {
      id
      email
    }
    isSaving @client
    isOwner @client
    draftNodes {
      nodes {
        id
        name
        ... on DraftScriptingNode {
          computationType
        }
        ... on DraftSqlNode {
          computationType
        }
        ... on DraftSqliteNode {
          computationType
        }
        ... on DraftMatchNode {
          computationType
        }
        ... on DraftSyntheticNode {
          computationType
        }
        ... on DraftPostNode {
          computationType
        }
        ... on DraftPreviewNode {
          computationType
        }
        ... on DraftS3SinkNode {
          computationType
        }
        ... on DraftRawLeafNode {
          id
          name
        }
        ... on DraftTableLeafNode {
          id
          name
        }
      }
    }
    participants {
      nodes {
        id
        userEmail
        permissions {
          nodes {
            ... on DraftAnalystPermission {
              node {
                ... on DraftScriptingNode {
                  id
                  name
                }
                ... on DraftSqlNode {
                  id
                  name
                }
                ... on DraftSqliteNode {
                  id
                  name
                }
                ... on DraftMatchNode {
                  id
                  name
                }
                ... on DraftSyntheticNode {
                  id
                  name
                }
                ... on DraftPostNode {
                  id
                  name
                }
                ... on DraftPreviewNode {
                  id
                  name
                }
                ... on DraftS3SinkNode {
                  id
                  name
                }
              }
            }
            ... on DraftDataOwnerPermission {
              node {
                ... on DraftRawLeafNode {
                  id
                  name
                }
                ... on DraftTableLeafNode {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
function pm(e) {
  const t = { ...n, ...e };
  return o.useQuery(Qe, t);
}
function mm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Qe, t);
}
function lm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Qe, t);
}
const Pe = i`
    query DraftDataRoomActions($id: String!) {
  draftDataRoom(id: $id) {
    id
    name: title
    logo
    showOrganizationLogo
    requirePassword
    password @client
    userSettings {
      id
      isArchived
      isFavorite
    }
    owner {
      id
      email
      organizationLogo
    }
    updatedAt
    createdAt
  }
}
    `;
function ym(e) {
  const t = { ...n, ...e };
  return o.useQuery(Pe, t);
}
function Dm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Pe, t);
}
function hm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Pe, t);
}
const Ie = i`
    query DraftDataRoomAsJson($id: String!) {
  draftDataRoom(id: $id) {
    id
    title
    description
    enableDevelopment
    enableInteractivity
    logo
    dataNodesOrder
    computeNodesOrder
    draftNodes {
      nodes {
        permissions {
          nodes {
            ... on DraftAnalystPermission {
              participant {
                id
                userEmail
              }
            }
          }
        }
        ... on DraftScriptingNode {
          id
          name
          computationType
          scripts {
            nodes {
              id
              name
              content
              isMainScript
            }
          }
          dependencies {
            nodes {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
            }
          }
          output
          scriptingLanguage
        }
        ... on DraftMatchNode {
          id
          name
          config
        }
        ... on DraftSqlNode {
          id
          name
          statement
          computationType
          privacyFilter {
            minimumRows
            isEnabled
          }
        }
        ... on DraftSqliteNode {
          id
          name
          statement
          computationType
          privacyFilter {
            minimumRows
            isEnabled
          }
        }
        ... on DraftSyntheticNode {
          id
          name
          accuracy
          includeReportWithStats
          computationType
          dependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
        }
        ... on DraftPostNode {
          id
          name
          computationType
          dependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
        }
        ... on DraftPreviewNode {
          id
          name
          quotaBytes
          computationType
          dependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
        }
        ... on DraftS3SinkNode {
          id
          name
          endpoint
          computationType
          region
          credentialsDependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
          uploadDependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
        }
        ... on DraftTableLeafNode {
          id
          name
          isRequired
          columns {
            nodes {
              id
              name
              dataType
              isNullable
            }
          }
        }
        ... on DraftRawLeafNode {
          id
          name
          isRequired
        }
      }
    }
    participants {
      nodes {
        id
        userEmail
        permissions {
          nodes {
            ... on DraftDataOwnerPermission {
              node {
                id
                name
              }
            }
            ... on DraftAnalystPermission {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
    owner {
      id
      email
    }
    updatedAt
    createdAt
  }
}
    `;
function fm(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ie, t);
}
function Sm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ie, t);
}
function bm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ie, t);
}
const ve = i`
    query DraftDataRoomDataNodes($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    id
    dataNodesOrder
    computeNodesOrder
    draftNodes {
      nodes {
        id
        name
        permissions {
          nodes {
            ... on DraftAnalystPermission {
              node {
                id
              }
            }
            ... on DraftDataOwnerPermission {
              node {
                id
              }
            }
          }
        }
        ... on DraftTableLeafNode {
          isRequired
          columns {
            nodes {
              id
              name
              dataType
              isNullable
              formatType
              hashWith
            }
          }
          columnsOrder
          testModePublication {
            dataset {
              id
              manifestHash
              createdAt
              owner {
                email
              }
            }
          }
          uniqueColumnIds
        }
        ... on DraftRawLeafNode {
          isRequired
          testModePublication {
            dataset {
              id
              manifestHash
              createdAt
              owner {
                email
              }
            }
          }
        }
      }
    }
    participants {
      nodes {
        id
        userEmail
        permissions {
          nodes {
            ... on DraftAnalystPermission {
              node {
                id
              }
            }
            ... on DraftDataOwnerPermission {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
function gm(e) {
  const t = { ...n, ...e };
  return o.useQuery(ve, t);
}
function Nm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ve, t);
}
function Rm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ve, t);
}
const xi = i`
    mutation DraftDataRoomDelete($id: String!) {
  draftDataRoom {
    delete(id: $id)
  }
}
    `;
function Qm(e) {
  const t = { ...n, ...e };
  return o.useMutation(xi, t);
}
const $e = i`
    query DraftDataRoomDescription($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    id
    description
  }
}
    `;
function Pm(e) {
  const t = { ...n, ...e };
  return o.useQuery($e, t);
}
function Im(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery($e, t);
}
function vm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery($e, t);
}
const Bi = i`
    mutation DraftDataRoomDuplicate($input: ImportDataScienceDataRoomInput!) {
  draftDataRoom {
    importDataScienceDataRoom(input: $input) {
      record {
        id
        title
        description
        owner {
          id
          email
        }
        logo
        enableInteractivity
        enableDevelopment
        userSettings {
          id
          isArchived
          isFavorite
        }
        createdAt
        draftNodes {
          nodes {
            id
            name
          }
        }
        editors {
          nodes {
            user {
              id
              email
            }
            role
          }
        }
        dataNodesOrder
        computeNodesOrder
        participants {
          nodes {
            id
            userEmail
            permissions {
              nodes {
                ... on DraftDataOwnerPermission {
                  node {
                    id
                    name
                  }
                }
                ... on DraftAnalystPermission {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
        query {
          dataRooms(
            filter: {isArchived: {equalTo: false}, isFavorite: {equalTo: false}, isOwnedByUser: {equalTo: true}}
            sortBy: {updatedAt: DESCENDING}
          ) {
            nodes {
              ... on DraftDataRoom {
                ...NavigationDrawerDraftDataRoom
              }
              ... on PublishedDataRoom {
                ...NavigationDrawerPublishedDataRoom
              }
              ... on PublishedMediaDataRoom {
                ...NavigationDrawerPublishedMediaDataRoom
              }
              ... on PublishedLookalikeMediaDataRoom {
                ...NavigationDrawerPublishedLookalikeMediaDataRoom
              }
              ... on PublishedMediaInsightsDcr {
                ...NavigationDrawerPublishedMediaInsightsDcr
              }
            }
          }
        }
      }
    }
  }
}
    ${s}
${u}
${r}
${p}
${m}`;
function $m(e) {
  const t = { ...n, ...e };
  return o.useMutation(Bi, t);
}
const Ce = i`
    query DraftDataRoomEnableImmutability($id: String!) {
  draftDataRoom(id: $id) {
    id
    enableInteractivity
    enableDevelopment
  }
}
    `;
function Cm(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ce, t);
}
function Am(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ce, t);
}
function Mm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ce, t);
}
const Ae = i`
    query DraftDataRoomIsFavorite($id: String!) {
  draftDataRoom(id: $id) {
    id
    userSettings {
      id
      isFavorite
    }
  }
}
    `;
function Lm(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ae, t);
}
function zm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ae, t);
}
function Hm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ae, t);
}
const Me = i`
    query DraftDataRoomIsHidden($id: String!) {
  draftDataRoom(id: $id) {
    id
    userSettings {
      id
      isHidden: isArchived
    }
  }
}
    `;
function qm(e) {
  const t = { ...n, ...e };
  return o.useQuery(Me, t);
}
function Tm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Me, t);
}
function wm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Me, t);
}
const Le = i`
    query DraftDataRoomName($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    id
    name: title
  }
}
    `;
function km(e) {
  const t = { ...n, ...e };
  return o.useQuery(Le, t);
}
function Fm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Le, t);
}
function Um(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Le, t);
}
const ze = i`
    query DraftDataRoomNodes($id: String!) {
  draftDataRoom(id: $id) {
    id
    draftNodes {
      nodes {
        permissions {
          nodes {
            ... on DraftAnalystPermission {
              participant {
                id
                userEmail
              }
            }
            ... on DraftDataOwnerPermission {
              participant {
                id
                userEmail
              }
            }
          }
        }
        ... on DraftScriptingNode {
          id
          name
          computationType
          scripts {
            nodes {
              id
              name
              content
              isMainScript
            }
          }
          dependencies {
            nodes {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
            }
          }
          output
          scriptingLanguage
        }
        ... on DraftMatchNode {
          id
          name
          config
          computationType
        }
        ... on DraftSqlNode {
          id
          name
          statement
          computationType
          privacyFilter {
            minimumRows
            isEnabled
          }
        }
        ... on DraftSqliteNode {
          id
          name
          statement
          computationType
          privacyFilter {
            minimumRows
            isEnabled
          }
        }
        ... on DraftSyntheticNode {
          id
          name
          accuracy
          computationType
          includeReportWithStats
          columns {
            nodes {
              id
              index
              name
              maskType
              dataType
              shouldMaskColumn
            }
          }
          dependencyUpdatedAt
          dependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
            ... on PublishedNodeConnection {
              computeNodeId
              publishedDataRoomId
            }
          }
        }
        ... on DraftPostNode {
          id
          name
          computationType
          dependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
        }
        ... on DraftPreviewNode {
          id
          name
          quotaBytes
          computationType
          dependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
        }
        ... on DraftS3SinkNode {
          id
          name
          endpoint
          region
          computationType
          credentialsDependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
          uploadDependency {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
          }
        }
        ... on DraftTableLeafNode {
          id
          name
          columns {
            nodes {
              id
              name
              dataType
              isNullable
            }
          }
        }
        ... on DraftRawLeafNode {
          id
          name
        }
      }
    }
    computeNodesOrder
    dataNodesOrder
  }
}
    `;
function Om(e) {
  const t = { ...n, ...e };
  return o.useQuery(ze, t);
}
function Em(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ze, t);
}
function Jm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ze, t);
}
const He = i`
    query DraftDataRoomOverview($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    id
    name: title
    createdAt
    owner {
      id
      email
    }
    ownerOrganization {
      name
    }
    userSettings {
      ...DataRoomUserSettings
    }
    participantUsers: participants {
      nodes {
        id
        userEmail
      }
    }
  }
}
    ${c}`;
function xm(e) {
  const t = { ...n, ...e };
  return o.useQuery(He, t);
}
function Bm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(He, t);
}
function _m(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(He, t);
}
const qe = i`
    query DraftDataRoomParticipants($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    participants {
      nodes {
        id
        userEmail
        permissions {
          nodes {
            ... on DraftDataOwnerPermission {
              node {
                ... on DraftRawLeafNode {
                  id
                  name
                }
                ... on DraftTableLeafNode {
                  id
                  name
                }
              }
            }
            ... on DraftAnalystPermission {
              node {
                ... on DraftScriptingNode {
                  id
                  name
                }
                ... on DraftSqlNode {
                  id
                  name
                }
                ... on DraftSqliteNode {
                  id
                  name
                }
                ... on DraftMatchNode {
                  id
                  name
                }
                ... on DraftSyntheticNode {
                  id
                  name
                }
                ... on DraftPostNode {
                  id
                  name
                }
                ... on DraftPreviewNode {
                  id
                  name
                }
                ... on DraftS3SinkNode {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
function jm(e) {
  const t = { ...n, ...e };
  return o.useQuery(qe, t);
}
function Wm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(qe, t);
}
function Gm(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(qe, t);
}
const Te = i`
    query DraftDataRoomPublish($id: String!) {
  draftDataRoom(id: $id) {
    id
    name: title
    logo
    owner {
      id
      email
    }
    updatedAt
    createdAt
  }
}
    `;
function Vm(e) {
  const t = { ...n, ...e };
  return o.useQuery(Te, t);
}
function Zm(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Te, t);
}
function Km(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Te, t);
}
const we = i`
    query DraftDataRoomShowOrganizationLogo($id: String!) {
  draftDataRoom(id: $id) {
    id
    showOrganizationLogo
  }
}
    `;
function Xm(e) {
  const t = { ...n, ...e };
  return o.useQuery(we, t);
}
function Ym(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(we, t);
}
function el(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(we, t);
}
const ke = i`
    query DraftDataRoomTestPublications($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    id
    draftNodes {
      nodes {
        id
        ... on DraftTableLeafNode {
          testModePublication {
            dataset {
              id
              manifestHash
            }
          }
        }
        ... on DraftRawLeafNode {
          testModePublication {
            dataset {
              id
              manifestHash
            }
          }
        }
      }
    }
  }
}
    `;
function tl(e) {
  const t = { ...n, ...e };
  return o.useQuery(ke, t);
}
function ol(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ke, t);
}
function nl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ke, t);
}
const _i = i`
    mutation DraftDataRoomUpdateEnableImmutability($id: String!, $mutable: Boolean!) {
  draftDataRoom {
    update(
      input: {id: $id, enableInteractivity: $mutable, enableDevelopment: $mutable}
    ) {
      id
      enableInteractivity
      enableDevelopment
    }
  }
}
    `;
function il(e) {
  const t = { ...n, ...e };
  return o.useMutation(_i, t);
}
const ji = i`
    mutation DraftMatchNodeAddDependency($id: String!, $dependencyId: NodeId!) {
  draftMatchNode {
    addDependency(id: $id, dependencyId: $dependencyId) {
      id
      ... on DraftMatchNode {
        dependencies {
          nodes {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
            ... on PublishedNodeConnection {
              computeNodeId
            }
          }
        }
      }
    }
  }
}
    `;
function al(e) {
  const t = { ...n, ...e };
  return o.useMutation(ji, t);
}
const Fe = i`
    query DraftMatchNodeConfig($id: String!) {
  draftNode(id: $id) {
    id
    ... on DraftMatchNode {
      config
    }
  }
}
    `;
function sl(e) {
  const t = { ...n, ...e };
  return o.useQuery(Fe, t);
}
function ul(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Fe, t);
}
function rl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Fe, t);
}
const Ue = i`
    query DraftMatchNodeDependencies($id: String!) {
  draftNode(id: $id) {
    id
    ... on DraftMatchNode {
      dependencies {
        nodes {
          ... on DraftNodeConnection {
            draftNode {
              id
              name
            }
          }
          ... on PublishedNodeConnection {
            computeNodeId
          }
        }
      }
    }
  }
}
    `;
function dl(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ue, t);
}
function cl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ue, t);
}
function pl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ue, t);
}
const Wi = i`
    mutation DraftMatchNodeRemoveDependency($id: String!, $dependencyId: NodeId!) {
  draftMatchNode {
    removeDependency(id: $id, dependencyId: $dependencyId) {
      id
      ... on DraftMatchNode {
        dependencies {
          nodes {
            ... on DraftNodeConnection {
              draftNode {
                id
                name
              }
            }
            ... on PublishedNodeConnection {
              computeNodeId
            }
          }
        }
      }
    }
  }
}
    `;
function ml(e) {
  const t = { ...n, ...e };
  return o.useMutation(Wi, t);
}
const Gi = i`
    mutation DraftMatchNodeUpdateConfig($id: String!, $config: JSON!) {
  draftMatchNode {
    update(input: {id: $id, config: $config}) {
      id
      config
    }
  }
}
    `;
function ll(e) {
  const t = { ...n, ...e };
  return o.useMutation(Gi, t);
}
const Oe = i`
    query DraftNodeId($id: String!) {
  draftNode(id: $id) {
    id
  }
}
    `;
function yl(e) {
  const t = { ...n, ...e };
  return o.useQuery(Oe, t);
}
function Dl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Oe, t);
}
function hl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Oe, t);
}
const Ee = i`
    query DraftNodeTypename($id: String!) {
  draftNode(id: $id) {
    __typename
  }
}
    `;
function fl(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ee, t);
}
function Sl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ee, t);
}
function bl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ee, t);
}
const Je = i`
    query DraftTableLeafNodeUniqueness($id: String!) {
  draftNode(id: $id) {
    id
    ... on DraftTableLeafNode {
      uniqueColumnIds
    }
  }
}
    `;
function gl(e) {
  const t = { ...n, ...e };
  return o.useQuery(Je, t);
}
function Nl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Je, t);
}
function Rl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Je, t);
}
const Vi = i`
    mutation DraftTableLeafNodeUpdateUniqueness($id: String!, $uniqueness: SetUniqueValidationSettingsInput!) {
  draftTableLeafNode {
    update(input: {id: $id, uniqueness: $uniqueness}) {
      id
      uniqueColumnIds
    }
  }
}
    `;
function Ql(e) {
  const t = { ...n, ...e };
  return o.useMutation(Vi, t);
}
const xe = i`
    query DraftNodesTypenames($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    draftNodes {
      nodes {
        id
        name
      }
    }
  }
}
    `;
function Pl(e) {
  const t = { ...n, ...e };
  return o.useQuery(xe, t);
}
function Il(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(xe, t);
}
function vl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(xe, t);
}
const Zi = i`
    mutation DraftParticipantCreate($draftDataRoomId: String!, $userEmail: String!) {
  draftParticipant {
    createForDraftDataRoom(
      input: {userEmail: $userEmail}
      draftDataRoomId: $draftDataRoomId
    ) {
      id
      userEmail
    }
  }
}
    `;
function $l(e) {
  const t = { ...n, ...e };
  return o.useMutation(Zi, t);
}
const Ki = i`
    mutation DraftParticipantCreateAnalystPermission($draftNodeId: String!, $draftParticipantId: String!) {
  draftParticipant {
    createAnalystPermission(
      input: {draftNodeId: $draftNodeId, draftParticipantId: $draftParticipantId}
    ) {
      node {
        id
        name
      }
    }
  }
}
    `;
function Cl(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ki, t);
}
const Xi = i`
    mutation DraftParticipantCreateDataOwnerPermission($draftNodeId: String!, $draftParticipantId: String!) {
  draftParticipant {
    createDataOwnerPermission(
      input: {draftNodeId: $draftNodeId, draftParticipantId: $draftParticipantId}
    ) {
      node {
        id
        name
      }
    }
  }
}
    `;
function Al(e) {
  const t = { ...n, ...e };
  return o.useMutation(Xi, t);
}
const Yi = i`
    mutation DraftParticipantDelete($id: String!) {
  draftParticipant {
    delete(id: $id)
  }
}
    `;
function Ml(e) {
  const t = { ...n, ...e };
  return o.useMutation(Yi, t);
}
const ea = i`
    mutation DraftParticipantDeleteAnalystPermission($computeNodeId: String!, $participantId: String!) {
  draftParticipant {
    deleteAnalystPermissionByDraftNodeId(
      draftNodeId: $computeNodeId
      participantId: $participantId
    )
  }
}
    `;
function Ll(e) {
  const t = { ...n, ...e };
  return o.useMutation(ea, t);
}
const ta = i`
    mutation DraftParticipantDeleteDataOwnerPermission($dataNodeId: String!, $participantId: String!) {
  draftParticipant {
    deleteDataOwnerPermissionByDraftNodeId(
      draftNodeId: $dataNodeId
      participantId: $participantId
    )
  }
}
    `;
function zl(e) {
  const t = { ...n, ...e };
  return o.useMutation(ta, t);
}
const oa = i`
    mutation DraftParticipantUpdateUserEmail($id: String!, $participantEmail: String!) {
  draftParticipant {
    update(input: {id: $id, participantEmail: $participantEmail}) {
      id
      userEmail
    }
  }
}
    `;
function Hl(e) {
  const t = { ...n, ...e };
  return o.useMutation(oa, t);
}
const Be = i`
    query DraftPostComputeNode($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftPostNode {
      id
      name
      computationType
      dependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function ql(e) {
  const t = { ...n, ...e };
  return o.useQuery(Be, t);
}
function Tl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Be, t);
}
function wl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Be, t);
}
const _e = i`
    query DraftPreviewComputeNode($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftPreviewNode {
      id
      name
      quotaBytes
      computationType
      dependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function kl(e) {
  const t = { ...n, ...e };
  return o.useQuery(_e, t);
}
function Fl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(_e, t);
}
function Ul(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(_e, t);
}
const je = i`
    query DraftPrivacyFilter($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftSqlNode {
      id
      privacyFilter {
        minimumRows
        isEnabled
      }
    }
    ... on DraftSqliteNode {
      id
      privacyFilter {
        minimumRows
        isEnabled
      }
    }
  }
}
    `;
function Ol(e) {
  const t = { ...n, ...e };
  return o.useQuery(je, t);
}
function El(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(je, t);
}
function Jl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(je, t);
}
const We = i`
    query DraftS3ConnectionParams($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftS3SinkNode {
      id
      name
      endpoint
      region
      credentialsDependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function xl(e) {
  const t = { ...n, ...e };
  return o.useQuery(We, t);
}
function Bl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(We, t);
}
function _l(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(We, t);
}
const Ge = i`
    query DraftS3ObjectUploadDependency($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftS3SinkNode {
      id
      uploadDependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function jl(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ge, t);
}
function Wl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ge, t);
}
function Gl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ge, t);
}
const Ve = i`
    query DraftScriptingComputeNode($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftScriptingNode {
      id
      name
      computationType
      scripts {
        nodes {
          id
          name
          content
          isMainScript
        }
      }
      dependencies {
        nodes {
          ... on DraftNodeConnection {
            draftNode {
              id
              name
            }
          }
          ... on PublishedNodeConnection {
            computeNodeId
            publishedDataRoomId
          }
        }
      }
      output
      scriptingLanguage
    }
  }
}
    `;
function Vl(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ve, t);
}
function Zl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ve, t);
}
function Kl(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ve, t);
}
const Ze = i`
    query DraftSqlComputeNode($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftSqlNode {
      id
      name
      computationType
      statement
    }
    ... on DraftSqliteNode {
      id
      name
      computationType
      statement
    }
  }
}
    `;
function Xl(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ze, t);
}
function Yl(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ze, t);
}
function ey(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ze, t);
}
const Ke = i`
    query DraftSyntheticComputeNode($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftSyntheticNode {
      id
      accuracy
      computationType
      includeReportWithStats
      columns {
        nodes {
          id
          index
          name
          maskType
          dataType
          shouldMaskColumn
        }
      }
      dependencyUpdatedAt
      dependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function ty(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ke, t);
}
function oy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ke, t);
}
function ny(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ke, t);
}
const Xe = i`
    query DraftSyntheticNodeAccuracy($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftSyntheticNode {
      id
      accuracy
    }
  }
}
    `;
function iy(e) {
  const t = { ...n, ...e };
  return o.useQuery(Xe, t);
}
function ay(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Xe, t);
}
function sy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Xe, t);
}
const Ye = i`
    query DraftSyntheticNodeDataSource($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftSyntheticNode {
      id
      dependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function uy(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ye, t);
}
function ry(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ye, t);
}
function dy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ye, t);
}
const et = i`
    query DraftSyntheticNodeDependency($id: String!) {
  draftNode(id: $id) {
    id
    name
    updatedAt
    ... on DraftTableLeafNode {
      columns {
        nodes {
          id
          name
          dataType
          isNullable
        }
      }
      columnsOrder
    }
  }
}
    `;
function cy(e) {
  const t = { ...n, ...e };
  return o.useQuery(et, t);
}
function py(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(et, t);
}
function my(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(et, t);
}
const tt = i`
    query DraftSyntheticNodeIncludeStatistics($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftSyntheticNode {
      id
      includeReportWithStats
    }
  }
}
    `;
function ly(e) {
  const t = { ...n, ...e };
  return o.useQuery(tt, t);
}
function yy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(tt, t);
}
function Dy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(tt, t);
}
const ot = i`
    query DraftSyntheticNodeMasking($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    ... on DraftSyntheticNode {
      id
      columns {
        nodes {
          id
          index
          name
          maskType
          dataType
          shouldMaskColumn
        }
      }
      dependencyUpdatedAt
      dependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function hy(e) {
  const t = { ...n, ...e };
  return o.useQuery(ot, t);
}
function fy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ot, t);
}
function Sy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ot, t);
}
const na = i`
    mutation EditUserOrganization($input: SetUserOrganizationInput!) {
  user {
    setOrganization(input: $input) {
      record {
        id
        organization {
          id
        }
      }
    }
  }
}
    `;
function by(e) {
  const t = { ...n, ...e };
  return o.useMutation(na, t);
}
const ia = i`
    mutation EditUserRole($input: SetUserRoleInput!, $userId: String!) {
  user {
    setRole(input: $input) {
      record {
        id
        userRole
      }
      query {
        user(id: $userId) {
          id
          userRole
        }
      }
    }
  }
}
    `;
function gy(e) {
  const t = { ...n, ...e };
  return o.useMutation(ia, t);
}
const nt = i`
    query EnclaveConfigurationPin($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    enclaveConfigurationPin @client
  }
}
    `;
function Ny(e) {
  const t = { ...n, ...e };
  return o.useQuery(nt, t);
}
function Ry(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(nt, t);
}
function Qy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(nt, t);
}
const it = i`
    query EnclaveConnectionParametersForSubmittedDataRoomRequest($id: String!) {
  submittedDataRoomRequest(id: $id) {
    id
    publishedDataRoom {
      id
      driverAttestationHash
    }
  }
}
    `;
function Py(e) {
  const t = { ...n, ...e };
  return o.useQuery(it, t);
}
function Iy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(it, t);
}
function vy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(it, t);
}
const at = i`
    query EnclaveWorkers {
  workerTypes {
    nodes {
      id
      name
      shortName
    }
  }
}
    `;
function $y(e) {
  const t = { ...n, ...e };
  return o.useQuery(at, t);
}
function Cy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(at, t);
}
function Ay(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(at, t);
}
const st = i`
    query ExternalInvitations($organizationId: String!) {
  organization(id: $organizationId) {
    id
    userInvitations {
      nodes {
        id
        user {
          id
          email
        }
        lastInvitedAt
        lastInvitedBy {
          id
          email
        }
      }
      totalCount
    }
  }
}
    `;
function My(e) {
  const t = { ...n, ...e };
  return o.useQuery(st, t);
}
function Ly(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(st, t);
}
function zy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(st, t);
}
const aa = i`
    mutation FetchComputeJobResult($input: RetrieveComputeJobResultInput!) {
  retrieveComputeJobResult(input: $input) @client {
    result
  }
}
    `;
function Hy(e) {
  const t = { ...n, ...e };
  return o.useMutation(aa, t);
}
const sa = i`
    mutation FetchComputeJobResultSize($input: RetrieveComputeJobResultInput!) {
  retrieveComputeJobResultSize(input: $input) @client
}
    `;
function qy(e) {
  const t = { ...n, ...e };
  return o.useMutation(sa, t);
}
const ua = i`
    mutation GenerateConsentlessAudience($input: MediaGenerateConsentlessAudienceInput!) {
  mediaGenerateConsentlessAudience(input: $input) @client {
    audienceIds
  }
}
    `;
function Ty(e) {
  const t = { ...n, ...e };
  return o.useMutation(ua, t);
}
const ut = i`
    query GetComputeJobEnclaveHandle($id: String!) {
  computeJob(id: $id) {
    enclaveComputeJobHandleBase64
  }
}
    `;
function wy(e) {
  const t = { ...n, ...e };
  return o.useQuery(ut, t);
}
function ky(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ut, t);
}
function Fy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ut, t);
}
const rt = i`
    query GetComputeJobs($input: NodeId!) {
  computeJobs(nodeId: $input) {
    nodes {
      id
      enclaveComputeJobId
      enclaveComputeJobHandleBase64
      status
      createdAt
      updatedAt
      autoFetching @client
      dataRoomHash
      driverAttestationHash
      purpose
    }
  }
}
    `;
function Uy(e) {
  const t = { ...n, ...e };
  return o.useQuery(rt, t);
}
function Oy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(rt, t);
}
function Ey(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(rt, t);
}
const dt = i`
    query GetLookalikeMediaComputeJob($input: MediaComputeJobFilterInput!) {
  mediaComputeJob(input: $input) {
    ...LookalikeMediaComputeJobComplete
  }
}
    ${D}`;
function Jy(e) {
  const t = { ...n, ...e };
  return o.useQuery(dt, t);
}
function xy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(dt, t);
}
function By(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(dt, t);
}
const ct = i`
    query GetMediaInsightsComputeJob($input: MediaComputeJobFilterInput!) {
  mediaComputeJob(input: $input) {
    ...LookalikeMediaComputeJobComplete
  }
}
    ${D}`;
function _y(e) {
  const t = { ...n, ...e };
  return o.useQuery(ct, t);
}
function jy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ct, t);
}
function Wy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ct, t);
}
const pt = i`
    query IsDraftDataRoomOwner($dataRoomId: String!) {
  draftDataRoom(id: $dataRoomId) {
    isOwner @client
  }
}
    `;
function Gy(e) {
  const t = { ...n, ...e };
  return o.useQuery(pt, t);
}
function Vy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(pt, t);
}
function Zy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(pt, t);
}
const mt = i`
    query IsPublishedDataRoomOwner($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    isOwner @client
  }
}
    `;
function Ky(e) {
  const t = { ...n, ...e };
  return o.useQuery(mt, t);
}
function Xy(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(mt, t);
}
function Yy(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(mt, t);
}
const ra = i`
    mutation MatchNodeCreate($input: CreateDraftMatchNodeInput!) {
  draftMatchNode {
    create(input: $input) {
      id
      name
    }
  }
}
    `;
function eD(e) {
  const t = { ...n, ...e };
  return o.useMutation(ra, t);
}
const da = i`
    mutation MatchNodeDelete($id: String!) {
  draftMatchNode {
    delete(id: $id)
  }
}
    `;
function tD(e) {
  const t = { ...n, ...e };
  return o.useMutation(da, t);
}
const ca = i`
    mutation MatchNodeNameEdit($input: UpdateDraftMatchNodeInput!) {
  draftMatchNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function oD(e) {
  const t = { ...n, ...e };
  return o.useMutation(ca, t);
}
const lt = i`
    query MediaDataRoom($input: MediaRetrieveDataRoomInput!) {
  mediaRetrieveDataRoom(input: $input) @client {
    highLevel
  }
}
    `;
function nD(e) {
  const t = { ...n, ...e };
  return o.useQuery(lt, t);
}
function iD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(lt, t);
}
function aD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(lt, t);
}
const yt = i`
    query MediaDataRoomActivation($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    activationType @client
    advertiserDatasetHash @client
    publisherDatasetHash @client
  }
}
    `;
function sD(e) {
  const t = { ...n, ...e };
  return o.useQuery(yt, t);
}
function uD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(yt, t);
}
function rD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(yt, t);
}
const Dt = i`
    query MediaDataRoomActivationType($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    enclaveId: id
    driverAttestationHash
    activationType @client
  }
}
    `;
function dD(e) {
  const t = { ...n, ...e };
  return o.useQuery(Dt, t);
}
function cD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Dt, t);
}
function pD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Dt, t);
}
const ht = i`
    query MediaDataRoomAudienceInsights($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    enclaveId: id
    driverAttestationHash
    activationType @client
    enableOverlapInsights @client
    advertiserDatasetHash @client
    publisherDatasetHash @client
  }
}
    `;
function mD(e) {
  const t = { ...n, ...e };
  return o.useQuery(ht, t);
}
function lD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ht, t);
}
function yD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ht, t);
}
const ft = i`
    query MediaDataRoomDatasetHashes($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    activationType @client
    advertiserDatasetHash @client
    publisherDatasetHash @client
  }
}
    `;
function DD(e) {
  const t = { ...n, ...e };
  return o.useQuery(ft, t);
}
function hD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ft, t);
}
function fD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ft, t);
}
const St = i`
    query MediaDataRoomHashes($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    enclaveId: id
    driverAttestationHash
  }
}
    `;
function SD(e) {
  const t = { ...n, ...e };
  return o.useQuery(St, t);
}
function bD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(St, t);
}
function gD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(St, t);
}
const bt = i`
    query MediaDataRoomMainbar($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    title: name @client
  }
}
    `;
function ND(e) {
  const t = { ...n, ...e };
  return o.useQuery(bt, t);
}
function RD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(bt, t);
}
function QD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(bt, t);
}
const gt = i`
    query LookalikeMediaDataRoomMainbar($id: String!) {
  publishedLookalikeMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    title
    isStopped
    deactivatedAt
  }
}
    `;
function PD(e) {
  const t = { ...n, ...e };
  return o.useQuery(gt, t);
}
function ID(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(gt, t);
}
function vD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(gt, t);
}
const Nt = i`
    query MediaDataRoomOrganizations($advertiserEmail: String!, $publisherEmail: String!) {
  advertiserOrganization: userByEmail(email: $advertiserEmail) {
    id
    organizationLogo
    organization {
      id
      name
    }
  }
  publisherOrganization: userByEmail(email: $publisherEmail) {
    id
    organizationLogo
    organization {
      id
      name
    }
  }
}
    `;
function $D(e) {
  const t = { ...n, ...e };
  return o.useQuery(Nt, t);
}
function CD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Nt, t);
}
function AD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Nt, t);
}
const Rt = i`
    query MediaDataRoomSummary($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    name @client
    activationDownloadByAdvertiser @client
    activationDownloadByPublisher @client
    activationDownloadByAgency @client
    activationType @client
    advertiserUserEmails @client
    enableOverlapInsights @client
    observerUserEmails @client
    publisherUserEmails @client
    agencyUserEmails @client
  }
}
    `;
function MD(e) {
  const t = { ...n, ...e };
  return o.useQuery(Rt, t);
}
function LD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Rt, t);
}
function zD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Rt, t);
}
const pa = i`
    mutation MediaInviteParticipants($input: InviteParticipantsInput!) {
  publishedDataRoom {
    inviteParticipants(input: $input) {
      id
    }
  }
}
    `;
function HD(e) {
  const t = { ...n, ...e };
  return o.useMutation(pa, t);
}
const ma = i`
    mutation MediaInsightsInviteParticipants($input: InviteParticipantsInput!) {
  publishedDataRoom {
    inviteParticipants(input: $input) {
      id
    }
  }
}
    `;
function qD(e) {
  const t = { ...n, ...e };
  return o.useMutation(ma, t);
}
const la = i`
    mutation MediaUnpublishAdvertiserDataset($dataRoomId: String!, $driverAttestationHash: String!) {
  mediaUnpublishAdvertiserDataset(
    input: {dataRoomId: $dataRoomId, driverAttestationHash: $driverAttestationHash}
  ) @client
}
    `;
function TD(e) {
  const t = { ...n, ...e };
  return o.useMutation(la, t);
}
const ya = i`
    mutation MediaUnpublishPublisherDataset($dataRoomId: String!, $driverAttestationHash: String!) {
  mediaUnpublishPublisherDataset(
    input: {dataRoomId: $dataRoomId, driverAttestationHash: $driverAttestationHash}
  ) @client
}
    `;
function wD(e) {
  const t = { ...n, ...e };
  return o.useMutation(ya, t);
}
const Da = i`
    mutation MergeRemoteSubmittedDataRoomRequest($id: String!) {
  submittedDataRoomRequest {
    merge(submittedDataRoomRequestId: $id)
  }
}
    `;
function kD(e) {
  const t = { ...n, ...e };
  return o.useMutation(Da, t);
}
const ha = i`
    mutation MergeSubmittedDataRoomRequest($input: MergeSubmittedDataRoomRequestInput!) {
  mergeSubmittedDataRoomRequest(input: $input) @client
}
    `;
function FD(e) {
  const t = { ...n, ...e };
  return o.useMutation(ha, t);
}
const Qt = i`
    query MyDataRooms {
  dataRooms(
    filter: {isArchived: {equalTo: false}, isOwnedByUser: {equalTo: true}}
    sortBy: {updatedAt: DESCENDING}
  ) {
    nodes {
      ... on DraftDataRoom {
        ...NavigationDrawerDraftDataRoom
      }
      ... on PublishedDataRoom {
        ...NavigationDrawerPublishedDataRoom
      }
      ... on PublishedMediaDataRoom {
        ...NavigationDrawerPublishedMediaDataRoom
      }
      ... on PublishedLookalikeMediaDataRoom {
        ...NavigationDrawerPublishedLookalikeMediaDataRoom
      }
      ... on PublishedMediaInsightsDcr {
        ...NavigationDrawerPublishedMediaInsightsDcr
      }
    }
  }
}
    ${s}
${u}
${r}
${p}
${m}`;
function UD(e) {
  const t = { ...n, ...e };
  return o.useQuery(Qt, t);
}
function OD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Qt, t);
}
function ED(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Qt, t);
}
const Pt = i`
    query OrganizationComputeTimeout($organizationId: String!) {
  organization(id: $organizationId) {
    id
    quotas {
      containerWorkerMaxRuntimeSeconds
    }
  }
}
    `;
function JD(e) {
  const t = { ...n, ...e };
  return o.useQuery(Pt, t);
}
function xD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Pt, t);
}
function BD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Pt, t);
}
const It = i`
    query OrganizationDataRooms($organizationId: String!, $filter: OrganizationDataRoomFilter, $sortBy: DataRoomSortBy) {
  organization(id: $organizationId) {
    id
    participatingDataRooms(filter: $filter, sortBy: $sortBy) {
      nodes {
        id
        kind
        title
        createdAt
        owner {
          email
          id
          organization {
            id
            name
          }
        }
        ... on PublishedDataRoom {
          isActive
          deactivatedAt
        }
        ... on PublishedMediaDataRoom {
          isActive
          deactivatedAt
        }
        ... on PublishedLookalikeMediaDataRoom {
          isActive
          deactivatedAt
        }
        ... on PublishedMediaInsightsDcr {
          isActive
          deactivatedAt
        }
      }
    }
  }
}
    `;
function _D(e) {
  const t = { ...n, ...e };
  return o.useQuery(It, t);
}
function jD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(It, t);
}
function WD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(It, t);
}
const vt = i`
    query OrganizationDetails($organizationId: String!) {
  organization(id: $organizationId) {
    id
    createdAt
    createdBy {
      id
      email
    }
    updatedAt
  }
}
    `;
function GD(e) {
  const t = { ...n, ...e };
  return o.useQuery(vt, t);
}
function VD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(vt, t);
}
function ZD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(vt, t);
}
const $t = i`
    query OrganizationDomains($organizationId: String!) {
  organization(id: $organizationId) {
    id
    domains
  }
}
    `;
function KD(e) {
  const t = { ...n, ...e };
  return o.useQuery($t, t);
}
function XD(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery($t, t);
}
function YD(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery($t, t);
}
const Ct = i`
    query OrganizationEnclaveWorkers($organizationId: String!) {
  organization(id: $organizationId) {
    id
    workerTypes {
      nodes {
        id
        name
        shortName
      }
    }
  }
}
    `;
function eh(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ct, t);
}
function th(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ct, t);
}
function oh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ct, t);
}
const At = i`
    query OrganizationFeatures($organizationId: String!) {
  organization(id: $organizationId) {
    id
    microsoftDspMember
    hasAdvertiserFeatures
    hasAnalyticsFeatures
    hasPublisherFeatures
    useLegacyDataLabs
    skipMdcrAudiencesResettingOnDataLabChange
    hasDataPartnerFeatures
    canViewDataPartners
    hasDatalabFeatures
    canViewMeasurements
    allowExcludingSeedAudience
    enableAudienceBuilder
    enableDmp
    s3ExportState
    metaExportState
    googleDv360ExportState
    tradedeskExportState
    azureExportState
    googleCloudStorageExportState
    googleAdManagerExportState
    permutiveExportState
    sportradarExportState
    adformExportState
    microsoftDspExportState
    splickyExportState
    googleAdsExportState
    snapchatExportState
    tiktokExportState
    localImportState
    computeImportState
    s3ImportState
    snowflakeImportState
    salesforceImportState
    azureImportState
    googleCloudStorageImportState
    permutiveImportState
    databricksImportState
  }
}
    `;
function nh(e) {
  const t = { ...n, ...e };
  return o.useQuery(At, t);
}
function ih(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(At, t);
}
function ah(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(At, t);
}
const Mt = i`
    query OrganizationLicense($organizationId: String!) {
  organization(id: $organizationId) {
    id
    state
  }
}
    `;
function sh(e) {
  const t = { ...n, ...e };
  return o.useQuery(Mt, t);
}
function uh(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Mt, t);
}
function rh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Mt, t);
}
const Lt = i`
    query OrganizationLogo($organizationId: String!) {
  organization(id: $organizationId) {
    id
    logo
  }
}
    `;
function dh(e) {
  const t = { ...n, ...e };
  return o.useQuery(Lt, t);
}
function ch(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Lt, t);
}
function ph(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Lt, t);
}
const zt = i`
    query OrganizationMediaScope($organizationId: String!) {
  organization(id: $organizationId) {
    id
    mediaScope
  }
}
    `;
function mh(e) {
  const t = { ...n, ...e };
  return o.useQuery(zt, t);
}
function lh(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(zt, t);
}
function yh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(zt, t);
}
const Ht = i`
    query OrganizationMicrosoftDspMember($organizationId: String!) {
  organization(id: $organizationId) {
    id
    microsoftDspMember
  }
}
    `;
function Dh(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ht, t);
}
function hh(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ht, t);
}
function fh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ht, t);
}
const qt = i`
    query OrganizationName($organizationId: String!) {
  organization(id: $organizationId) {
    id
    name
  }
}
    `;
function Sh(e) {
  const t = { ...n, ...e };
  return o.useQuery(qt, t);
}
function bh(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(qt, t);
}
function gh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(qt, t);
}
const Tt = i`
    query OrganizationPage($organizationId: String!) {
  organization(id: $organizationId) {
    id
    name
    state
    hasPublisherFeatures
    hasDataPartnerFeatures
    canViewDataPartners
  }
}
    `;
function Nh(e) {
  const t = { ...n, ...e };
  return o.useQuery(Tt, t);
}
function Rh(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Tt, t);
}
function Qh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Tt, t);
}
const wt = i`
    query OrganizationPreferences($userEmail: String!) {
  userByEmail(email: $userEmail) {
    id
    email
    organization {
      id
      hasAdvertiserFeatures
      hasAnalyticsFeatures
      hasPublisherFeatures
      useLegacyDataLabs
      hasDataPartnerFeatures
      canViewDataPartners
      hasDatalabFeatures
      canViewMeasurements
      allowExcludingSeedAudience
      enableAudienceBuilder
      enableDmp
      state
    }
  }
}
    `;
function Ph(e) {
  const t = { ...n, ...e };
  return o.useQuery(wt, t);
}
function Ih(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(wt, t);
}
function vh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(wt, t);
}
const kt = i`
    query OrganizationUserEmails($organizationId: String!) {
  organization(id: $organizationId) {
    id
    userEmails: users {
      nodes {
        userId: id
        email
      }
    }
  }
}
    `;
function $h(e) {
  const t = { ...n, ...e };
  return o.useQuery(kt, t);
}
function Ch(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(kt, t);
}
function Ah(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(kt, t);
}
const Ft = i`
    query Organizations {
  organizations {
    nodes {
      id
      createdAt
      createdBy {
        id
        email
      }
      updatedAt
      name
      domains
      state
      hasAdvertiserFeatures
      hasAnalyticsFeatures
      hasPublisherFeatures
      hasDataPartnerFeatures
      canViewDataPartners
      hasDatalabFeatures
    }
  }
}
    `;
function Mh(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ft, t);
}
function Lh(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ft, t);
}
function zh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ft, t);
}
const Ut = i`
    query OwnOrganizationUserEmails {
  myself {
    organization {
      users {
        nodes {
          id
          email
        }
      }
    }
  }
}
    `;
function Hh(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ut, t);
}
function qh(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ut, t);
}
function Th(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ut, t);
}
const fa = i`
    mutation PollDatasetExport($id: String!) {
  pollDatasetExport(id: $id) @client {
    error
    success
  }
}
    `;
function wh(e) {
  const t = { ...n, ...e };
  return o.useMutation(fa, t);
}
const Sa = i`
    mutation PollDatasetImport($id: String!) {
  pollDatasetImport(id: $id) @client {
    success
    error
  }
}
    `;
function kh(e) {
  const t = { ...n, ...e };
  return o.useMutation(Sa, t);
}
const ba = i`
    mutation PostNodeCreate($input: CreateDraftPostNodeInput!) {
  draftPostNode {
    create(input: $input) {
      id
      name
      computationType
    }
  }
}
    `;
function Fh(e) {
  const t = { ...n, ...e };
  return o.useMutation(ba, t);
}
const ga = i`
    mutation PostNodeDelete($id: String!) {
  draftPostNode {
    delete(id: $id)
  }
}
    `;
function Uh(e) {
  const t = { ...n, ...e };
  return o.useMutation(ga, t);
}
const Na = i`
    mutation PostNodeNameEdit($input: UpdateDraftPostNodeInput!) {
  draftPostNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function Oh(e) {
  const t = { ...n, ...e };
  return o.useMutation(Na, t);
}
const Ot = i`
    query PreviewComputeNodeResult($id: String!) {
  computeJob(id: $id) {
    id
    autoFetching @client
  }
}
    `;
function Eh(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ot, t);
}
function Jh(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ot, t);
}
function xh(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ot, t);
}
const Ra = i`
    mutation PreviewNodeCreate($input: CreateDraftPreviewNodeInput!) {
  draftPreviewNode {
    create(input: $input) {
      id
      name
      quotaBytes
      computationType
    }
  }
}
    `;
function Bh(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ra, t);
}
const Qa = i`
    mutation PreviewNodeDelete($id: String!) {
  draftPreviewNode {
    delete(id: $id)
  }
}
    `;
function _h(e) {
  const t = { ...n, ...e };
  return o.useMutation(Qa, t);
}
const Pa = i`
    mutation PreviewNodeNameEdit($input: UpdateDraftPreviewNodeInput!) {
  draftPreviewNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function jh(e) {
  const t = { ...n, ...e };
  return o.useMutation(Pa, t);
}
const Ia = i`
    mutation ProvisionDataLab($input: ProvisionDataLabInput!) {
  dataLab {
    provisionDataLab(input: $input) {
      id
    }
  }
}
    `;
function Wh(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ia, t);
}
const va = i`
    mutation ProvisionDataLabToMediaInsightsDcr($input: ProvisionDataLabInput!) {
  dataLab {
    provisionDataLabToMediaInsightsDcr(input: $input) {
      id
      skipAudiencesResettingOnDataLabChange
    }
  }
}
    `;
function Gh(e) {
  const t = { ...n, ...e };
  return o.useMutation(va, t);
}
const $a = i`
    mutation PublishDataset($input: PublishDatasetInput!) {
  publishDataset(input: $input) @client {
    dataset {
      datasetHash
      leafId
      timestamp
      user
    }
  }
}
    `;
function Vh(e) {
  const t = { ...n, ...e };
  return o.useMutation($a, t);
}
const Ca = i`
    mutation PublishDraftDataRoom($input: PublishDraftDataRoomLocalInput!) {
  publishDraftDataRoom(input: $input) @client {
    id
  }
}
    `;
function Zh(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ca, t);
}
const Aa = i`
    mutation PublishDraftDataRoomRemote($input: PublishDraftDataRoomInput!) {
  draftDataRoom {
    publish(input: $input) {
      record {
        id
      }
      query {
        dataRooms(sortBy: {updatedAt: DESCENDING}) {
          nodes {
            ... on DraftDataRoom {
              ...NavigationDrawerDraftDataRoom
            }
            ... on PublishedDataRoom {
              ...NavigationDrawerPublishedDataRoom
            }
            ... on PublishedMediaDataRoom {
              ...NavigationDrawerPublishedMediaDataRoom
            }
          }
        }
      }
    }
  }
}
    ${s}
${u}
${r}`;
function Kh(e) {
  const t = { ...n, ...e };
  return o.useMutation(Aa, t);
}
const Ma = i`
    mutation MediaPublishDraftDataRoom($name: String!, $mainPublisherUserEmail: String!, $mainAdvertiserUserEmail: String!, $publisherUserEmails: [String!]!, $advertiserUserEmails: [String!]!, $observerUserEmails: [String!]!, $agencyUserEmails: [String!]!, $enableOverlapInsights: Boolean!, $activationType: ActivationType, $activationDownloadByPublisher: Boolean!, $activationDownloadByAdvertiser: Boolean!, $activationDownloadByAgency: Boolean!) {
  mediaPublishDraftDataRoom(
    input: {name: $name, mainPublisherUserEmail: $mainPublisherUserEmail, mainAdvertiserUserEmail: $mainAdvertiserUserEmail, publisherUserEmails: $publisherUserEmails, advertiserUserEmails: $advertiserUserEmails, observerUserEmails: $observerUserEmails, agencyUserEmails: $agencyUserEmails, enableOverlapInsights: $enableOverlapInsights, activationType: $activationType, activationDownloadByPublisher: $activationDownloadByPublisher, activationDownloadByAdvertiser: $activationDownloadByAdvertiser, activationDownloadByAgency: $activationDownloadByAgency}
  ) @client {
    id
    driverAttestationHash
  }
}
    `;
function Xh(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ma, t);
}
const La = i`
    mutation PublishMediaAdvertiserDataset($input: PublishMediaDatasetInput!) {
  mediaPublishAdvertiserDataset(input: $input) @client
}
    `;
function Yh(e) {
  const t = { ...n, ...e };
  return o.useMutation(La, t);
}
const za = i`
    mutation PublishMediaPublisherDataset($input: PublishMediaDatasetInput!) {
  mediaPublishPublisherDataset(input: $input) @client
}
    `;
function ef(e) {
  const t = { ...n, ...e };
  return o.useMutation(za, t);
}
const Et = i`
    query PublishedComputeNode($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    name
    ... on PublishedSqlNode {
      computationType
      job {
        id
        status
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedSqliteNode {
      computationType
      job {
        id
        status
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedMatchNode {
      computationType
      job {
        id
        status
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedPostNode {
      computationType
      job {
        id
        status
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedPreviewNode {
      computationType
      job {
        id
        status
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedScriptingNode {
      computationType
      job {
        id
        status
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedSyntheticNode {
      computationType
      job {
        id
        status
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedS3SinkNode {
      computationType
      job {
        id
        status
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
  }
}
    `;
function tf(e) {
  const t = { ...n, ...e };
  return o.useQuery(Et, t);
}
function of(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Et, t);
}
function nf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Et, t);
}
const Jt = i`
    query PublishedComputeNodeEditor($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
  }
}
    `;
function af(e) {
  const t = { ...n, ...e };
  return o.useQuery(Jt, t);
}
function sf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Jt, t);
}
function uf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Jt, t);
}
const xt = i`
    query PublishedComputeNodeJob($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    dcrHash
    driverAttestationHash
    commitId
    ... on PublishedSqlNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedSqliteNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedMatchNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedPostNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedPreviewNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedScriptingNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedSyntheticNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedS3SinkNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
  }
}
    `;
function rf(e) {
  const t = { ...n, ...e };
  return o.useQuery(xt, t);
}
function df(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(xt, t);
}
function cf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(xt, t);
}
const Bt = i`
    query PublishedComputeNodeName($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    name
  }
}
    `;
function pf(e) {
  const t = { ...n, ...e };
  return o.useQuery(Bt, t);
}
function mf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Bt, t);
}
function lf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Bt, t);
}
const _t = i`
    query PublishedComputeNodeParticipants($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    permissions {
      ... on PublishedAnalystPermission {
        participant {
          userEmail
        }
      }
    }
  }
}
    `;
function yf(e) {
  const t = { ...n, ...e };
  return o.useQuery(_t, t);
}
function Df(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(_t, t);
}
function hf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(_t, t);
}
const jt = i`
    query PublishedComputeNodeType($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    name
    ... on PublishedScriptingNode {
      computationType
      usesCustomPythonEnv
    }
    ... on PublishedSyntheticNode {
      computationType
    }
    ... on PublishedPostNode {
      computationType
    }
    ... on PublishedPreviewNode {
      computationType
    }
    ... on PublishedS3SinkNode {
      computationType
    }
    ... on PublishedMatchNode {
      computationType
    }
    ... on PublishedSqliteNode {
      computationType
      privacyFilter {
        minimumRows
      }
    }
    ... on PublishedSqlNode {
      computationType
      privacyFilter {
        minimumRows
      }
    }
  }
}
    `;
function ff(e) {
  const t = { ...n, ...e };
  return o.useQuery(jt, t);
}
function Sf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(jt, t);
}
function bf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(jt, t);
}
const Wt = i`
    query PublishedDataRoomDataNodes($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    publishedNodes @client {
      __typename
      id
      name
      permissions {
        ... on PublishedAnalystPermission {
          participant {
            userEmail
          }
        }
        ... on PublishedDataOwnerPermission {
          participant {
            userEmail
          }
        }
      }
      ... on PublishedRawLeafNode {
        isRequired
        dataset {
          datasetHash
          leafId
          timestamp
          user
        }
        testDataset {
          datasetHash
          leafId
          timestamp
          user
        }
      }
      ... on PublishedTableLeafNode {
        isRequired
        columns {
          name
          isNullable
          dataType
          formatType
          hashWith
        }
        uniqueColumnIds
        dataset {
          datasetHash
          leafId
          timestamp
          user
        }
        testDataset {
          datasetHash
          leafId
          timestamp
          user
        }
      }
    }
  }
}
    `;
function gf(e) {
  const t = { ...n, ...e };
  return o.useQuery(Wt, t);
}
function Nf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Wt, t);
}
function Rf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Wt, t);
}
const Gt = i`
    query PublishedDataRoomActions($id: String!) {
  publishedDataRoom(id: $id) {
    id
    driverAttestationHash
    name: title
    userSettings {
      id
      isArchived
      isFavorite
    }
    owner {
      email
    }
    updatedAt
    createdAt
    isStopped
    deactivatedAt
  }
}
    `;
function Qf(e) {
  const t = { ...n, ...e };
  return o.useQuery(Gt, t);
}
function Pf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Gt, t);
}
function If(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Gt, t);
}
const Vt = i`
    query PublishedDataRoomDataRoomHash($id: String!) {
  publishedDataRoom(id: $id) {
    id
    isStopped
    deactivatedAt
  }
}
    `;
function vf(e) {
  const t = { ...n, ...e };
  return o.useQuery(Vt, t);
}
function $f(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Vt, t);
}
function Cf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Vt, t);
}
const Zt = i`
    query PublishedDataRoomDescription($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    description @client
  }
}
    `;
function Af(e) {
  const t = { ...n, ...e };
  return o.useQuery(Zt, t);
}
function Mf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Zt, t);
}
function Lf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Zt, t);
}
const Ha = i`
    mutation PublishedDataRoomDuplicate($input: ImportDataScienceDataRoomInput!) {
  draftDataRoom {
    importDataScienceDataRoom(input: $input) {
      record {
        id
        title
        description
        owner {
          id
          email
        }
        logo
        enableInteractivity
        enableDevelopment
        userSettings {
          id
          isArchived
          isFavorite
        }
        createdAt
        draftNodes {
          nodes {
            id
            name
          }
        }
        editors {
          nodes {
            user {
              id
              email
            }
            role
          }
        }
        dataNodesOrder
        computeNodesOrder
        participants {
          nodes {
            id
            userEmail
            permissions {
              nodes {
                ... on DraftDataOwnerPermission {
                  node {
                    id
                    name
                  }
                }
                ... on DraftAnalystPermission {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
        query {
          dataRooms(
            filter: {isArchived: {equalTo: false}, isFavorite: {equalTo: false}, isOwnedByUser: {equalTo: true}}
            sortBy: {updatedAt: DESCENDING}
          ) {
            nodes {
              ... on DraftDataRoom {
                ...NavigationDrawerDraftDataRoom
              }
              ... on PublishedDataRoom {
                ...NavigationDrawerPublishedDataRoom
              }
              ... on PublishedMediaDataRoom {
                ...NavigationDrawerPublishedMediaDataRoom
              }
              ... on PublishedLookalikeMediaDataRoom {
                ...NavigationDrawerPublishedLookalikeMediaDataRoom
              }
              ... on PublishedMediaInsightsDcr {
                ...NavigationDrawerPublishedMediaInsightsDcr
              }
            }
          }
        }
      }
    }
  }
}
    ${s}
${u}
${r}
${p}
${m}`;
function zf(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ha, t);
}
const Kt = i`
    query PublishedDataRoomEnableImmutability($id: String!) {
  publishedDataRoom(id: $id) {
    id
    enableInteractivity @client
  }
}
    `;
function Hf(e) {
  const t = { ...n, ...e };
  return o.useQuery(Kt, t);
}
function qf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Kt, t);
}
function Tf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Kt, t);
}
const Xt = i`
    query PublishedDataRoomEnclaveConnectionParameters($id: String!) {
  publishedDataRoom(id: $id) {
    driverAttestationHash
  }
}
    `;
function wf(e) {
  const t = { ...n, ...e };
  return o.useQuery(Xt, t);
}
function kf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Xt, t);
}
function Ff(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Xt, t);
}
const Yt = i`
    query PublishedDataRoomIsFavorite($id: String!) {
  publishedDataRoom(id: $id) {
    id
    userSettings {
      id
      isFavorite
    }
  }
}
    `;
function Uf(e) {
  const t = { ...n, ...e };
  return o.useQuery(Yt, t);
}
function Of(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Yt, t);
}
function Ef(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Yt, t);
}
const eo = i`
    query PublishedDataRoomIsHidden($id: String!) {
  publishedDataRoom(id: $id) {
    id
    userSettings {
      id
      isHidden: isArchived
    }
  }
}
    `;
function Jf(e) {
  const t = { ...n, ...e };
  return o.useQuery(eo, t);
}
function xf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(eo, t);
}
function Bf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(eo, t);
}
const to = i`
    query PublishedDataRoomLogo($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    showOrganizationLogo
    logo
  }
}
    `;
function _f(e) {
  const t = { ...n, ...e };
  return o.useQuery(to, t);
}
function jf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(to, t);
}
function Wf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(to, t);
}
const oo = i`
    query PublishedDataRoomLowLevelRepresentation($id: String!) {
  publishedDataRoom(id: $id) {
    id
    name: title
    lowLevelRepresentation @client
  }
}
    `;
function Gf(e) {
  const t = { ...n, ...e };
  return o.useQuery(oo, t);
}
function Vf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(oo, t);
}
function Zf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(oo, t);
}
const no = i`
    query PublishedDataRoomName($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    name: title
  }
}
    `;
function Kf(e) {
  const t = { ...n, ...e };
  return o.useQuery(no, t);
}
function Xf(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(no, t);
}
function Yf(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(no, t);
}
const io = i`
    query PublishedDataRoomNodes($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    publishedNodes @client {
      __typename
      id
      name
      permissions {
        ... on PublishedAnalystPermission {
          participant {
            userEmail
          }
        }
        ... on PublishedDataOwnerPermission {
          participant {
            userEmail
          }
        }
      }
      ... on PublishedTableLeafNode {
        isRequired
        columns {
          name
          dataType
          isNullable
          formatType
          hashWith
        }
        dataset {
          datasetHash
          leafId
          timestamp
          user
        }
      }
      ... on PublishedRawLeafNode {
        isRequired
        dataset {
          datasetHash
          leafId
          timestamp
          user
        }
      }
      ... on PublishedScriptingNode {
        scripts {
          name
          content
          isMainScript
        }
        computationType
        dependencies {
          id
          name
        }
        job {
          id
          enclaveComputeJobId
          status
          updatedAt
          createdAt
          driverAttestationHash
          dataRoomHash
          purpose
        }
        output
        scriptingLanguage
        usesCustomPythonEnv
      }
      ... on PublishedSqlNode {
        statement
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
        job {
          id
          enclaveComputeJobId
          status
          updatedAt
          createdAt
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on PublishedSqliteNode {
        statement
        computationType
        privacyFilter {
          minimumRows
          isEnabled
        }
        job {
          id
          enclaveComputeJobId
          status
          updatedAt
          createdAt
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on PublishedMatchNode {
        computationType
        job {
          id
          enclaveComputeJobId
          status
          updatedAt
          createdAt
          driverAttestationHash
          dataRoomHash
          purpose
        }
        config
      }
      ... on PublishedSyntheticNode {
        id
        name
        accuracy
        computationType
        includeReportWithStats
        dependency {
          id
          name
        }
        columns {
          name
          shouldMaskColumn
          index
          maskType
          dataType
        }
        job {
          id
          enclaveComputeJobId
          status
          updatedAt
          createdAt
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on PublishedPostNode {
        id
        name
        computationType
        dependency {
          id
          name
        }
        job {
          id
          enclaveComputeJobId
          status
          updatedAt
          createdAt
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on PublishedPreviewNode {
        id
        name
        usedQuotaBytes
        remainingQuotaBytes
        totalQuotaBytes
        dependency {
          __typename
          id
          name
          permissions {
            ... on PublishedAnalystPermission {
              participant {
                userEmail
              }
            }
            ... on PublishedDataOwnerPermission {
              participant {
                userEmail
              }
            }
          }
          ... on PublishedTableLeafNode {
            isRequired
            columns {
              name
              dataType
              isNullable
              formatType
              hashWith
            }
            dataset {
              datasetHash
              leafId
              timestamp
              user
            }
          }
          ... on PublishedRawLeafNode {
            isRequired
            dataset {
              datasetHash
              leafId
              timestamp
              user
            }
          }
          ... on PublishedScriptingNode {
            scripts {
              name
              content
              isMainScript
            }
            computationType
            dependencies {
              id
              name
            }
            job {
              id
              enclaveComputeJobId
              status
              updatedAt
              createdAt
              driverAttestationHash
              dataRoomHash
              purpose
            }
            output
            scriptingLanguage
            usesCustomPythonEnv
          }
          ... on PublishedSqlNode {
            statement
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
            job {
              id
              enclaveComputeJobId
              status
              updatedAt
              createdAt
              driverAttestationHash
              dataRoomHash
              purpose
            }
          }
          ... on PublishedSqliteNode {
            statement
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
            job {
              id
              enclaveComputeJobId
              status
              updatedAt
              createdAt
              driverAttestationHash
              dataRoomHash
              purpose
            }
          }
          ... on PublishedMatchNode {
            computationType
            job {
              id
              enclaveComputeJobId
              status
              updatedAt
              createdAt
              driverAttestationHash
              dataRoomHash
              purpose
            }
            config
          }
          ... on PublishedSyntheticNode {
            id
            name
            accuracy
            computationType
            includeReportWithStats
            dependency {
              id
              name
            }
            columns {
              name
              shouldMaskColumn
              index
              maskType
              dataType
            }
            job {
              id
              enclaveComputeJobId
              status
              updatedAt
              createdAt
              driverAttestationHash
              dataRoomHash
              purpose
            }
          }
          ... on PublishedPostNode {
            id
            name
            computationType
            dependency {
              id
              name
            }
            job {
              id
              enclaveComputeJobId
              status
              updatedAt
              createdAt
              driverAttestationHash
              dataRoomHash
              purpose
            }
          }
          ... on PublishedPreviewNode {
            id
            name
            usedQuotaBytes
            remainingQuotaBytes
            totalQuotaBytes
            dependency {
              id
              name
            }
            job {
              id
              enclaveComputeJobId
              status
              updatedAt
              createdAt
              driverAttestationHash
              dataRoomHash
              purpose
            }
          }
          ... on PublishedS3SinkNode {
            id
            name
            endpoint
            computationType
            region
            credentialsDependency {
              id
              name
            }
            job {
              id
              enclaveComputeJobId
              status
              updatedAt
              createdAt
              driverAttestationHash
              dataRoomHash
              purpose
            }
          }
        }
        job {
          id
          enclaveComputeJobId
          status
          updatedAt
          createdAt
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on PublishedS3SinkNode {
        id
        name
        endpoint
        computationType
        region
        credentialsDependency {
          id
          name
        }
        job {
          id
          enclaveComputeJobId
          status
          updatedAt
          createdAt
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
    }
  }
}
    `;
function eS(e) {
  const t = { ...n, ...e };
  return o.useQuery(io, t);
}
function tS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(io, t);
}
function oS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(io, t);
}
const ao = i`
    query PublishedDataRoom($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    owner {
      email
    }
    driverAttestationHash
    deactivatedAt
    enableAirlock @client
    enableInteractivity @client
    enableDevelopment @client
    isStopped
    createdAt
    testing @client
    publishedNodes @client {
      __typename
      permissions {
        ... on PublishedAnalystPermission {
          participant {
            userEmail
          }
        }
        ... on PublishedDataOwnerPermission {
          participant {
            userEmail
          }
        }
      }
    }
    source @client
    enableAutomergeFeature @client
    enableTestDatasets @client
    submittedRequests {
      nodes {
        id
      }
    }
  }
}
    `;
function nS(e) {
  const t = { ...n, ...e };
  return o.useQuery(ao, t);
}
function iS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ao, t);
}
function aS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ao, t);
}
const so = i`
    query PublishedDataRoomOverview($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    name: title
    createdAt
    owner {
      id
      email
    }
    ownerOrganization {
      name
    }
    userSettings {
      ...DataRoomUserSettings
    }
    activatedAt
    stoppedAt
    driverAttestationHash
    isStopped
    isActive
    deactivatedAt
    updatedAt
    participantUsers {
      nodes {
        id
        userEmail: email
        organization {
          id
          name
        }
      }
    }
    datasetPublications {
      nodes {
        dataset {
          id
          manifestHash
          name
        }
      }
    }
  }
}
    ${c}`;
function sS(e) {
  const t = { ...n, ...e };
  return o.useQuery(so, t);
}
function uS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(so, t);
}
function rS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(so, t);
}
const uo = i`
    query PublishedDataRoomParticipants($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    participants @client {
      userEmail
      permissions {
        ... on PublishedAnalystPermission {
          node {
            id
          }
        }
        ... on PublishedDataOwnerPermission {
          node {
            id
          }
        }
      }
    }
  }
}
    `;
function dS(e) {
  const t = { ...n, ...e };
  return o.useQuery(uo, t);
}
function cS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(uo, t);
}
function pS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(uo, t);
}
const ro = i`
    query PublishedDataRoomPasswordRequirements($id: String!) {
  publishedDataRoom(id: $id) {
    id
    driverAttestationHash
    requirePassword
    password @client
    createdAt
  }
}
    `;
function mS(e) {
  const t = { ...n, ...e };
  return o.useQuery(ro, t);
}
function lS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ro, t);
}
function yS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ro, t);
}
const co = i`
    query PublishedDataRoomStopData($id: String!) {
  publishedDataRoom(id: $id) {
    id
    driverAttestationHash
  }
}
    `;
function DS(e) {
  const t = { ...n, ...e };
  return o.useQuery(co, t);
}
function hS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(co, t);
}
function fS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(co, t);
}
const po = i`
    query PublishedDataRoomTesting($id: String!) {
  publishedDataRoom(id: $id) {
    id
    testing @client
  }
}
    `;
function SS(e) {
  const t = { ...n, ...e };
  return o.useQuery(po, t);
}
function bS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(po, t);
}
function gS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(po, t);
}
const mo = i`
    query PublishedLookalikeMediaDataRoomStopData($id: String!) {
  publishedLookalikeMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    deactivatedAt
    isStopped
  }
}
    `;
function NS(e) {
  const t = { ...n, ...e };
  return o.useQuery(mo, t);
}
function RS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(mo, t);
}
function QS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(mo, t);
}
const lo = i`
    query PublishedLookalikeMediaDataRoom($id: String!) {
  publishedLookalikeMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    isStopped
    isActive
    deactivatedAt
    createdAt
  }
}
    `;
function PS(e) {
  const t = { ...n, ...e };
  return o.useQuery(lo, t);
}
function IS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(lo, t);
}
function vS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(lo, t);
}
const yo = i`
    query PublishedLookalikeMediaDataRoomActions($id: String!) {
  publishedLookalikeMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    name: title
    userSettings {
      id
      isArchived
      isFavorite
    }
    owner {
      id
      email
    }
    updatedAt
    createdAt
    isStopped
    deactivatedAt
  }
}
    `;
function $S(e) {
  const t = { ...n, ...e };
  return o.useQuery(yo, t);
}
function CS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(yo, t);
}
function AS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(yo, t);
}
const Do = i`
    query PublishedLookalikeMediaDataRoomDataLabData($id: String!) {
  publishedLookalikeMediaDataRoom(id: $id) {
    id
    wasDataLabPublishedBefore
    publishedDataLab {
      ...FullDataLab
    }
  }
}
    ${a}`;
function MS(e) {
  const t = { ...n, ...e };
  return o.useQuery(Do, t);
}
function LS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Do, t);
}
function zS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Do, t);
}
const ho = i`
    query PublishedLookalikeMediaDataRoomIsFavorite($id: String!) {
  publishedLookalikeMediaDataRoom(id: $id) {
    id
    userSettings {
      id
      isFavorite
    }
  }
}
    `;
function HS(e) {
  const t = { ...n, ...e };
  return o.useQuery(ho, t);
}
function qS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ho, t);
}
function TS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ho, t);
}
const fo = i`
    query PublishedLookalikeMediaDataRoomIsHidden($id: String!) {
  publishedLookalikeMediaDataRoom(id: $id) {
    id
    userSettings {
      id
      isHidden: isArchived
    }
  }
}
    `;
function wS(e) {
  const t = { ...n, ...e };
  return o.useQuery(fo, t);
}
function kS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(fo, t);
}
function FS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(fo, t);
}
const So = i`
    query PublishedLookalikeMediaDataRoomOrganizations($advertiserEmail: String!, $publisherEmail: String!) {
  advertiserOrganization: userByEmail(email: $advertiserEmail) {
    id
    organizationLogo
    organization {
      id
      name
    }
  }
  publisherOrganization: userByEmail(email: $publisherEmail) {
    id
    organizationLogo
    organization {
      id
      name
    }
  }
}
    `;
function US(e) {
  const t = { ...n, ...e };
  return o.useQuery(So, t);
}
function OS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(So, t);
}
function ES(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(So, t);
}
const bo = i`
    query PublishedLookalikeMediaDataRoomOverview($dataRoomId: String!) {
  publishedLookalikeMediaDataRoom(id: $dataRoomId) {
    id
    name: title
    createdAt
    owner {
      id
      email
    }
    ownerOrganization {
      name
    }
    userSettings {
      ...DataRoomUserSettings
    }
    activatedAt
    driverAttestationHash
    isStopped
    isActive
    deactivatedAt
    stoppedAt
    updatedAt
    participantUsers {
      nodes {
        id
        userEmail: email
        organization {
          id
          name
        }
      }
    }
    wasDataLabPublishedBefore
    publishedDataLab {
      id
      name
      owner {
        id
        email
        organization {
          id
          name
        }
      }
    }
    datasetPublications {
      nodes {
        dataset {
          id
          manifestHash
          name
        }
      }
    }
  }
}
    ${c}`;
function JS(e) {
  const t = { ...n, ...e };
  return o.useQuery(bo, t);
}
function xS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(bo, t);
}
function BS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(bo, t);
}
const go = i`
    query PublishedMatchNodeConfig($commitId: HexString, $dcrHash: HexString!, $driverAttestationHash: HexString!, $id: String!) {
  publishedNode(
    commitId: $commitId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    id: $id
  ) {
    id
    ... on PublishedMatchNode {
      config
    }
  }
}
    `;
function _S(e) {
  const t = { ...n, ...e };
  return o.useQuery(go, t);
}
function jS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(go, t);
}
function WS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(go, t);
}
const No = i`
    query PublishedMatchNodeDependencies($commitId: HexString, $dcrHash: HexString!, $driverAttestationHash: HexString!, $id: String!) {
  publishedNode(
    commitId: $commitId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    id: $id
  ) {
    id
    ... on PublishedMatchNode {
      dependencies {
        ... on PublishedNode {
          id
        }
      }
    }
  }
}
    `;
function GS(e) {
  const t = { ...n, ...e };
  return o.useQuery(No, t);
}
function VS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(No, t);
}
function ZS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(No, t);
}
const Ro = i`
    query PublishedMediaDataRoom($id: String!) {
  publishedMediaDataRoom: publishedMediaInsightsDcr(id: $id) {
    id
    name: title
    driverAttestationHash
    isStopped
    isActive
    kind
    deactivatedAt
    createdAt
    skipAudiencesResettingOnDataLabChange
  }
}
    `;
function KS(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ro, t);
}
function XS(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ro, t);
}
function YS(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ro, t);
}
const Qo = i`
    query PublishedMediaDataRoomActions($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    driverAttestationHash
    name: title
    userSettings {
      id
      isArchived
      isFavorite
    }
    owner {
      id
      email
    }
    updatedAt
    createdAt
    isStopped
    deactivatedAt
  }
}
    `;
function eb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Qo, t);
}
function tb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Qo, t);
}
function ob(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Qo, t);
}
const Po = i`
    query PublishedMediaDataRoomIsFavorite($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    userSettings {
      id
      isFavorite
    }
  }
}
    `;
function nb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Po, t);
}
function ib(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Po, t);
}
function ab(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Po, t);
}
const Io = i`
    query PublishedMediaDataRoomIsHidden($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    userSettings {
      id
      isHidden: isArchived
    }
  }
}
    `;
function sb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Io, t);
}
function ub(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Io, t);
}
function rb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Io, t);
}
const vo = i`
    query PublishedMediaDataRoomOverview($dataRoomId: String!) {
  publishedMediaDataRoom(id: $dataRoomId) {
    id
    name: title
    createdAt
    owner {
      id
      email
    }
    ownerOrganization {
      name
    }
    userSettings {
      ...DataRoomUserSettings
    }
    activatedAt
    driverAttestationHash
    isStopped
    isActive
    deactivatedAt
    stoppedAt
    updatedAt
    participantUsers {
      nodes {
        id
        userEmail: email
        organization {
          id
          name
        }
      }
    }
    datasetPublications {
      nodes {
        dataset {
          id
          manifestHash
          name
        }
      }
    }
  }
}
    ${c}`;
function db(e) {
  const t = { ...n, ...e };
  return o.useQuery(vo, t);
}
function cb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(vo, t);
}
function pb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(vo, t);
}
const $o = i`
    query PublishedMediaDataRoomStopData($id: String!) {
  publishedMediaDataRoom(id: $id) {
    id
    driverAttestationHash
  }
}
    `;
function mb(e) {
  const t = { ...n, ...e };
  return o.useQuery($o, t);
}
function lb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery($o, t);
}
function yb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery($o, t);
}
const Co = i`
    query PublishedMediaInsightsDcrActions($id: String!) {
  publishedMediaInsightsDcr(id: $id) {
    id
    driverAttestationHash
    name: title
    userSettings {
      id
      isArchived
      isFavorite
    }
    owner {
      id
      email
    }
    updatedAt
    createdAt
    isStopped
    deactivatedAt
  }
}
    `;
function Db(e) {
  const t = { ...n, ...e };
  return o.useQuery(Co, t);
}
function hb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Co, t);
}
function fb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Co, t);
}
const Ao = i`
    query PublishedMediaInsightsDcrDataLabData($id: String!) {
  publishedMediaInsightsDcr(id: $id) {
    id
    wasDataLabPublishedBefore
    skipAudiencesResettingOnDataLabChange
    publishedDataLab {
      ...FullDataLab
    }
  }
}
    ${a}`;
function Sb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ao, t);
}
function bb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ao, t);
}
function gb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ao, t);
}
const Mo = i`
    query PublishedMediaInsightsDcrIsFavorite($id: String!) {
  publishedMediaInsightsDcr(id: $id) {
    id
    userSettings {
      id
      isFavorite
    }
  }
}
    `;
function Nb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Mo, t);
}
function Rb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Mo, t);
}
function Qb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Mo, t);
}
const Lo = i`
    query PublishedMediaInsightsDcrIsHidden($id: String!) {
  publishedMediaInsightsDcr(id: $id) {
    id
    userSettings {
      id
      isHidden: isArchived
    }
  }
}
    `;
function Pb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Lo, t);
}
function Ib(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Lo, t);
}
function vb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Lo, t);
}
const zo = i`
    query PublishedMediaInsightsDcrOrganizations($advertiserEmail: String!, $publisherEmail: String!) {
  advertiserOrganization: userByEmail(email: $advertiserEmail) {
    id
    organizationLogo
    organization {
      id
      name
    }
  }
  publisherOrganization: userByEmail(email: $publisherEmail) {
    id
    organizationLogo
    organization {
      id
      name
    }
  }
}
    `;
function $b(e) {
  const t = { ...n, ...e };
  return o.useQuery(zo, t);
}
function Cb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(zo, t);
}
function Ab(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(zo, t);
}
const Ho = i`
    query PublishedMediaInsightsDcrOverview($dataRoomId: String!) {
  publishedMediaInsightsDcr(id: $dataRoomId) {
    id
    kind
    name: title
    createdAt
    owner {
      id
      email
    }
    ownerOrganization {
      name
    }
    userSettings {
      ...DataRoomUserSettings
    }
    activatedAt
    driverAttestationHash
    isStopped
    isActive
    deactivatedAt
    stoppedAt
    updatedAt
    participantUsers {
      nodes {
        id
        userEmail: email
        organization {
          id
          name
        }
      }
    }
    wasDataLabPublishedBefore
    publishedDataLab {
      id
      name
      owner {
        id
        email
        organization {
          id
          name
        }
      }
    }
    datasetPublications {
      nodes {
        dataset {
          id
          manifestHash
          name
        }
      }
    }
  }
}
    ${c}`;
function Mb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ho, t);
}
function Lb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ho, t);
}
function zb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ho, t);
}
const qo = i`
    query PublishedMediaInsightsDcrStopData($id: String!) {
  publishedMediaInsightsDcr(id: $id) {
    id
    driverAttestationHash
    deactivatedAt
    isStopped
  }
}
    `;
function Hb(e) {
  const t = { ...n, ...e };
  return o.useQuery(qo, t);
}
function qb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(qo, t);
}
function Tb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(qo, t);
}
const To = i`
    query PublishedNodeId($nodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $nodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
  }
}
    `;
function wb(e) {
  const t = { ...n, ...e };
  return o.useQuery(To, t);
}
function kb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(To, t);
}
function Fb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(To, t);
}
const wo = i`
    query PublishedNodeTypename($id: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $id
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    name
    dcrHash
    driverAttestationHash
    commitId
  }
}
    `;
function Ub(e) {
  const t = { ...n, ...e };
  return o.useQuery(wo, t);
}
function Ob(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(wo, t);
}
function Eb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(wo, t);
}
const ko = i`
    query PublishedTableLeafNodeUniqueness($id: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $id
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    ... on PublishedTableLeafNode {
      uniqueColumnIds
    }
  }
}
    `;
function Jb(e) {
  const t = { ...n, ...e };
  return o.useQuery(ko, t);
}
function xb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ko, t);
}
function Bb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ko, t);
}
const Fo = i`
    query PublishedNodesTypenames($dataRoomId: String!) {
  publishedDataRoom(id: $dataRoomId) {
    id
    publishedNodes @client {
      id
      name
    }
  }
}
    `;
function _b(e) {
  const t = { ...n, ...e };
  return o.useQuery(Fo, t);
}
function jb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Fo, t);
}
function Wb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Fo, t);
}
const Uo = i`
    query PublishedPostComputeNode($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedPostNode {
      id
      name
      computationType
      dependency {
        id
        name
      }
    }
  }
}
    `;
function Gb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Uo, t);
}
function Vb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Uo, t);
}
function Zb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Uo, t);
}
const Oo = i`
    query PublishedPreviewComputeNode($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedPreviewNode {
      id
      name
      usedQuotaBytes
      remainingQuotaBytes
      totalQuotaBytes
      computationType
      dependency {
        id
        name
      }
    }
  }
}
    `;
function Kb(e) {
  const t = { ...n, ...e };
  return o.useQuery(Oo, t);
}
function Xb(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Oo, t);
}
function Yb(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Oo, t);
}
const Eo = i`
    query PublishedPrivacyFilter($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedSqlNode {
      id
      privacyFilter {
        minimumRows
        isEnabled
      }
    }
  }
}
    `;
function eg(e) {
  const t = { ...n, ...e };
  return o.useQuery(Eo, t);
}
function tg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Eo, t);
}
function og(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Eo, t);
}
const Jo = i`
    query PublishedS3ConnectionParams($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedS3SinkNode {
      id
      name
      endpoint
      region
      credentialsDependency {
        id
        name
      }
    }
  }
}
    `;
function ng(e) {
  const t = { ...n, ...e };
  return o.useQuery(Jo, t);
}
function ig(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Jo, t);
}
function ag(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Jo, t);
}
const xo = i`
    query PublishedS3ObjectUploadDependency($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedS3SinkNode {
      id
      uploadDependency {
        id
        name
      }
    }
  }
}
    `;
function sg(e) {
  const t = { ...n, ...e };
  return o.useQuery(xo, t);
}
function ug(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(xo, t);
}
function rg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(xo, t);
}
const Bo = i`
    query PublishedScriptingComputeNode($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedScriptingNode {
      id
      name
      computationType
      scripts {
        name
        content
        isMainScript
      }
      dependencies {
        id
        name
      }
      output
      scriptingLanguage
      usesCustomPythonEnv
    }
  }
}
    `;
function dg(e) {
  const t = { ...n, ...e };
  return o.useQuery(Bo, t);
}
function cg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Bo, t);
}
function pg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Bo, t);
}
const _o = i`
    query PublishedSqlComputeNode($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedSqlNode {
      id
      name
      computationType
      statement
    }
    ... on PublishedSqliteNode {
      id
      name
      computationType
      statement
    }
  }
}
    `;
function mg(e) {
  const t = { ...n, ...e };
  return o.useQuery(_o, t);
}
function lg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(_o, t);
}
function yg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(_o, t);
}
const jo = i`
    query PublishedSyntheticComputeNode($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    ... on PublishedSyntheticNode {
      dependency {
        id
        name
      }
    }
  }
}
    `;
function Dg(e) {
  const t = { ...n, ...e };
  return o.useQuery(jo, t);
}
function hg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(jo, t);
}
function fg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(jo, t);
}
const Wo = i`
    query PublishedSyntheticNodeAccuracy($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedSyntheticNode {
      id
      accuracy
    }
  }
}
    `;
function Sg(e) {
  const t = { ...n, ...e };
  return o.useQuery(Wo, t);
}
function bg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Wo, t);
}
function gg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Wo, t);
}
const Go = i`
    query PublishedSyntheticNodeDataSource($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedSyntheticNode {
      id
      dependency {
        id
        name
      }
    }
  }
}
    `;
function Ng(e) {
  const t = { ...n, ...e };
  return o.useQuery(Go, t);
}
function Rg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Go, t);
}
function Qg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Go, t);
}
const Vo = i`
    query PublishedSyntheticNodeDependency($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    name
    ... on PublishedTableLeafNode {
      columns {
        name
        dataType
        isNullable
        formatType
        hashWith
      }
    }
  }
}
    `;
function Pg(e) {
  const t = { ...n, ...e };
  return o.useQuery(Vo, t);
}
function Ig(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Vo, t);
}
function vg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Vo, t);
}
const Zo = i`
    query PublishedSyntheticNodeIncludeStatistics($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    ... on PublishedSyntheticNode {
      id
      includeReportWithStats
    }
  }
}
    `;
function $g(e) {
  const t = { ...n, ...e };
  return o.useQuery(Zo, t);
}
function Cg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Zo, t);
}
function Ag(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Zo, t);
}
const Ko = i`
    query PublishedSyntheticNodeMasking($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    name
    ... on PublishedSyntheticNode {
      columns {
        name
        shouldMaskColumn
        index
        maskType
        dataType
      }
      dependency {
        id
      }
    }
  }
}
    `;
function Mg(e) {
  const t = { ...n, ...e };
  return o.useQuery(Ko, t);
}
function Lg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Ko, t);
}
function zg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Ko, t);
}
const Xo = i`
    query GetPublisherDisplayConfiguration($id: String!, $isAdmin: Boolean!) {
  ownOrganization: myself @skip(if: $isAdmin) {
    organization {
      publisherDisplayConfiguration {
        id
        publisherName
        description
        collaborationRequestUsers
        logo
        marketIds
      }
    }
  }
  otherOrganization: organization(id: $id) @include(if: $isAdmin) {
    publisherDisplayConfiguration {
      id
      publisherName
      description
      collaborationRequestUsers
      logo
      marketIds
    }
  }
}
    `;
function Hg(e) {
  const t = { ...n, ...e };
  return o.useQuery(Xo, t);
}
function qg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Xo, t);
}
function Tg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Xo, t);
}
const Yo = i`
    query PublisherPortalOverview {
  organizations {
    nodes {
      id
      name
      mediaScope
      publisherDisplayConfiguration {
        id
        publisherName
        description
        marketIds
        collaborationRequestUsers
      }
      activationConfigurations {
        nodes {
          id
          name
          matchingIdFormat
          matchingIdHashingAlgorithm
          allowInsights
          allowLookalike
          allowRetargeting
          allowMeasurements
          allowExclusionTargeting
          allowRuleBasedAudiences
          matchAnyDomain
          publisherParticipants
          advertiserDomains
        }
      }
      dataPartnerDisplayConfiguration {
        id
        name
        description
        marketIds
        collaborationRequestUsers
      }
      dataPartnerUsageConfigurations {
        nodes {
          name
          matchingIdFormat
          matchingIdHashingAlgorithm
          allowInsights
          allowLookalike
          allowRetargeting
          allowExclusionTargeting
          allowRuleBasedAudiences
          matchAnyDomain
          participants
          advertiserDomains
        }
      }
    }
  }
}
    `;
function wg(e) {
  const t = { ...n, ...e };
  return o.useQuery(Yo, t);
}
function kg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Yo, t);
}
function Fg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Yo, t);
}
const qa = i`
    mutation RebaseSubmittedDataRoomRequest($input: RebaseSubmittedDataRoomRequestInput!) {
  submittedDataRoomRequest {
    rebase(input: $input) {
      id
      enclaveCommitId
      enclaveConfigurationPin
      signers {
        nodes {
          id
          userEmail
          user {
            id
            email
          }
          signature
        }
      }
      owner {
        id
        email
      }
      createdAt
      updatedAt
      node @client {
        __typename
        id
        name
        dcrHash
        driverAttestationHash
        commitId
        permissions {
          ... on PublishedAnalystPermission {
            participant {
              userEmail
            }
          }
          ... on PublishedDataOwnerPermission {
            participant {
              userEmail
            }
          }
        }
        ... on PublishedScriptingNode {
          computationType
          output
          scriptingLanguage
          scripts {
            name
            content
            isMainScript
          }
          dependencies {
            __typename
            id
            name
            dcrHash
            driverAttestationHash
            commitId
          }
          usesCustomPythonEnv
        }
        ... on PublishedSqlNode {
          computationType
          privacyFilter {
            minimumRows
            isEnabled
          }
          dependencies {
            __typename
            id
            name
            dcrHash
            driverAttestationHash
            commitId
          }
          statement
        }
        ... on PublishedSqliteNode {
          computationType
          privacyFilter {
            minimumRows
            isEnabled
          }
          dependencies {
            __typename
            id
            name
            dcrHash
            driverAttestationHash
            commitId
          }
          statement
        }
        ... on PublishedMatchNode {
          computationType
          dependencies {
            __typename
            id
            name
            dcrHash
            driverAttestationHash
            commitId
          }
          config
        }
        ... on PublishedSyntheticNode {
          computationType
          accuracy
          includeReportWithStats
          dependency {
            __typename
            id
            name
            dcrHash
            driverAttestationHash
            commitId
          }
          columns {
            name
            shouldMaskColumn
            index
            maskType
            dataType
          }
        }
        ... on PublishedPostNode {
          computationType
          dependency {
            __typename
            id
            dcrHash
            driverAttestationHash
            commitId
          }
        }
        ... on PublishedPreviewNode {
          computationType
          dependency {
            __typename
            id
            dcrHash
            driverAttestationHash
            commitId
          }
        }
        ... on PublishedS3SinkNode {
          endpoint
          computationType
          region
          credentialsDependency {
            __typename
            id
            name
            dcrHash
            driverAttestationHash
            commitId
          }
          uploadDependency {
            __typename
            id
            name
            dcrHash
            driverAttestationHash
            commitId
          }
        }
      }
    }
  }
}
    `;
function Ug(e) {
  const t = { ...n, ...e };
  return o.useMutation(qa, t);
}
const Ta = i`
    mutation RebaseSubmittedRequest($input: RebaseSubmittedDataRoomRequestLocalInput!) {
  rebaseSubmittedDataRoomRequest(input: $input) @client {
    id
  }
}
    `;
function Og(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ta, t);
}
const wa = i`
    mutation RemoveScriptingNodeDependency($computeNodeId: String!, $dependencyId: NodeId!) {
  draftScriptingNode {
    removeDependency(id: $computeNodeId, dependencyId: $dependencyId) {
      id
      dependencies {
        nodes {
          ... on DraftNodeConnection {
            draftNode {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
function Eg(e) {
  const t = { ...n, ...e };
  return o.useMutation(wa, t);
}
const en = i`
    query RequestComputeNodeActions($requestId: String!) {
  dataRoomRequest(id: $requestId) {
    id
    draftNode {
      id
      ... on DraftMatchNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on DraftSqlNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on DraftSqliteNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on DraftSqliteNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on DraftPostNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on DraftPreviewNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on DraftScriptingNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on DraftSyntheticNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
      ... on DraftS3SinkNode {
        job @client {
          id
          enclaveComputeJobId
          status
          createdAt
          autoFetching
          driverAttestationHash
          dataRoomHash
          purpose
        }
      }
    }
  }
}
    `;
function Jg(e) {
  const t = { ...n, ...e };
  return o.useQuery(en, t);
}
function xg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(en, t);
}
function Bg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(en, t);
}
const tn = i`
    query RequestComputeNodePermissions($computeNodeId: String!) {
  draftNode(id: $computeNodeId) {
    id
    permissions {
      nodes {
        ... on DraftAnalystPermission {
          participant {
            id
            userEmail
          }
        }
      }
    }
  }
}
    `;
function _g(e) {
  const t = { ...n, ...e };
  return o.useQuery(tn, t);
}
function jg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(tn, t);
}
function Wg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(tn, t);
}
const on = i`
    query Requests($id: String!) {
  publishedDataRoom(id: $id) {
    id
    requests {
      nodes {
        id
        draftNode {
          id
          name
          permissions {
            nodes {
              ... on DraftAnalystPermission {
                participant {
                  id
                  userEmail
                }
              }
            }
          }
          ... on DraftSyntheticNode {
            computationType
          }
          ... on DraftPostNode {
            computationType
          }
          ... on DraftPreviewNode {
            computationType
          }
          ... on DraftMatchNode {
            computationType
          }
          ... on DraftS3SinkNode {
            computationType
          }
          ... on DraftScriptingNode {
            computationType
            scriptingLanguage
          }
          ... on DraftSqlNode {
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
          }
          ... on DraftSqliteNode {
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
          }
          ... on DraftSyntheticNode {
            accuracy
            includeReportWithStats
          }
        }
      }
    }
  }
}
    `;
function Gg(e) {
  const t = { ...n, ...e };
  return o.useQuery(on, t);
}
function Vg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(on, t);
}
function Zg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(on, t);
}
const nn = i`
    query RequestsForReport($id: String!) {
  publishedDataRoom(id: $id) {
    id
    requests {
      nodes {
        id
        draftNode {
          id
          name
          permissions {
            nodes {
              ... on DraftAnalystPermission {
                participant {
                  id
                  userEmail
                }
              }
            }
          }
          ... on DraftSyntheticNode {
            id
            accuracy
            computationType
            includeReportWithStats
            columns {
              nodes {
                id
                index
                name
                maskType
                dataType
                shouldMaskColumn
              }
            }
            dependencyUpdatedAt
            dependency {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
              ... on PublishedNodeConnection {
                computeNodeId
                publishedDataRoomId
              }
            }
          }
          ... on DraftPostNode {
            id
            name
            computationType
            dependency {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
              ... on PublishedNodeConnection {
                computeNodeId
                publishedDataRoomId
              }
            }
          }
          ... on DraftPreviewNode {
            id
            name
            computationType
            quotaBytes
            dependency {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
              ... on PublishedNodeConnection {
                computeNodeId
                publishedDataRoomId
              }
            }
          }
          ... on DraftMatchNode {
            id
            config
            computationType
            dependencies {
              nodes {
                ... on DraftNodeConnection {
                  draftNode {
                    id
                    name
                  }
                }
                ... on PublishedNodeConnection {
                  computeNodeId
                }
              }
            }
          }
          ... on DraftS3SinkNode {
            computationType
          }
          ... on DraftScriptingNode {
            id
            name
            computationType
            scripts {
              nodes {
                id
                name
                content
                isMainScript
              }
            }
            dependencies {
              nodes {
                ... on DraftNodeConnection {
                  draftNode {
                    id
                    name
                  }
                }
                ... on PublishedNodeConnection {
                  computeNodeId
                  publishedDataRoomId
                }
              }
            }
            output
            scriptingLanguage
          }
          ... on DraftSqlNode {
            id
            name
            statement
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
          }
          ... on DraftSqliteNode {
            id
            name
            statement
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
          }
          ... on DraftSyntheticNode {
            id
            accuracy
            computationType
            includeReportWithStats
            columns {
              nodes {
                id
                index
                name
                maskType
                dataType
                shouldMaskColumn
              }
            }
            dependencyUpdatedAt
            dependency {
              ... on DraftNodeConnection {
                draftNode {
                  id
                  name
                }
              }
              ... on PublishedNodeConnection {
                computeNodeId
                publishedDataRoomId
              }
            }
          }
        }
      }
    }
  }
}
    `;
function Kg(e) {
  const t = { ...n, ...e };
  return o.useQuery(nn, t);
}
function Xg(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(nn, t);
}
function Yg(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(nn, t);
}
const ka = i`
    mutation ResetJobIdsForDataLab($id: String!) {
  dataLab {
    resetJobIds(id: $id) {
      record {
        ...FullDataLab
      }
    }
  }
}
    ${a}`;
function eN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ka, t);
}
const Fa = i`
    mutation RetrieveDraftComputationFormat($id: String!, $nodeId: String!) {
  retrieveDraftComputationFormat(input: {id: $id, nodeId: $nodeId}) @client {
    format
  }
}
    `;
function tN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Fa, t);
}
const Ua = i`
    mutation RetrievePublishedComputationFormat($dcrHash: HexString!, $driverAttestationHash: HexString!, $computeNodeId: String!) {
  retrievePublishedComputationFormat(
    input: {dcrHash: $dcrHash, driverAttestationHash: $driverAttestationHash, computeNodeId: $computeNodeId}
  ) @client {
    format
  }
}
    `;
function oN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ua, t);
}
const Oa = i`
    mutation RevokeAccessToken($tokenId: String!) {
  apiToken {
    revoke(id: $tokenId) {
      token
      id
      name
      createdAt
      revoked
    }
  }
}
    `;
function nN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Oa, t);
}
const Ea = i`
    mutation S3NodeCreate($input: CreateDraftS3SinkNodeInput!) {
  draftS3SinkNode {
    create(input: $input) {
      id
      name
      endpoint
      region
      computationType
      credentialsDependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
      }
      uploadDependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
      }
    }
  }
}
    `;
function iN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ea, t);
}
const Ja = i`
    mutation S3NodeDelete($id: String!) {
  draftS3SinkNode {
    delete(id: $id)
  }
}
    `;
function aN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ja, t);
}
const xa = i`
    mutation S3NodeNameEdit($input: UpdateDraftS3SinkNodeInput!) {
  draftS3SinkNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function sN(e) {
  const t = { ...n, ...e };
  return o.useMutation(xa, t);
}
const Ba = i`
    mutation ScriptingNodeCreate($input: CreateDraftScriptingNodeInput!) {
  draftScriptingNode {
    create(input: $input) {
      id
      name
      scriptingLanguage
      computationType
      scripts {
        nodes {
          id
          name
          content
        }
      }
      output
      scriptingLanguage
    }
  }
}
    `;
function uN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ba, t);
}
const _a = i`
    mutation ScriptingNodeDelete($id: String!) {
  draftScriptingNode {
    delete(id: $id)
  }
}
    `;
function rN(e) {
  const t = { ...n, ...e };
  return o.useMutation(_a, t);
}
const an = i`
    query ScriptingNodeInteractivityPublishedDependencies($id: String!) {
  publishedDataRoom(id: $id) {
    id
    publishedNodes @client {
      id
      name
    }
  }
}
    `;
function dN(e) {
  const t = { ...n, ...e };
  return o.useQuery(an, t);
}
function cN(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(an, t);
}
function pN(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(an, t);
}
const ja = i`
    mutation ScriptingNodeNameEdit($input: UpdateDraftScriptingNodeInput!) {
  draftScriptingNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function mN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ja, t);
}
const Wa = i`
    mutation SendCollaborationRequestToDataPartner($requestRecipientId: String!, $message: String!) {
  availableDataPartner {
    contactDataPartner(requestRecipientId: $requestRecipientId, message: $message)
  }
}
    `;
function lN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Wa, t);
}
const Ga = i`
    mutation SendCollaborationRequestToPublisher($requestRecipientId: String!, $message: String!) {
  availablePublisher {
    contactPublisher(requestRecipientId: $requestRecipientId, message: $message)
  }
}
    `;
function yN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ga, t);
}
const Va = i`
    mutation SendErrorReport($input: CreateErrorReportInput!) {
  errorReport {
    create(input: $input) {
      id
      createdAt
      report
    }
  }
}
    `;
function DN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Va, t);
}
const Za = i`
    mutation SendExternalInvitationOrgAdmin($input: CreateExternalUserInput!) {
  organization {
    createExternalUser(input: $input) {
      record {
        id
        user {
          id
          email
        }
        lastInvitedAt
        lastInvitedBy {
          id
          email
        }
      }
    }
  }
}
    `;
function hN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Za, t);
}
const Ka = i`
    mutation SetComputeNodesOrder($dataRoomId: String!, $computeNodesOrder: [String!]!) {
  draftDataRoom {
    setComputeNodesOrder(
      draftDataRoomId: $dataRoomId
      draftNodeIds: $computeNodesOrder
    ) {
      id
      computeNodesOrder
    }
  }
}
    `;
function fN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ka, t);
}
const Xa = i`
    mutation SetDataNodesOrder($dataRoomId: String!, $dataNodesOrder: [String!]!) {
  draftDataRoom {
    setDataNodesOrder(draftDataRoomId: $dataRoomId, draftNodeIds: $dataNodesOrder) {
      id
      dataNodesOrder
    }
  }
}
    `;
function SN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Xa, t);
}
const Ya = i`
    mutation SetDataRoomDescription($input: UpdateDraftDataRoomInput!) {
  draftDataRoom {
    update(input: $input) {
      id
      description
    }
  }
}
    `;
function bN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ya, t);
}
const es = i`
    mutation SetDataRoomName($input: UpdateDraftDataRoomInput!) {
  draftDataRoom {
    update(input: $input) {
      id
      name: title
    }
  }
}
    `;
function gN(e) {
  const t = { ...n, ...e };
  return o.useMutation(es, t);
}
const ts = i`
    mutation SetDemographicsDatasetForDataLab($input: SetDataLabDatasetInput!) {
  dataLab {
    setDemographicsDataset(input: $input) {
      record {
        ...FullDataLab
      }
    }
  }
}
    ${a}`;
function NN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ts, t);
}
const os = i`
    mutation SetEmbeddingsDatasetForDataLab($input: SetDataLabDatasetInput!) {
  dataLab {
    setEmbeddingsDataset(input: $input) {
      record {
        ...FullDataLab
      }
    }
  }
}
    ${a}`;
function RN(e) {
  const t = { ...n, ...e };
  return o.useMutation(os, t);
}
const ns = i`
    mutation SetJobIdsForDataLab($input: SetDataLabJobIdsInput!) {
  dataLab {
    setJobIds(input: $input) {
      record {
        ...FullDataLab
      }
    }
  }
}
    ${a}`;
function QN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ns, t);
}
const is = i`
    mutation SetPrivacyFilter($input: UpdateDraftSqlNodeInput!) {
  draftSqlNode {
    update(input: $input) {
      id
      privacyFilter {
        minimumRows
        isEnabled
      }
    }
  }
}
    `;
function PN(e) {
  const t = { ...n, ...e };
  return o.useMutation(is, t);
}
const as = i`
    mutation SetSegmentsDatasetForDataLab($input: SetDataLabDatasetInput!) {
  dataLab {
    setSegmentsDataset(input: $input) {
      record {
        ...FullDataLab
      }
    }
  }
}
    ${a}`;
function IN(e) {
  const t = { ...n, ...e };
  return o.useMutation(as, t);
}
const ss = i`
    mutation SetStatisticsForDataLab($input: SetDataLabStatisticsInput!) {
  dataLab {
    setStatistics(input: $input) {
      record {
        ...FullDataLab
      }
    }
  }
}
    ${a}`;
function vN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ss, t);
}
const us = i`
    mutation SetSyntheticNodeColumns($id: String!, $columns: [CreateSyntheticNodeColumnForSyntheticNodeInput!]!) {
  draftSyntheticNode {
    setSyntheticNodeColumns(
      draftSyntheticNodeId: $id
      syntheticNodeColumns: $columns
    ) {
      id
      columns {
        nodes {
          id
          index
          name
          maskType
          dataType
          shouldMaskColumn
        }
      }
    }
  }
}
    `;
function $N(e) {
  const t = { ...n, ...e };
  return o.useMutation(us, t);
}
const rs = i`
    mutation SetSyntheticNodeIncludeStatistics($input: UpdateDraftSyntheticNodeInput!) {
  draftSyntheticNode {
    update(input: $input) {
      id
      includeReportWithStats
    }
  }
}
    `;
function CN(e) {
  const t = { ...n, ...e };
  return o.useMutation(rs, t);
}
const ds = i`
    mutation SetTestModePublication($input: SetTestModePublicationInput!) {
  testModePublication {
    set(input: $input) {
      record {
        dataset {
          id
          manifestHash
          createdAt
          owner {
            email
          }
        }
      }
    }
  }
}
    `;
function AN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ds, t);
}
const cs = i`
    mutation SetUserHasLoggedInBefore($input: SetUserLoggedInBeforeInput!) {
  user {
    setLoggedInBefore(input: $input) {
      record {
        id
        hasLoggedInBefore
      }
    }
  }
}
    `;
function MN(e) {
  const t = { ...n, ...e };
  return o.useMutation(cs, t);
}
const ps = i`
    mutation SetUsersDatasetForDataLab($input: SetDataLabDatasetInput!) {
  dataLab {
    setUsersDataset(input: $input) {
      record {
        ...FullDataLab
      }
    }
  }
}
    ${a}`;
function LN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ps, t);
}
const sn = i`
    query SharedWithMeDataRooms {
  dataRooms(
    filter: {isArchived: {equalTo: false}, isFavorite: {equalTo: false}, isOwnedByUser: {equalTo: false}}
    sortBy: {updatedAt: DESCENDING}
  ) {
    nodes {
      ... on DraftDataRoom {
        ...NavigationDrawerDraftDataRoom
      }
      ... on PublishedDataRoom {
        ...NavigationDrawerPublishedDataRoom
      }
      ... on PublishedMediaDataRoom {
        ...NavigationDrawerPublishedMediaDataRoom
      }
      ... on PublishedLookalikeMediaDataRoom {
        ...NavigationDrawerPublishedLookalikeMediaDataRoom
      }
      ... on PublishedMediaInsightsDcr {
        ...NavigationDrawerPublishedMediaInsightsDcr
      }
    }
  }
}
    ${s}
${u}
${r}
${p}
${m}`;
function zN(e) {
  const t = { ...n, ...e };
  return o.useQuery(sn, t);
}
function HN(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(sn, t);
}
function qN(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(sn, t);
}
const ms = i`
    mutation SignSubmittedDataRoomRequest($input: SignSubmittedDataRoomRequestLocalInput!) {
  signSubmittedDataRoomRequest(input: $input) @client {
    signature
    signers {
      userEmail
      signature
    }
  }
}
    `;
function TN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ms, t);
}
const ls = i`
    mutation SqlNodeCreate($input: CreateDraftSqlNodeInput!) {
  draftSqlNode {
    create(input: $input) {
      id
      name
      statement
      computationType
      privacyFilter {
        minimumRows
        isEnabled
      }
    }
  }
}
    `;
function wN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ls, t);
}
const ys = i`
    mutation SqlNodeDelete($id: String!) {
  draftSqlNode {
    delete(id: $id)
  }
}
    `;
function kN(e) {
  const t = { ...n, ...e };
  return o.useMutation(ys, t);
}
const Ds = i`
    mutation SqlNodeNameEdit($input: UpdateDraftSqlNodeInput!) {
  draftSqlNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function FN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ds, t);
}
const hs = i`
    mutation SqliteNodeCreate($input: CreateDraftSqliteNodeInput!) {
  draftSqliteNode {
    create(input: $input) {
      id
      name
      statement
      computationType
      privacyFilter {
        minimumRows
        isEnabled
      }
    }
  }
}
    `;
function UN(e) {
  const t = { ...n, ...e };
  return o.useMutation(hs, t);
}
const fs = i`
    mutation SqliteNodeDelete($id: String!) {
  draftSqliteNode {
    delete(id: $id)
  }
}
    `;
function ON(e) {
  const t = { ...n, ...e };
  return o.useMutation(fs, t);
}
const Ss = i`
    mutation SqliteNodeNameEdit($input: UpdateDraftSqliteNodeInput!) {
  draftSqliteNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function EN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ss, t);
}
const bs = i`
    mutation StartJobPolling($input: PollComputeJobInput!) {
  pollComputeJob(input: $input) @client
}
    `;
function JN(e) {
  const t = { ...n, ...e };
  return o.useMutation(bs, t);
}
const gs = i`
    mutation StopDataRoom($input: StopDataRoomInput!) {
  stopDataRoom(input: $input) @client {
    id
  }
}
    `;
function xN(e) {
  const t = { ...n, ...e };
  return o.useMutation(gs, t);
}
const Ns = i`
    mutation StoreActivatedDirectAudienceAsDataset($input: StoreDirectActivatedAudienceAsDatasetInput!) {
  storeActivatedDirectAudienceAsDataset(input: $input) @client {
    audienceType
    createImportPayload {
      dataConnectorJob {
        ...DataConnectorJob
      }
    }
  }
}
    ${d}`;
function BN(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ns, t);
}
const Rs = i`
    mutation SubmitDataRoomRequest($input: SubmitDataRoomRequestLocalInput!) {
  submitDataRoomRequest(input: $input) @client {
    id
    status
  }
}
    `;
function _N(e) {
  const t = { ...n, ...e };
  return o.useMutation(Rs, t);
}
const un = i`
    query SubmittedDataRoomRequestSignatures($id: String!) {
  submittedDataRoomRequest(id: $id) {
    id
    enclaveCommitId
    publishedDataRoom {
      id
    }
    signers {
      nodes {
        userEmail
        user {
          email
        }
        signature
      }
    }
  }
}
    `;
function jN(e) {
  const t = { ...n, ...e };
  return o.useQuery(un, t);
}
function WN(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(un, t);
}
function GN(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(un, t);
}
const rn = i`
    query SubmittedDataRoomRequests($id: String!) {
  publishedDataRoom(id: $id) {
    submittedRequests {
      nodes {
        id
        enclaveCommitId
        enclaveConfigurationPin
        signers {
          nodes {
            id
            userEmail
            user {
              id
              email
            }
            signature
          }
        }
        owner {
          id
          email
        }
        createdAt
        updatedAt
        node @client {
          __typename
          id
          name
          dcrHash
          driverAttestationHash
          commitId
          permissions {
            ... on PublishedAnalystPermission {
              participant {
                userEmail
              }
            }
            ... on PublishedDataOwnerPermission {
              participant {
                userEmail
              }
            }
          }
          ... on PublishedScriptingNode {
            computationType
            output
            scriptingLanguage
            usesCustomPythonEnv
            scripts {
              name
              content
              isMainScript
            }
            dependencies {
              __typename
              id
              name
              dcrHash
              driverAttestationHash
              commitId
            }
          }
          ... on PublishedSqlNode {
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
            dependencies {
              __typename
              id
              name
              dcrHash
              driverAttestationHash
              commitId
            }
            statement
          }
          ... on PublishedSqliteNode {
            computationType
            privacyFilter {
              minimumRows
              isEnabled
            }
            dependencies {
              __typename
              id
              name
              dcrHash
              driverAttestationHash
              commitId
            }
            statement
          }
          ... on PublishedMatchNode {
            computationType
            dependencies {
              __typename
              id
              name
              dcrHash
              driverAttestationHash
              commitId
            }
            config
          }
          ... on PublishedSyntheticNode {
            computationType
            accuracy
            includeReportWithStats
            dependency {
              __typename
              id
              name
              dcrHash
              driverAttestationHash
              commitId
            }
            columns {
              name
              shouldMaskColumn
              index
              maskType
              dataType
            }
          }
          ... on PublishedPostNode {
            computationType
            dependency {
              __typename
              id
              dcrHash
              driverAttestationHash
              commitId
            }
          }
          ... on PublishedPreviewNode {
            computationType
            usedQuotaBytes
            remainingQuotaBytes
            totalQuotaBytes
            dependency {
              __typename
              id
              dcrHash
              driverAttestationHash
              commitId
            }
          }
          ... on PublishedS3SinkNode {
            endpoint
            computationType
            region
            credentialsDependency {
              __typename
              id
              name
              dcrHash
              driverAttestationHash
              commitId
            }
            uploadDependency {
              __typename
              id
              name
              dcrHash
              driverAttestationHash
              commitId
            }
          }
        }
      }
    }
  }
}
    `;
function VN(e) {
  const t = { ...n, ...e };
  return o.useQuery(rn, t);
}
function ZN(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(rn, t);
}
function KN(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(rn, t);
}
const dn = i`
    query SubmittedRequestComputeNodeActions($requestId: String!, $computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    name
    ... on PublishedSqlNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedSqliteNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedMatchNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedPostNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedPreviewNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedScriptingNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedSyntheticNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
    ... on PublishedS3SinkNode {
      job {
        id
        enclaveComputeJobId
        status
        createdAt
        autoFetching
        driverAttestationHash
        dataRoomHash
        purpose
      }
    }
  }
  submittedDataRoomRequest(id: $requestId) {
    id
    signers {
      nodes {
        id
        userEmail
        user {
          id
          email
        }
      }
    }
  }
}
    `;
function XN(e) {
  const t = { ...n, ...e };
  return o.useQuery(dn, t);
}
function YN(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(dn, t);
}
function eR(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(dn, t);
}
const cn = i`
    query SubmittedRequestComputeNodePermissions($computeNodeId: String!, $dcrHash: HexString!, $driverAttestationHash: HexString!, $commitId: HexString) {
  publishedNode(
    id: $computeNodeId
    dcrHash: $dcrHash
    driverAttestationHash: $driverAttestationHash
    commitId: $commitId
  ) @client {
    id
    permissions {
      ... on PublishedAnalystPermission {
        participant {
          userEmail
        }
      }
    }
  }
}
    `;
function tR(e) {
  const t = { ...n, ...e };
  return o.useQuery(cn, t);
}
function oR(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(cn, t);
}
function nR(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(cn, t);
}
const Qs = i`
    mutation SubmittedRequestComputeNodeRun($input: RunSubmittedDataRoomRequestInput!) {
  runSubmittedDataRoomRequest(input: $input) @client {
    id
    enclaveComputeJobId
    status
    createdAt
  }
}
    `;
function iR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Qs, t);
}
const pn = i`
    query SubmittedRequestCreationDate($id: String!) {
  submittedDataRoomRequest(id: $id) {
    id
    createdAt
    owner {
      id
      email
    }
  }
}
    `;
function aR(e) {
  const t = { ...n, ...e };
  return o.useQuery(pn, t);
}
function sR(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(pn, t);
}
function uR(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(pn, t);
}
const mn = i`
    query SubmittedRequestRebase($id: String!) {
  submittedDataRoomRequest(id: $id) {
    id
    enclaveConfigurationPin
    owner {
      id
      email
    }
    node @client {
      id
      commitId
    }
  }
}
    `;
function rR(e) {
  const t = { ...n, ...e };
  return o.useQuery(mn, t);
}
function dR(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(mn, t);
}
function cR(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(mn, t);
}
const ln = i`
    query SubmittedRequestSignees($id: String!) {
  submittedDataRoomRequest(id: $id) {
    id
    enclaveConfigurationPin
    node @client {
      __typename
      id
      commitId
    }
    signers {
      nodes {
        id
        userEmail
        user {
          id
          email
        }
        signature
      }
    }
  }
}
    `;
function pR(e) {
  const t = { ...n, ...e };
  return o.useQuery(ln, t);
}
function mR(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(ln, t);
}
function lR(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(ln, t);
}
const Ps = i`
    mutation SyntheticNodeCreate($input: CreateDraftSyntheticNodeInput!) {
  draftSyntheticNode {
    create(input: $input) {
      id
      name
      computationType
    }
  }
}
    `;
function yR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ps, t);
}
const Is = i`
    mutation SyntheticNodeDelete($id: String!) {
  draftSyntheticNode {
    delete(id: $id)
  }
}
    `;
function DR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Is, t);
}
const yn = i`
    query SyntheticNodeInteractivityPublishedDependencies($id: String!) {
  publishedDataRoom(id: $id) {
    id
    publishedNodes @client {
      id
      name
      ... on PublishedTableLeafNode {
        isRequired
        columns {
          name
          dataType
          isNullable
          formatType
          hashWith
        }
      }
    }
  }
}
    `;
function hR(e) {
  const t = { ...n, ...e };
  return o.useQuery(yn, t);
}
function fR(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(yn, t);
}
function SR(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(yn, t);
}
const vs = i`
    mutation SyntheticNodeNameEdit($input: UpdateDraftSyntheticNodeInput!) {
  draftSyntheticNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function bR(e) {
  const t = { ...n, ...e };
  return o.useMutation(vs, t);
}
const $s = i`
    mutation TestAllComputations($input: TestAllComputationsInput!) {
  testAllComputations(input: $input) @client {
    results {
      computeNodeId
    }
  }
}
    `;
function gR(e) {
  const t = { ...n, ...e };
  return o.useMutation($s, t);
}
const Cs = i`
    mutation TestDraftComputation($input: TestDraftComputationInput!) {
  testDraftComputation(input: $input) @client {
    id
    enclaveComputeJobId
    status
    updatedAt
    createdAt
    autoFetching @client
  }
}
    `;
function NR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Cs, t);
}
const Dn = i`
    query TestModePublication($id: NodeId!) {
  testModePublication(id: $id) {
    dataset {
      id
      manifestHash
      name
      description
      owner {
        id
        email
      }
      createdAt
      usage
    }
  }
}
    `;
function RR(e) {
  const t = { ...n, ...e };
  return o.useQuery(Dn, t);
}
function QR(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Dn, t);
}
function PR(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Dn, t);
}
const As = i`
    mutation UnpublishDataset($input: UnpublishDatasetInput!) {
  unpublishDataset(input: $input) @client {
    id
  }
}
    `;
function IR(e) {
  const t = { ...n, ...e };
  return o.useMutation(As, t);
}
const Ms = i`
    mutation UpdateAdvertiserMarketFilters($input: [String!]!) {
  availablePublisher {
    updateMarketFilters(marketIds: $input)
  }
}
    `;
function vR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ms, t);
}
const Ls = i`
    mutation UpdateDataPartnerDisplayConfiguration($input: UpdateDataPartnerDisplayConfigurationInput!) {
  dataPartnerDisplayConfiguration {
    update(input: $input) {
      record {
        ...DataPartnerDisplayConfiguration
      }
    }
  }
}
    ${y}`;
function $R(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ls, t);
}
const zs = i`
    mutation UpdateDraftDataRoomIsFavorite($id: String!, $isFavorite: Boolean!) {
  draftDataRoom {
    updateUserSettings(input: {id: $id, isFavorite: $isFavorite}) {
      id
      isFavorite
    }
  }
}
    `;
function CR(e) {
  const t = { ...n, ...e };
  return o.useMutation(zs, t);
}
const Hs = i`
    mutation UpdateDraftDataRoomIsHidden($id: String!, $isHidden: Boolean!) {
  draftDataRoom {
    updateUserSettings(input: {id: $id, isArchived: $isHidden}) {
      id
      isHidden: isArchived
    }
  }
}
    `;
function AR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Hs, t);
}
const qs = i`
    mutation UpdateDraftDataRoomShowOrganizationLogo($id: String!, $showOrganizationLogo: Boolean!) {
  draftDataRoom {
    update(input: {id: $id, showOrganizationLogo: $showOrganizationLogo}) {
      id
      showOrganizationLogo
    }
  }
}
    `;
function MR(e) {
  const t = { ...n, ...e };
  return o.useMutation(qs, t);
}
const Ts = i`
    mutation UpdateDraftRawLeafNode($input: UpdateDraftRawLeafNodeInput!) {
  draftRawLeafNode {
    update(input: $input) {
      id
      name
      isRequired
    }
  }
}
    `;
function LR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ts, t);
}
const ws = i`
    mutation UpdateDraftRawLeafNodeName($input: UpdateDraftRawLeafNodeInput!) {
  draftRawLeafNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function zR(e) {
  const t = { ...n, ...e };
  return o.useMutation(ws, t);
}
const ks = i`
    mutation UpdateDraftTableLeafNode($input: UpdateDraftTableLeafNodeInput!) {
  draftTableLeafNode {
    update(input: $input) {
      id
      name
      isRequired
      columnsOrder
    }
  }
}
    `;
function HR(e) {
  const t = { ...n, ...e };
  return o.useMutation(ks, t);
}
const Fs = i`
    mutation UpdateDraftTableLeafNodeColumn($input: UpdateDraftTableLeafNodeColumnInput!) {
  draftTableLeafNode {
    updateColumn(input: $input) {
      id
      name
      dataType
      formatType
      isNullable
      hashWith
    }
  }
}
    `;
function qR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Fs, t);
}
const Us = i`
    mutation UpdateDraftTableLeafNodeName($input: UpdateDraftTableLeafNodeInput!) {
  draftTableLeafNode {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function TR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Us, t);
}
const Os = i`
    mutation UpdateOrganizationComputeTimeout($input: UpdateOrganizationQuotasInput!) {
  organizationQuotas {
    updateOrganizationQuotas(input: $input) {
      record {
        containerWorkerMaxRuntimeSeconds
      }
    }
  }
}
    `;
function wR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Os, t);
}
const Es = i`
    mutation UpdateOrganizationDomains($input: UpdateOrganizationInput!) {
  organization {
    update(input: $input) {
      id
      domains
    }
  }
}
    `;
function kR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Es, t);
}
const Js = i`
    mutation UpdateOrganizationEnclaveWorkers($input: UpdateOrganizationInput!) {
  organization {
    update(input: $input) {
      id
      workerTypes {
        nodes {
          id
          name
          shortName
        }
      }
    }
  }
}
    `;
function FR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Js, t);
}
const xs = i`
    mutation UpdateOrganizationFlags($input: UpdateOrganizationFlagsInput!, $organizationId: String!) {
  organization {
    updateOrganizationFlags(input: $input, organizationId: $organizationId) {
      id
      hasAdvertiserFeatures
      hasAnalyticsFeatures
      hasPublisherFeatures
      useLegacyDataLabs
      skipMdcrAudiencesResettingOnDataLabChange
      hasDataPartnerFeatures
      canViewDataPartners
      hasDatalabFeatures
      canViewMeasurements
      allowExcludingSeedAudience
      enableExtendedLookalikeQualityStatistics
      enableAudienceBuilder
      enableDmp
      s3ExportState
      metaExportState
      googleDv360ExportState
      tradedeskExportState
      azureExportState
      googleCloudStorageExportState
      googleAdManagerExportState
      permutiveExportState
      sportradarExportState
      adformExportState
      microsoftDspExportState
      splickyExportState
      googleAdsExportState
      snapchatExportState
      tiktokExportState
      localImportState
      computeImportState
      s3ImportState
      snowflakeImportState
      salesforceImportState
      azureImportState
      googleCloudStorageImportState
      permutiveImportState
      databricksImportState
    }
  }
}
    `;
function UR(e) {
  const t = { ...n, ...e };
  return o.useMutation(xs, t);
}
const Bs = i`
    mutation UpdateOrganizationLicense($organizationId: String!, $state: OrganizationState!) {
  organization {
    setState(id: $organizationId, state: $state) {
      record {
        id
        state
      }
    }
  }
}
    `;
function OR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Bs, t);
}
const _s = i`
    mutation UpdateOrganizationMediaScope($input: UpdateOrganizationInput!) {
  organization {
    update(input: $input) {
      id
      mediaScope
    }
  }
}
    `;
function ER(e) {
  const t = { ...n, ...e };
  return o.useMutation(_s, t);
}
const js = i`
    mutation UpdateOrganizationMicrosoftDspMember($input: UpdateOrganizationInput!) {
  organization {
    update(input: $input) {
      id
      microsoftDspMember
    }
  }
}
    `;
function JR(e) {
  const t = { ...n, ...e };
  return o.useMutation(js, t);
}
const Ws = i`
    mutation UpdateOrganizationName($input: UpdateOrganizationInput!) {
  organization {
    update(input: $input) {
      id
      name
    }
  }
}
    `;
function xR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ws, t);
}
const Gs = i`
    mutation UpdatePostComputeNodeDependency($computeNodeId: String!, $dependencyId: NodeId!) {
  draftPostNode {
    setDependency(id: $computeNodeId, dependencyId: $dependencyId) {
      id
      dependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function BR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Gs, t);
}
const Vs = i`
    mutation UpdatePreviewComputeNodeDependency($computeNodeId: String!, $dependencyId: NodeId!) {
  draftPreviewNode {
    setDependency(id: $computeNodeId, dependencyId: $dependencyId) {
      id
      dependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function _R(e) {
  const t = { ...n, ...e };
  return o.useMutation(Vs, t);
}
const Zs = i`
    mutation UpdatePreviewComputeNodeQuota($computeNodeId: String!, $quotaBytes: SetUnsignedLong!) {
  draftPreviewNode {
    update(input: {id: $computeNodeId, quotaBytes: $quotaBytes}) {
      id
      quotaBytes
    }
  }
}
    `;
function jR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Zs, t);
}
const Ks = i`
    mutation UpdatePublishedDataRoomIsHidden($id: String!, $isHidden: Boolean!) {
  publishedDataRoom {
    updateUserSettings(input: {id: $id, isArchived: $isHidden}) {
      id
      isHidden: isArchived
    }
  }
}
    `;
function WR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ks, t);
}
const Xs = i`
    mutation UpdatePublishedDataRoomIsFavorite($id: String!, $isFavorite: Boolean!) {
  publishedDataRoom {
    updateUserSettings(input: {id: $id, isFavorite: $isFavorite}) {
      id
      isFavorite
    }
  }
}
    `;
function GR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Xs, t);
}
const Ys = i`
    mutation UpdatePublisherDisplayConfiguration($input: UpdatePublisherDisplayConfigurationInput!) {
  publisherDisplayConfiguration {
    update(input: $input) {
      record {
        id
        publisherName
        description
        collaborationRequestUsers
        logo
        marketIds
      }
    }
  }
}
    `;
function VR(e) {
  const t = { ...n, ...e };
  return o.useMutation(Ys, t);
}
const eu = i`
    mutation UpdateS3ConnectionParams($input: UpdateDraftS3SinkNodeInput!) {
  draftS3SinkNode {
    update(input: $input) {
      id
      name
      endpoint
      region
    }
  }
}
    `;
function ZR(e) {
  const t = { ...n, ...e };
  return o.useMutation(eu, t);
}
const tu = i`
    mutation UpdateS3CredentialsDependency($computeNodeId: String!, $dependencyId: NodeId!) {
  draftS3SinkNode {
    setCredentialsDependency(id: $computeNodeId, dependencyId: $dependencyId) {
      id
      credentialsDependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function KR(e) {
  const t = { ...n, ...e };
  return o.useMutation(tu, t);
}
const ou = i`
    mutation UpdateS3UploadDependency($computeNodeId: String!, $dependencyId: NodeId!) {
  draftS3SinkNode {
    setUploadDependency(id: $computeNodeId, dependencyId: $dependencyId) {
      id
      uploadDependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
    }
  }
}
    `;
function XR(e) {
  const t = { ...n, ...e };
  return o.useMutation(ou, t);
}
const nu = i`
    mutation UpdateScriptContent($input: UpdateDraftScriptInput!) {
  draftScriptingNode {
    updateScript(input: $input) {
      id
      content
    }
  }
}
    `;
function YR(e) {
  const t = { ...n, ...e };
  return o.useMutation(nu, t);
}
const iu = i`
    mutation UpdateScriptingNodeOutputFolder($input: UpdateDraftScriptingNodeInput!) {
  draftScriptingNode {
    update(input: $input) {
      id
      output
    }
  }
}
    `;
function eQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(iu, t);
}
const au = i`
    mutation UpdateSqlComputeNode($input: UpdateDraftSqlNodeInput!) {
  draftSqlNode {
    update(input: $input) {
      statement
      name
      id
    }
  }
}
    `;
function tQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(au, t);
}
const su = i`
    mutation UpdateSqliteComputeNode($input: UpdateDraftSqliteNodeInput!) {
  draftSqliteNode {
    update(input: $input) {
      statement
      name
      id
    }
  }
}
    `;
function oQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(su, t);
}
const uu = i`
    mutation UpdateStaticScriptName($input: UpdateDraftScriptInput!) {
  draftScriptingNode {
    updateScript(input: $input) {
      id
      name
    }
  }
}
    `;
function nQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(uu, t);
}
const ru = i`
    mutation UpdateSyntheticNodeAccuracy($input: UpdateDraftSyntheticNodeInput!) {
  draftSyntheticNode {
    update(input: $input) {
      id
      accuracy
    }
  }
}
    `;
function iQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(ru, t);
}
const du = i`
    mutation UpdateSyntheticNodeColumn($id: String!, $maskType: SyntheticMaskType, $shouldMaskColumn: Boolean) {
  draftSyntheticNode {
    updateSyntheticNodeColumn(
      input: {id: $id, maskType: $maskType, shouldMaskColumn: $shouldMaskColumn}
    ) {
      id
      maskType
      shouldMaskColumn
    }
  }
}
    `;
function aQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(du, t);
}
const cu = i`
    mutation UpdateSyntheticNodeDataSource($computeNodeId: String!, $dependencyId: NodeId!, $dependencyLastUpdatedAt: DateTime, $syntheticNodeColumns: [CreateSyntheticNodeColumnForSyntheticNodeInput!]) {
  draftSyntheticNode {
    setDependency(
      id: $computeNodeId
      dependencyId: $dependencyId
      dependencyLastUpdatedAt: $dependencyLastUpdatedAt
      syntheticNodeColumns: $syntheticNodeColumns
    ) {
      id
      dependency {
        ... on DraftNodeConnection {
          draftNode {
            id
            name
            ... on DraftTableLeafNode {
              columns {
                nodes {
                  id
                  name
                  dataType
                  isNullable
                }
              }
            }
          }
        }
        ... on PublishedNodeConnection {
          computeNodeId
          publishedDataRoomId
        }
      }
      columns {
        nodes {
          id
          index
          name
          maskType
          dataType
          shouldMaskColumn
        }
      }
    }
  }
}
    `;
function sQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(cu, t);
}
const pu = i`
    mutation UpdateUser($input: UpdateUserInput!) {
  user {
    update(input: $input) {
      record {
        ...User
      }
    }
  }
}
    ${Cn}`;
function uQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(pu, t);
}
const mu = i`
    mutation UpsertOrganizationLogo($input: UpdateOrganizationInput!) {
  organization {
    update(input: $input) {
      id
      logo
    }
  }
}
    `;
function rQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(mu, t);
}
const hn = i`
    query UserByEmail($email: String!) {
  userByEmail(email: $email) {
    id
    email
    organization {
      id
      name
      workerTypes {
        nodes {
          id
          name
          shortName
        }
      }
    }
  }
}
    `;
function dQ(e) {
  const t = { ...n, ...e };
  return o.useQuery(hn, t);
}
function cQ(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(hn, t);
}
function pQ(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(hn, t);
}
const fn = i`
    query UserDetails($userId: String!) {
  user(id: $userId) {
    id
    email
    userRole
    createdAt
    isDemoUser
    logo
    organization {
      id
      domains
      name
      state
    }
    createdBy {
      email
      id
      organization {
        id
        name
      }
    }
    dataRooms {
      nodes {
        id
        createdAt
        title
      }
      totalCount
    }
    datasets {
      nodes {
        id
        name
        createdAt
      }
    }
  }
}
    `;
function mQ(e) {
  const t = { ...n, ...e };
  return o.useQuery(fn, t);
}
function lQ(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(fn, t);
}
function yQ(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(fn, t);
}
const Sn = i`
    query UserHasLoggedInBefore($email: String!) {
  userByEmail(email: $email) {
    id
    email
    hasLoggedInBefore
  }
}
    `;
function DQ(e) {
  const t = { ...n, ...e };
  return o.useQuery(Sn, t);
}
function hQ(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(Sn, t);
}
function fQ(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(Sn, t);
}
const bn = i`
    query UserRole($userEmail: String!) {
  userByEmail(email: $userEmail) {
    id
    email
    userRole
    organization {
      id
    }
  }
}
    `;
function SQ(e) {
  const t = { ...n, ...e };
  return o.useQuery(bn, t);
}
function bQ(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(bn, t);
}
function gQ(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(bn, t);
}
const gn = i`
    query Users {
  users {
    nodes {
      id
      email
      logo
      organization {
        id
        name
      }
      userRole
      isDemoUser
      createdAt
    }
  }
}
    `;
function NQ(e) {
  const t = { ...n, ...e };
  return o.useQuery(gn, t);
}
function RQ(e) {
  const t = { ...n, ...e };
  return o.useLazyQuery(gn, t);
}
function QQ(e) {
  const t = { ...n, ...e };
  return o.useSuspenseQuery(gn, t);
}
const lu = i`
    mutation ValidateDataRoomRequest($input: ValidateDataRoomRequestInput!) {
  validateDataRoomRequest(input: $input) @client {
    id
    enclaveComputeJobId
    status
  }
}
    `;
function PQ(e) {
  const t = { ...n, ...e };
  return o.useMutation(lu, t);
}
export {
  h as AccessTokenDocument,
  f as AccessTokensDocument,
  S as AccessTokensNamesDocument,
  An as ActivateConsentlessAudienceDocument,
  Mn as ActivateDirectAudienceDocument,
  b as ActivationConfigurationsDocument,
  N as ActiveMarketsDocument,
  Ln as AddRequestParticipantDocument,
  zn as AddScriptingNodeDependencyDocument,
  Hn as AddSubmittedDataRoomRequestSignatureDocument,
  qn as AddSyntheticNodeColumnDocument,
  R as AdminPortalOrganizationUsersDocument,
  P as AdvertiserMarketFiltersDocument,
  Du as ApiTokenFragment,
  Tn as ApproveSubmittedDataRoomRequestDocument,
  wn as ArchiveOrganizationDocument,
  v as AudienceInsightsAdvertiserDocument,
  $ as AudienceInsightsAdvertiserStatisticsDocument,
  I as AudienceInsightsDocument,
  C as AudienceInsightsPublisherDocument,
  A as AudienceInsightsPublisherStatisticsDocument,
  M as AudienceInsightsStatisticsDocument,
  L as AudienceTypesDocument,
  z as AuditLogsDocument,
  Qn as AvailableDataPartnerFragment,
  H as AvailableDataPartnersDocument,
  Pn as AvailablePublisherFragment,
  q as AvailablePublishersDocument,
  T as CollaboratingOrganizationsDocument,
  w as CommittedComputeNodeActionsDocument,
  kn as CompleteComputeJobFailureDocument,
  Fn as CompleteComputeJobSuccessDocument,
  k as CompleteDataRoomRequestDocument,
  F as CompleteDraftDataRoomDocument,
  U as CompleteMediaDataRoomDocument,
  O as CompletePlaygroundDocument,
  E as CompletePublishedDataRoomDocument,
  J as CompleteSubmittedDataRoomRequestDocument,
  Un as ComputeNodeRunDocument,
  x as ConsentlessActivatedAudiencesDocument,
  Q as ConsentlessAudiencesDocument,
  On as CreateAccessTokenDocument,
  En as CreateActivationConfigurationDocument,
  Jn as CreateComputeJobDocument,
  xn as CreateDataConnectorJobDocument,
  Bn as CreateDataLabDocument,
  _n as CreateDataPartnerDisplayConfigurationDocument,
  jn as CreateDataPartnerUsageConfigurationDocument,
  Wn as CreateDataRoomPlaygroundDocument,
  Gn as CreateDataRoomRequestDocument,
  Vn as CreateDatasetExportDocument,
  Zn as CreateDatasetImportDocument,
  Kn as CreateDemoUserDocument,
  Xn as CreateDraftDataRoomDocument,
  fu as CreateDraftDataRoomFragment,
  Yn as CreateDraftDataRoomIsFavoriteDocument,
  ei as CreateDraftDataRoomIsHiddenDocument,
  ti as CreateDraftRawLeafNodeDocument,
  ni as CreateDraftTableLeafNodeColumnDocument,
  oi as CreateDraftTableLeafNodeDocument,
  ii as CreateLookalikeMediaComputeJobDocument,
  ai as CreateMediaInsightsComputeJobDocument,
  si as CreateOrganizationDocument,
  ui as CreateOrganizationUserDocument,
  ri as CreatePublishedDataRoomIsFavoriteDocument,
  di as CreatePublishedDataRoomIsHiddenDocument,
  pi as CreatePublisherDisplayConfigurationDocument,
  mi as CreateRequestFromPlaygroundDocument,
  li as CreateStaticScriptDocument,
  ci as CreateSubmittedDataRoomRequestDocument,
  B as CurrentUserDomainDocument,
  _ as DataConnectorJobDocument,
  d as DataConnectorJobFragment,
  j as DataConnectorJobResultDocument,
  l as DataConnectorJobResultFragment,
  W as DataConnectorJobSecretDocument,
  Di as DataConnectorJobSetToFailureDocument,
  hi as DataConnectorJobSetToSuccessDocument,
  G as DataConnectorJobsDocument,
  V as DataConnectorJobsSecretsDocument,
  Z as DataLabDocument,
  K as DataLabsDocument,
  X as DataPartnerDisplayConfigurationDocument,
  y as DataPartnerDisplayConfigurationFragment,
  Nn as DataPartnerUsageConfigurationFragment,
  Y as DataPartnerUsageConfigurationsDocument,
  ee as DataRoomAttestationSpecsDocument,
  Su as DataRoomOverviewFragment,
  te as DataRoomRequestComputeNodeTypenameDocument,
  oe as DataRoomRequestTempApproversDocument,
  c as DataRoomUserSettingsFragment,
  ne as DataRoomsListDocument,
  ie as DatasetByHashDocument,
  bu as DatasetFragment,
  ae as DatasetPublicationsByHashDocument,
  se as DatasetSchemaDocument,
  ue as DatasetSecretsByHashDocument,
  re as DatasetsDocument,
  de as DatasetsSecretsDocument,
  fi as DeactivateDataRoomDocument,
  Si as DeleteAccountDocument,
  bi as DeleteActivationConfigurationDocument,
  gi as DeleteConsentlessAudienceDocument,
  Ni as DeleteDataLabDocument,
  Ri as DeleteDataPartnerDisplayConfigurationDocument,
  Qi as DeleteDataPartnerUsageConfigurationDocument,
  Pi as DeleteDataRoomDocument,
  Ii as DeleteDatasetDocument,
  yi as DeleteDraftRawLeafNodeDocument,
  $i as DeleteDraftTableLeafNodeColumnDocument,
  vi as DeleteDraftTableLeafNodeDocument,
  Ci as DeletePlaygroundDocument,
  Ai as DeletePublisherDisplayConfigurationDocument,
  Mi as DeleteRequestDocument,
  Li as DeleteRequestParticipantDocument,
  zi as DeleteStaticScriptDocument,
  Hi as DeleteSyntheticNodeColumnDocument,
  qi as DeleteTestModePublicationDocument,
  Ti as DeleteUserDocument,
  wi as DeprovisionDataLabDocument,
  ki as DeprovisionDataLabFromMediaInsightsDcrDocument,
  ce as DevComputeNodeActionsDocument,
  pe as DevComputeNodeJobDocument,
  Fi as DevComputeNodeRunDocument,
  me as DevComputeNodeTypenameDocument,
  le as DevComputeNodesDocument,
  ye as DevComputeNodesForReportDocument,
  De as DirectActivatedAudiencesDocument,
  he as DirectAudiencesDocument,
  Ui as DownloadActivatedConsentlessAudienceDocument,
  Oi as DownloadActivatedDirectAudienceDocument,
  Ei as DownloadComputeNodeResultAsCsvDocument,
  Ji as DownloadComputeNodeResultAsZipDocument,
  gu as DraftComputationNodeNameFragment,
  fe as DraftComputeNodeDocument,
  Se as DraftComputeNodeEditorDocument,
  be as DraftComputeNodeNameDocument,
  ge as DraftComputeNodeParticipantsDocument,
  Ne as DraftComputeNodeTypeDocument,
  Re as DraftComputeNodeTypenameDocument,
  Pe as DraftDataRoomActionsDocument,
  Ie as DraftDataRoomAsJsonDocument,
  ve as DraftDataRoomDataNodesDocument,
  xi as DraftDataRoomDeleteDocument,
  $e as DraftDataRoomDescriptionDocument,
  Qe as DraftDataRoomDocument,
  Bi as DraftDataRoomDuplicateDocument,
  Ce as DraftDataRoomEnableImmutabilityDocument,
  Ae as DraftDataRoomIsFavoriteDocument,
  Me as DraftDataRoomIsHiddenDocument,
  Le as DraftDataRoomNameDocument,
  ze as DraftDataRoomNodesDocument,
  He as DraftDataRoomOverviewDocument,
  qe as DraftDataRoomParticipantsDocument,
  Nu as DraftDataRoomPasswordFragment,
  Te as DraftDataRoomPublishDocument,
  we as DraftDataRoomShowOrganizationLogoDocument,
  ke as DraftDataRoomTestPublicationsDocument,
  _i as DraftDataRoomUpdateEnableImmutabilityDocument,
  Ru as DraftLeafNodeNameFragment,
  ji as DraftMatchNodeAddDependencyDocument,
  Fe as DraftMatchNodeConfigDocument,
  Ue as DraftMatchNodeDependenciesDocument,
  Wi as DraftMatchNodeRemoveDependencyDocument,
  Gi as DraftMatchNodeUpdateConfigDocument,
  In as DraftNodeConnectionIdFragment,
  Oe as DraftNodeIdDocument,
  Ee as DraftNodeTypenameDocument,
  xe as DraftNodesTypenamesDocument,
  Ki as DraftParticipantCreateAnalystPermissionDocument,
  Xi as DraftParticipantCreateDataOwnerPermissionDocument,
  Zi as DraftParticipantCreateDocument,
  ea as DraftParticipantDeleteAnalystPermissionDocument,
  ta as DraftParticipantDeleteDataOwnerPermissionDocument,
  Yi as DraftParticipantDeleteDocument,
  oa as DraftParticipantUpdateUserEmailDocument,
  Qu as DraftParticipantUserEmailFragment,
  Be as DraftPostComputeNodeDocument,
  _e as DraftPreviewComputeNodeDocument,
  je as DraftPrivacyFilterDocument,
  We as DraftS3ConnectionParamsDocument,
  Ge as DraftS3ObjectUploadDependencyDocument,
  Ve as DraftScriptingComputeNodeDocument,
  Ze as DraftSqlComputeNodeDocument,
  Ke as DraftSyntheticComputeNodeDocument,
  Xe as DraftSyntheticNodeAccuracyDocument,
  Ye as DraftSyntheticNodeDataSourceDocument,
  et as DraftSyntheticNodeDependencyDocument,
  tt as DraftSyntheticNodeIncludeStatisticsDocument,
  ot as DraftSyntheticNodeMaskingDocument,
  Je as DraftTableLeafNodeUniquenessDocument,
  Vi as DraftTableLeafNodeUpdateUniquenessDocument,
  na as EditUserOrganizationDocument,
  ia as EditUserRoleDocument,
  nt as EnclaveConfigurationPinDocument,
  it as EnclaveConnectionParametersForSubmittedDataRoomRequestDocument,
  at as EnclaveWorkersDocument,
  Pu as ExternalInvitationFragment,
  st as ExternalInvitationsDocument,
  aa as FetchComputeJobResultDocument,
  sa as FetchComputeJobResultSizeDocument,
  Rn as FullActivationConfigurationFragment,
  a as FullDataLabFragment,
  ua as GenerateConsentlessAudienceDocument,
  ut as GetComputeJobEnclaveHandleDocument,
  rt as GetComputeJobsDocument,
  dt as GetLookalikeMediaComputeJobDocument,
  ct as GetMediaInsightsComputeJobDocument,
  Xo as GetPublisherDisplayConfigurationDocument,
  pt as IsDraftDataRoomOwnerDocument,
  mt as IsPublishedDataRoomOwnerDocument,
  D as LookalikeMediaComputeJobCompleteFragment,
  gt as LookalikeMediaDataRoomMainbarDocument,
  ra as MatchNodeCreateDocument,
  da as MatchNodeDeleteDocument,
  ca as MatchNodeNameEditDocument,
  yt as MediaDataRoomActivationDocument,
  g as MediaDataRoomActivationDownloadConfigDocument,
  Dt as MediaDataRoomActivationTypeDocument,
  ht as MediaDataRoomAudienceInsightsDocument,
  ft as MediaDataRoomDatasetHashesDocument,
  lt as MediaDataRoomDocument,
  St as MediaDataRoomHashesDocument,
  bt as MediaDataRoomMainbarDocument,
  Nt as MediaDataRoomOrganizationsDocument,
  Rt as MediaDataRoomSummaryDocument,
  vn as MediaInsightsComputeJobCompleteFragment,
  ma as MediaInsightsInviteParticipantsDocument,
  pa as MediaInviteParticipantsDocument,
  Ma as MediaPublishDraftDataRoomDocument,
  la as MediaUnpublishAdvertiserDatasetDocument,
  ya as MediaUnpublishPublisherDatasetDocument,
  Da as MergeRemoteSubmittedDataRoomRequestDocument,
  ha as MergeSubmittedDataRoomRequestDocument,
  Qt as MyDataRoomsDocument,
  s as NavigationDrawerDraftDataRoomFragment,
  u as NavigationDrawerPublishedDataRoomFragment,
  p as NavigationDrawerPublishedLookalikeMediaDataRoomFragment,
  r as NavigationDrawerPublishedMediaDataRoomFragment,
  m as NavigationDrawerPublishedMediaInsightsDcrFragment,
  Pt as OrganizationComputeTimeoutDocument,
  It as OrganizationDataRoomsDocument,
  vt as OrganizationDetailsDocument,
  $t as OrganizationDomainsDocument,
  Ct as OrganizationEnclaveWorkersDocument,
  At as OrganizationFeaturesDocument,
  $n as OrganizationFragment,
  Mt as OrganizationLicenseDocument,
  Lt as OrganizationLogoDocument,
  zt as OrganizationMediaScopeDocument,
  Ht as OrganizationMicrosoftDspMemberDocument,
  qt as OrganizationNameDocument,
  Tt as OrganizationPageDocument,
  wt as OrganizationPreferencesDocument,
  kt as OrganizationUserEmailsDocument,
  Ft as OrganizationsDocument,
  Ut as OwnOrganizationUserEmailsDocument,
  fa as PollDatasetExportDocument,
  Sa as PollDatasetImportDocument,
  ba as PostNodeCreateDocument,
  ga as PostNodeDeleteDocument,
  Na as PostNodeNameEditDocument,
  Ot as PreviewComputeNodeResultDocument,
  Ra as PreviewNodeCreateDocument,
  Qa as PreviewNodeDeleteDocument,
  Pa as PreviewNodeNameEditDocument,
  Ia as ProvisionDataLabDocument,
  va as ProvisionDataLabToMediaInsightsDcrDocument,
  $a as PublishDatasetDocument,
  Ca as PublishDraftDataRoomDocument,
  Aa as PublishDraftDataRoomRemoteDocument,
  La as PublishMediaAdvertiserDatasetDocument,
  za as PublishMediaPublisherDatasetDocument,
  Et as PublishedComputeNodeDocument,
  Jt as PublishedComputeNodeEditorDocument,
  xt as PublishedComputeNodeJobDocument,
  Bt as PublishedComputeNodeNameDocument,
  _t as PublishedComputeNodeParticipantsDocument,
  jt as PublishedComputeNodeTypeDocument,
  Gt as PublishedDataRoomActionsDocument,
  Wt as PublishedDataRoomDataNodesDocument,
  Vt as PublishedDataRoomDataRoomHashDocument,
  Zt as PublishedDataRoomDescriptionDocument,
  ao as PublishedDataRoomDocument,
  Ha as PublishedDataRoomDuplicateDocument,
  Kt as PublishedDataRoomEnableImmutabilityDocument,
  Xt as PublishedDataRoomEnclaveConnectionParametersDocument,
  Yt as PublishedDataRoomIsFavoriteDocument,
  eo as PublishedDataRoomIsHiddenDocument,
  to as PublishedDataRoomLogoDocument,
  oo as PublishedDataRoomLowLevelRepresentationDocument,
  no as PublishedDataRoomNameDocument,
  io as PublishedDataRoomNodesDocument,
  so as PublishedDataRoomOverviewDocument,
  uo as PublishedDataRoomParticipantsDocument,
  Iu as PublishedDataRoomPasswordFragment,
  ro as PublishedDataRoomPasswordRequirementsDocument,
  vu as PublishedDataRoomPasswordRequirementsFragment,
  co as PublishedDataRoomStopDataDocument,
  po as PublishedDataRoomTestingDocument,
  $u as PublishedDataRoomTestingFragmentFragment,
  yo as PublishedLookalikeMediaDataRoomActionsDocument,
  Do as PublishedLookalikeMediaDataRoomDataLabDataDocument,
  lo as PublishedLookalikeMediaDataRoomDocument,
  ho as PublishedLookalikeMediaDataRoomIsFavoriteDocument,
  fo as PublishedLookalikeMediaDataRoomIsHiddenDocument,
  So as PublishedLookalikeMediaDataRoomOrganizationsDocument,
  bo as PublishedLookalikeMediaDataRoomOverviewDocument,
  mo as PublishedLookalikeMediaDataRoomStopDataDocument,
  go as PublishedMatchNodeConfigDocument,
  No as PublishedMatchNodeDependenciesDocument,
  Qo as PublishedMediaDataRoomActionsDocument,
  Ro as PublishedMediaDataRoomDocument,
  Po as PublishedMediaDataRoomIsFavoriteDocument,
  Io as PublishedMediaDataRoomIsHiddenDocument,
  vo as PublishedMediaDataRoomOverviewDocument,
  $o as PublishedMediaDataRoomStopDataDocument,
  Co as PublishedMediaInsightsDcrActionsDocument,
  Ao as PublishedMediaInsightsDcrDataLabDataDocument,
  Mo as PublishedMediaInsightsDcrIsFavoriteDocument,
  Lo as PublishedMediaInsightsDcrIsHiddenDocument,
  zo as PublishedMediaInsightsDcrOrganizationsDocument,
  Ho as PublishedMediaInsightsDcrOverviewDocument,
  qo as PublishedMediaInsightsDcrStopDataDocument,
  hu as PublishedNodeConnectionIdFragment,
  To as PublishedNodeIdDocument,
  wo as PublishedNodeTypenameDocument,
  Fo as PublishedNodesTypenamesDocument,
  Uo as PublishedPostComputeNodeDocument,
  Oo as PublishedPreviewComputeNodeDocument,
  Cu as PublishedPreviewNodeQuotasFragment,
  Eo as PublishedPrivacyFilterDocument,
  Jo as PublishedS3ConnectionParamsDocument,
  xo as PublishedS3ObjectUploadDependencyDocument,
  Bo as PublishedScriptingComputeNodeDocument,
  _o as PublishedSqlComputeNodeDocument,
  jo as PublishedSyntheticComputeNodeDocument,
  Wo as PublishedSyntheticNodeAccuracyDocument,
  Go as PublishedSyntheticNodeDataSourceDocument,
  Vo as PublishedSyntheticNodeDependencyDocument,
  Zo as PublishedSyntheticNodeIncludeStatisticsDocument,
  Ko as PublishedSyntheticNodeMaskingDocument,
  ko as PublishedTableLeafNodeUniquenessDocument,
  Yo as PublisherPortalOverviewDocument,
  qa as RebaseSubmittedDataRoomRequestDocument,
  Ta as RebaseSubmittedRequestDocument,
  wa as RemoveScriptingNodeDependencyDocument,
  en as RequestComputeNodeActionsDocument,
  tn as RequestComputeNodePermissionsDocument,
  on as RequestsDocument,
  nn as RequestsForReportDocument,
  ka as ResetJobIdsForDataLabDocument,
  Fa as RetrieveDraftComputationFormatDocument,
  Ua as RetrievePublishedComputationFormatDocument,
  Oa as RevokeAccessTokenDocument,
  Ea as S3NodeCreateDocument,
  Ja as S3NodeDeleteDocument,
  xa as S3NodeNameEditDocument,
  Ba as ScriptingNodeCreateDocument,
  _a as ScriptingNodeDeleteDocument,
  an as ScriptingNodeInteractivityPublishedDependenciesDocument,
  ja as ScriptingNodeNameEditDocument,
  Wa as SendCollaborationRequestToDataPartnerDocument,
  Ga as SendCollaborationRequestToPublisherDocument,
  Va as SendErrorReportDocument,
  Za as SendExternalInvitationOrgAdminDocument,
  Ka as SetComputeNodesOrderDocument,
  Xa as SetDataNodesOrderDocument,
  Ya as SetDataRoomDescriptionDocument,
  es as SetDataRoomNameDocument,
  ts as SetDemographicsDatasetForDataLabDocument,
  os as SetEmbeddingsDatasetForDataLabDocument,
  ns as SetJobIdsForDataLabDocument,
  is as SetPrivacyFilterDocument,
  as as SetSegmentsDatasetForDataLabDocument,
  ss as SetStatisticsForDataLabDocument,
  us as SetSyntheticNodeColumnsDocument,
  rs as SetSyntheticNodeIncludeStatisticsDocument,
  ds as SetTestModePublicationDocument,
  cs as SetUserHasLoggedInBeforeDocument,
  ps as SetUsersDatasetForDataLabDocument,
  sn as SharedWithMeDataRoomsDocument,
  ms as SignSubmittedDataRoomRequestDocument,
  ls as SqlNodeCreateDocument,
  ys as SqlNodeDeleteDocument,
  Ds as SqlNodeNameEditDocument,
  hs as SqliteNodeCreateDocument,
  fs as SqliteNodeDeleteDocument,
  Ss as SqliteNodeNameEditDocument,
  bs as StartJobPollingDocument,
  Au as StaticScriptFragment,
  gs as StopDataRoomDocument,
  Ns as StoreActivatedDirectAudienceAsDatasetDocument,
  Rs as SubmitDataRoomRequestDocument,
  un as SubmittedDataRoomRequestSignaturesDocument,
  rn as SubmittedDataRoomRequestsDocument,
  dn as SubmittedRequestComputeNodeActionsDocument,
  cn as SubmittedRequestComputeNodePermissionsDocument,
  Qs as SubmittedRequestComputeNodeRunDocument,
  pn as SubmittedRequestCreationDateDocument,
  mn as SubmittedRequestRebaseDocument,
  ln as SubmittedRequestSigneesDocument,
  Ps as SyntheticNodeCreateDocument,
  Is as SyntheticNodeDeleteDocument,
  yn as SyntheticNodeInteractivityPublishedDependenciesDocument,
  vs as SyntheticNodeNameEditDocument,
  $s as TestAllComputationsDocument,
  Cs as TestDraftComputationDocument,
  Dn as TestModePublicationDocument,
  As as UnpublishDatasetDocument,
  Ms as UpdateAdvertiserMarketFiltersDocument,
  Ls as UpdateDataPartnerDisplayConfigurationDocument,
  zs as UpdateDraftDataRoomIsFavoriteDocument,
  Hs as UpdateDraftDataRoomIsHiddenDocument,
  qs as UpdateDraftDataRoomShowOrganizationLogoDocument,
  Ts as UpdateDraftRawLeafNodeDocument,
  ws as UpdateDraftRawLeafNodeNameDocument,
  Fs as UpdateDraftTableLeafNodeColumnDocument,
  ks as UpdateDraftTableLeafNodeDocument,
  Us as UpdateDraftTableLeafNodeNameDocument,
  Os as UpdateOrganizationComputeTimeoutDocument,
  Es as UpdateOrganizationDomainsDocument,
  Js as UpdateOrganizationEnclaveWorkersDocument,
  xs as UpdateOrganizationFlagsDocument,
  Bs as UpdateOrganizationLicenseDocument,
  _s as UpdateOrganizationMediaScopeDocument,
  js as UpdateOrganizationMicrosoftDspMemberDocument,
  Ws as UpdateOrganizationNameDocument,
  Gs as UpdatePostComputeNodeDependencyDocument,
  Vs as UpdatePreviewComputeNodeDependencyDocument,
  Zs as UpdatePreviewComputeNodeQuotaDocument,
  Xs as UpdatePublishedDataRoomIsFavoriteDocument,
  Ks as UpdatePublishedDataRoomIsHiddenDocument,
  Ys as UpdatePublisherDisplayConfigurationDocument,
  eu as UpdateS3ConnectionParamsDocument,
  tu as UpdateS3CredentialsDependencyDocument,
  ou as UpdateS3UploadDependencyDocument,
  nu as UpdateScriptContentDocument,
  iu as UpdateScriptingNodeOutputFolderDocument,
  au as UpdateSqlComputeNodeDocument,
  su as UpdateSqliteComputeNodeDocument,
  uu as UpdateStaticScriptNameDocument,
  ru as UpdateSyntheticNodeAccuracyDocument,
  du as UpdateSyntheticNodeColumnDocument,
  cu as UpdateSyntheticNodeDataSourceDocument,
  pu as UpdateUserDocument,
  mu as UpsertOrganizationLogoDocument,
  hn as UserByEmailDocument,
  fn as UserDetailsDocument,
  Cn as UserFragment,
  Sn as UserHasLoggedInBeforeDocument,
  bn as UserRoleDocument,
  gn as UsersDocument,
  lu as ValidateDataRoomRequestDocument,
  Lu as useAccessTokenLazyQuery,
  Mu as useAccessTokenQuery,
  zu as useAccessTokenSuspenseQuery,
  qu as useAccessTokensLazyQuery,
  ku as useAccessTokensNamesLazyQuery,
  wu as useAccessTokensNamesQuery,
  Fu as useAccessTokensNamesSuspenseQuery,
  Hu as useAccessTokensQuery,
  Tu as useAccessTokensSuspenseQuery,
  Uu as useActivateConsentlessAudienceMutation,
  Ou as useActivateDirectAudienceMutation,
  Ju as useActivationConfigurationsLazyQuery,
  Eu as useActivationConfigurationsQuery,
  xu as useActivationConfigurationsSuspenseQuery,
  Gu as useActiveMarketsLazyQuery,
  Wu as useActiveMarketsQuery,
  Vu as useActiveMarketsSuspenseQuery,
  Zu as useAddRequestParticipantMutation,
  Ku as useAddScriptingNodeDependencyMutation,
  Xu as useAddSubmittedDataRoomRequestSignatureMutation,
  Yu as useAddSyntheticNodeColumnMutation,
  tr as useAdminPortalOrganizationUsersLazyQuery,
  er as useAdminPortalOrganizationUsersQuery,
  or as useAdminPortalOrganizationUsersSuspenseQuery,
  ur as useAdvertiserMarketFiltersLazyQuery,
  sr as useAdvertiserMarketFiltersQuery,
  rr as useAdvertiserMarketFiltersSuspenseQuery,
  dr as useApproveSubmittedDataRoomRequestMutation,
  cr as useArchiveOrganizationMutation,
  Dr as useAudienceInsightsAdvertiserLazyQuery,
  yr as useAudienceInsightsAdvertiserQuery,
  Sr as useAudienceInsightsAdvertiserStatisticsLazyQuery,
  fr as useAudienceInsightsAdvertiserStatisticsQuery,
  br as useAudienceInsightsAdvertiserStatisticsSuspenseQuery,
  hr as useAudienceInsightsAdvertiserSuspenseQuery,
  mr as useAudienceInsightsLazyQuery,
  Nr as useAudienceInsightsPublisherLazyQuery,
  gr as useAudienceInsightsPublisherQuery,
  Pr as useAudienceInsightsPublisherStatisticsLazyQuery,
  Qr as useAudienceInsightsPublisherStatisticsQuery,
  Ir as useAudienceInsightsPublisherStatisticsSuspenseQuery,
  Rr as useAudienceInsightsPublisherSuspenseQuery,
  pr as useAudienceInsightsQuery,
  $r as useAudienceInsightsStatisticsLazyQuery,
  vr as useAudienceInsightsStatisticsQuery,
  Cr as useAudienceInsightsStatisticsSuspenseQuery,
  lr as useAudienceInsightsSuspenseQuery,
  Mr as useAudienceTypesLazyQuery,
  Ar as useAudienceTypesQuery,
  Lr as useAudienceTypesSuspenseQuery,
  Hr as useAuditLogsLazyQuery,
  zr as useAuditLogsQuery,
  qr as useAuditLogsSuspenseQuery,
  wr as useAvailableDataPartnersLazyQuery,
  Tr as useAvailableDataPartnersQuery,
  kr as useAvailableDataPartnersSuspenseQuery,
  Ur as useAvailablePublishersLazyQuery,
  Fr as useAvailablePublishersQuery,
  Or as useAvailablePublishersSuspenseQuery,
  Jr as useCollaboratingOrganizationsLazyQuery,
  Er as useCollaboratingOrganizationsQuery,
  xr as useCollaboratingOrganizationsSuspenseQuery,
  _r as useCommittedComputeNodeActionsLazyQuery,
  Br as useCommittedComputeNodeActionsQuery,
  jr as useCommittedComputeNodeActionsSuspenseQuery,
  Wr as useCompleteComputeJobFailureMutation,
  Gr as useCompleteComputeJobSuccessMutation,
  Zr as useCompleteDataRoomRequestLazyQuery,
  Vr as useCompleteDataRoomRequestQuery,
  Kr as useCompleteDataRoomRequestSuspenseQuery,
  Yr as useCompleteDraftDataRoomLazyQuery,
  Xr as useCompleteDraftDataRoomQuery,
  ed as useCompleteDraftDataRoomSuspenseQuery,
  od as useCompleteMediaDataRoomLazyQuery,
  td as useCompleteMediaDataRoomQuery,
  nd as useCompleteMediaDataRoomSuspenseQuery,
  ad as useCompletePlaygroundLazyQuery,
  id as useCompletePlaygroundQuery,
  sd as useCompletePlaygroundSuspenseQuery,
  rd as useCompletePublishedDataRoomLazyQuery,
  ud as useCompletePublishedDataRoomQuery,
  dd as useCompletePublishedDataRoomSuspenseQuery,
  pd as useCompleteSubmittedDataRoomRequestLazyQuery,
  cd as useCompleteSubmittedDataRoomRequestQuery,
  md as useCompleteSubmittedDataRoomRequestSuspenseQuery,
  ld as useComputeNodeRunMutation,
  Dd as useConsentlessActivatedAudiencesLazyQuery,
  yd as useConsentlessActivatedAudiencesQuery,
  hd as useConsentlessActivatedAudiencesSuspenseQuery,
  ir as useConsentlessAudiencesLazyQuery,
  nr as useConsentlessAudiencesQuery,
  ar as useConsentlessAudiencesSuspenseQuery,
  fd as useCreateAccessTokenMutation,
  Sd as useCreateActivationConfigurationMutation,
  bd as useCreateComputeJobMutation,
  gd as useCreateDataConnectorJobMutation,
  Nd as useCreateDataLabMutation,
  Rd as useCreateDataPartnerDisplayConfigurationMutation,
  Qd as useCreateDataPartnerUsageConfigurationMutation,
  Pd as useCreateDataRoomPlaygroundMutation,
  Id as useCreateDataRoomRequestMutation,
  vd as useCreateDatasetExportMutation,
  $d as useCreateDatasetImportMutation,
  Cd as useCreateDemoUserMutation,
  Md as useCreateDraftDataRoomIsFavoriteMutation,
  Ld as useCreateDraftDataRoomIsHiddenMutation,
  Ad as useCreateDraftDataRoomMutation,
  zd as useCreateDraftRawLeafNodeMutation,
  qd as useCreateDraftTableLeafNodeColumnMutation,
  Hd as useCreateDraftTableLeafNodeMutation,
  Td as useCreateLookalikeMediaComputeJobMutation,
  wd as useCreateMediaInsightsComputeJobMutation,
  kd as useCreateOrganizationMutation,
  Fd as useCreateOrganizationUserMutation,
  Ud as useCreatePublishedDataRoomIsFavoriteMutation,
  Od as useCreatePublishedDataRoomIsHiddenMutation,
  Jd as useCreatePublisherDisplayConfigurationMutation,
  xd as useCreateRequestFromPlaygroundMutation,
  Bd as useCreateStaticScriptMutation,
  Ed as useCreateSubmittedDataRoomRequestMutation,
  jd as useCurrentUserDomainLazyQuery,
  _d as useCurrentUserDomainQuery,
  Wd as useCurrentUserDomainSuspenseQuery,
  Zd as useDataConnectorJobLazyQuery,
  Vd as useDataConnectorJobQuery,
  Yd as useDataConnectorJobResultLazyQuery,
  Xd as useDataConnectorJobResultQuery,
  ec as useDataConnectorJobResultSuspenseQuery,
  oc as useDataConnectorJobSecretLazyQuery,
  tc as useDataConnectorJobSecretQuery,
  nc as useDataConnectorJobSecretSuspenseQuery,
  ic as useDataConnectorJobSetToFailureMutation,
  ac as useDataConnectorJobSetToSuccessMutation,
  Kd as useDataConnectorJobSuspenseQuery,
  uc as useDataConnectorJobsLazyQuery,
  sc as useDataConnectorJobsQuery,
  cc as useDataConnectorJobsSecretsLazyQuery,
  dc as useDataConnectorJobsSecretsQuery,
  pc as useDataConnectorJobsSecretsSuspenseQuery,
  rc as useDataConnectorJobsSuspenseQuery,
  lc as useDataLabLazyQuery,
  mc as useDataLabQuery,
  yc as useDataLabSuspenseQuery,
  hc as useDataLabsLazyQuery,
  Dc as useDataLabsQuery,
  fc as useDataLabsSuspenseQuery,
  bc as useDataPartnerDisplayConfigurationLazyQuery,
  Sc as useDataPartnerDisplayConfigurationQuery,
  gc as useDataPartnerDisplayConfigurationSuspenseQuery,
  Rc as useDataPartnerUsageConfigurationsLazyQuery,
  Nc as useDataPartnerUsageConfigurationsQuery,
  Qc as useDataPartnerUsageConfigurationsSuspenseQuery,
  Ic as useDataRoomAttestationSpecsLazyQuery,
  Pc as useDataRoomAttestationSpecsQuery,
  vc as useDataRoomAttestationSpecsSuspenseQuery,
  Cc as useDataRoomRequestComputeNodeTypenameLazyQuery,
  $c as useDataRoomRequestComputeNodeTypenameQuery,
  Ac as useDataRoomRequestComputeNodeTypenameSuspenseQuery,
  Lc as useDataRoomRequestTempApproversLazyQuery,
  Mc as useDataRoomRequestTempApproversQuery,
  zc as useDataRoomRequestTempApproversSuspenseQuery,
  qc as useDataRoomsListLazyQuery,
  Hc as useDataRoomsListQuery,
  Tc as useDataRoomsListSuspenseQuery,
  kc as useDatasetByHashLazyQuery,
  wc as useDatasetByHashQuery,
  Fc as useDatasetByHashSuspenseQuery,
  Oc as useDatasetPublicationsByHashLazyQuery,
  Uc as useDatasetPublicationsByHashQuery,
  Ec as useDatasetPublicationsByHashSuspenseQuery,
  xc as useDatasetSchemaLazyQuery,
  Jc as useDatasetSchemaQuery,
  Bc as useDatasetSchemaSuspenseQuery,
  jc as useDatasetSecretsByHashLazyQuery,
  _c as useDatasetSecretsByHashQuery,
  Wc as useDatasetSecretsByHashSuspenseQuery,
  Vc as useDatasetsLazyQuery,
  Gc as useDatasetsQuery,
  Xc as useDatasetsSecretsLazyQuery,
  Kc as useDatasetsSecretsQuery,
  Yc as useDatasetsSecretsSuspenseQuery,
  Zc as useDatasetsSuspenseQuery,
  ep as useDeactivateDataRoomMutation,
  tp as useDeleteAccountMutation,
  op as useDeleteActivationConfigurationMutation,
  np as useDeleteConsentlessAudienceMutation,
  ip as useDeleteDataLabMutation,
  ap as useDeleteDataPartnerDisplayConfigurationMutation,
  sp as useDeleteDataPartnerUsageConfigurationMutation,
  up as useDeleteDataRoomMutation,
  rp as useDeleteDatasetMutation,
  Gd as useDeleteDraftRawLeafNodeMutation,
  cp as useDeleteDraftTableLeafNodeColumnMutation,
  dp as useDeleteDraftTableLeafNodeMutation,
  pp as useDeletePlaygroundMutation,
  mp as useDeletePublisherDisplayConfigurationMutation,
  lp as useDeleteRequestMutation,
  yp as useDeleteRequestParticipantMutation,
  Dp as useDeleteStaticScriptMutation,
  hp as useDeleteSyntheticNodeColumnMutation,
  fp as useDeleteTestModePublicationMutation,
  Sp as useDeleteUserMutation,
  gp as useDeprovisionDataLabFromMediaInsightsDcrMutation,
  bp as useDeprovisionDataLabMutation,
  Rp as useDevComputeNodeActionsLazyQuery,
  Np as useDevComputeNodeActionsQuery,
  Qp as useDevComputeNodeActionsSuspenseQuery,
  Ip as useDevComputeNodeJobLazyQuery,
  Pp as useDevComputeNodeJobQuery,
  vp as useDevComputeNodeJobSuspenseQuery,
  $p as useDevComputeNodeRunMutation,
  Ap as useDevComputeNodeTypenameLazyQuery,
  Cp as useDevComputeNodeTypenameQuery,
  Mp as useDevComputeNodeTypenameSuspenseQuery,
  Tp as useDevComputeNodesForReportLazyQuery,
  qp as useDevComputeNodesForReportQuery,
  wp as useDevComputeNodesForReportSuspenseQuery,
  zp as useDevComputeNodesLazyQuery,
  Lp as useDevComputeNodesQuery,
  Hp as useDevComputeNodesSuspenseQuery,
  Fp as useDirectActivatedAudiencesLazyQuery,
  kp as useDirectActivatedAudiencesQuery,
  Up as useDirectActivatedAudiencesSuspenseQuery,
  Ep as useDirectAudiencesLazyQuery,
  Op as useDirectAudiencesQuery,
  Jp as useDirectAudiencesSuspenseQuery,
  xp as useDownloadActivatedConsentlessAudienceMutation,
  Bp as useDownloadActivatedDirectAudienceMutation,
  _p as useDownloadComputeNodeResultAsCsvMutation,
  jp as useDownloadComputeNodeResultAsZipMutation,
  Kp as useDraftComputeNodeEditorLazyQuery,
  Zp as useDraftComputeNodeEditorQuery,
  Xp as useDraftComputeNodeEditorSuspenseQuery,
  Gp as useDraftComputeNodeLazyQuery,
  em as useDraftComputeNodeNameLazyQuery,
  Yp as useDraftComputeNodeNameQuery,
  tm as useDraftComputeNodeNameSuspenseQuery,
  nm as useDraftComputeNodeParticipantsLazyQuery,
  om as useDraftComputeNodeParticipantsQuery,
  im as useDraftComputeNodeParticipantsSuspenseQuery,
  Wp as useDraftComputeNodeQuery,
  Vp as useDraftComputeNodeSuspenseQuery,
  sm as useDraftComputeNodeTypeLazyQuery,
  am as useDraftComputeNodeTypeQuery,
  um as useDraftComputeNodeTypeSuspenseQuery,
  dm as useDraftComputeNodeTypenameLazyQuery,
  rm as useDraftComputeNodeTypenameQuery,
  cm as useDraftComputeNodeTypenameSuspenseQuery,
  Dm as useDraftDataRoomActionsLazyQuery,
  ym as useDraftDataRoomActionsQuery,
  hm as useDraftDataRoomActionsSuspenseQuery,
  Sm as useDraftDataRoomAsJsonLazyQuery,
  fm as useDraftDataRoomAsJsonQuery,
  bm as useDraftDataRoomAsJsonSuspenseQuery,
  Nm as useDraftDataRoomDataNodesLazyQuery,
  gm as useDraftDataRoomDataNodesQuery,
  Rm as useDraftDataRoomDataNodesSuspenseQuery,
  Qm as useDraftDataRoomDeleteMutation,
  Im as useDraftDataRoomDescriptionLazyQuery,
  Pm as useDraftDataRoomDescriptionQuery,
  vm as useDraftDataRoomDescriptionSuspenseQuery,
  $m as useDraftDataRoomDuplicateMutation,
  Am as useDraftDataRoomEnableImmutabilityLazyQuery,
  Cm as useDraftDataRoomEnableImmutabilityQuery,
  Mm as useDraftDataRoomEnableImmutabilitySuspenseQuery,
  zm as useDraftDataRoomIsFavoriteLazyQuery,
  Lm as useDraftDataRoomIsFavoriteQuery,
  Hm as useDraftDataRoomIsFavoriteSuspenseQuery,
  Tm as useDraftDataRoomIsHiddenLazyQuery,
  qm as useDraftDataRoomIsHiddenQuery,
  wm as useDraftDataRoomIsHiddenSuspenseQuery,
  mm as useDraftDataRoomLazyQuery,
  Fm as useDraftDataRoomNameLazyQuery,
  km as useDraftDataRoomNameQuery,
  Um as useDraftDataRoomNameSuspenseQuery,
  Em as useDraftDataRoomNodesLazyQuery,
  Om as useDraftDataRoomNodesQuery,
  Jm as useDraftDataRoomNodesSuspenseQuery,
  Bm as useDraftDataRoomOverviewLazyQuery,
  xm as useDraftDataRoomOverviewQuery,
  _m as useDraftDataRoomOverviewSuspenseQuery,
  Wm as useDraftDataRoomParticipantsLazyQuery,
  jm as useDraftDataRoomParticipantsQuery,
  Gm as useDraftDataRoomParticipantsSuspenseQuery,
  Zm as useDraftDataRoomPublishLazyQuery,
  Vm as useDraftDataRoomPublishQuery,
  Km as useDraftDataRoomPublishSuspenseQuery,
  pm as useDraftDataRoomQuery,
  Ym as useDraftDataRoomShowOrganizationLogoLazyQuery,
  Xm as useDraftDataRoomShowOrganizationLogoQuery,
  el as useDraftDataRoomShowOrganizationLogoSuspenseQuery,
  lm as useDraftDataRoomSuspenseQuery,
  ol as useDraftDataRoomTestPublicationsLazyQuery,
  tl as useDraftDataRoomTestPublicationsQuery,
  nl as useDraftDataRoomTestPublicationsSuspenseQuery,
  il as useDraftDataRoomUpdateEnableImmutabilityMutation,
  al as useDraftMatchNodeAddDependencyMutation,
  ul as useDraftMatchNodeConfigLazyQuery,
  sl as useDraftMatchNodeConfigQuery,
  rl as useDraftMatchNodeConfigSuspenseQuery,
  cl as useDraftMatchNodeDependenciesLazyQuery,
  dl as useDraftMatchNodeDependenciesQuery,
  pl as useDraftMatchNodeDependenciesSuspenseQuery,
  ml as useDraftMatchNodeRemoveDependencyMutation,
  ll as useDraftMatchNodeUpdateConfigMutation,
  Dl as useDraftNodeIdLazyQuery,
  yl as useDraftNodeIdQuery,
  hl as useDraftNodeIdSuspenseQuery,
  Sl as useDraftNodeTypenameLazyQuery,
  fl as useDraftNodeTypenameQuery,
  bl as useDraftNodeTypenameSuspenseQuery,
  Il as useDraftNodesTypenamesLazyQuery,
  Pl as useDraftNodesTypenamesQuery,
  vl as useDraftNodesTypenamesSuspenseQuery,
  Cl as useDraftParticipantCreateAnalystPermissionMutation,
  Al as useDraftParticipantCreateDataOwnerPermissionMutation,
  $l as useDraftParticipantCreateMutation,
  Ll as useDraftParticipantDeleteAnalystPermissionMutation,
  zl as useDraftParticipantDeleteDataOwnerPermissionMutation,
  Ml as useDraftParticipantDeleteMutation,
  Hl as useDraftParticipantUpdateUserEmailMutation,
  Tl as useDraftPostComputeNodeLazyQuery,
  ql as useDraftPostComputeNodeQuery,
  wl as useDraftPostComputeNodeSuspenseQuery,
  Fl as useDraftPreviewComputeNodeLazyQuery,
  kl as useDraftPreviewComputeNodeQuery,
  Ul as useDraftPreviewComputeNodeSuspenseQuery,
  El as useDraftPrivacyFilterLazyQuery,
  Ol as useDraftPrivacyFilterQuery,
  Jl as useDraftPrivacyFilterSuspenseQuery,
  Bl as useDraftS3ConnectionParamsLazyQuery,
  xl as useDraftS3ConnectionParamsQuery,
  _l as useDraftS3ConnectionParamsSuspenseQuery,
  Wl as useDraftS3ObjectUploadDependencyLazyQuery,
  jl as useDraftS3ObjectUploadDependencyQuery,
  Gl as useDraftS3ObjectUploadDependencySuspenseQuery,
  Zl as useDraftScriptingComputeNodeLazyQuery,
  Vl as useDraftScriptingComputeNodeQuery,
  Kl as useDraftScriptingComputeNodeSuspenseQuery,
  Yl as useDraftSqlComputeNodeLazyQuery,
  Xl as useDraftSqlComputeNodeQuery,
  ey as useDraftSqlComputeNodeSuspenseQuery,
  oy as useDraftSyntheticComputeNodeLazyQuery,
  ty as useDraftSyntheticComputeNodeQuery,
  ny as useDraftSyntheticComputeNodeSuspenseQuery,
  ay as useDraftSyntheticNodeAccuracyLazyQuery,
  iy as useDraftSyntheticNodeAccuracyQuery,
  sy as useDraftSyntheticNodeAccuracySuspenseQuery,
  ry as useDraftSyntheticNodeDataSourceLazyQuery,
  uy as useDraftSyntheticNodeDataSourceQuery,
  dy as useDraftSyntheticNodeDataSourceSuspenseQuery,
  py as useDraftSyntheticNodeDependencyLazyQuery,
  cy as useDraftSyntheticNodeDependencyQuery,
  my as useDraftSyntheticNodeDependencySuspenseQuery,
  yy as useDraftSyntheticNodeIncludeStatisticsLazyQuery,
  ly as useDraftSyntheticNodeIncludeStatisticsQuery,
  Dy as useDraftSyntheticNodeIncludeStatisticsSuspenseQuery,
  fy as useDraftSyntheticNodeMaskingLazyQuery,
  hy as useDraftSyntheticNodeMaskingQuery,
  Sy as useDraftSyntheticNodeMaskingSuspenseQuery,
  Nl as useDraftTableLeafNodeUniquenessLazyQuery,
  gl as useDraftTableLeafNodeUniquenessQuery,
  Rl as useDraftTableLeafNodeUniquenessSuspenseQuery,
  Ql as useDraftTableLeafNodeUpdateUniquenessMutation,
  by as useEditUserOrganizationMutation,
  gy as useEditUserRoleMutation,
  Ry as useEnclaveConfigurationPinLazyQuery,
  Ny as useEnclaveConfigurationPinQuery,
  Qy as useEnclaveConfigurationPinSuspenseQuery,
  Iy as useEnclaveConnectionParametersForSubmittedDataRoomRequestLazyQuery,
  Py as useEnclaveConnectionParametersForSubmittedDataRoomRequestQuery,
  vy as useEnclaveConnectionParametersForSubmittedDataRoomRequestSuspenseQuery,
  Cy as useEnclaveWorkersLazyQuery,
  $y as useEnclaveWorkersQuery,
  Ay as useEnclaveWorkersSuspenseQuery,
  Ly as useExternalInvitationsLazyQuery,
  My as useExternalInvitationsQuery,
  zy as useExternalInvitationsSuspenseQuery,
  Hy as useFetchComputeJobResultMutation,
  qy as useFetchComputeJobResultSizeMutation,
  Ty as useGenerateConsentlessAudienceMutation,
  ky as useGetComputeJobEnclaveHandleLazyQuery,
  wy as useGetComputeJobEnclaveHandleQuery,
  Fy as useGetComputeJobEnclaveHandleSuspenseQuery,
  Oy as useGetComputeJobsLazyQuery,
  Uy as useGetComputeJobsQuery,
  Ey as useGetComputeJobsSuspenseQuery,
  xy as useGetLookalikeMediaComputeJobLazyQuery,
  Jy as useGetLookalikeMediaComputeJobQuery,
  By as useGetLookalikeMediaComputeJobSuspenseQuery,
  jy as useGetMediaInsightsComputeJobLazyQuery,
  _y as useGetMediaInsightsComputeJobQuery,
  Wy as useGetMediaInsightsComputeJobSuspenseQuery,
  qg as useGetPublisherDisplayConfigurationLazyQuery,
  Hg as useGetPublisherDisplayConfigurationQuery,
  Tg as useGetPublisherDisplayConfigurationSuspenseQuery,
  Vy as useIsDraftDataRoomOwnerLazyQuery,
  Gy as useIsDraftDataRoomOwnerQuery,
  Zy as useIsDraftDataRoomOwnerSuspenseQuery,
  Xy as useIsPublishedDataRoomOwnerLazyQuery,
  Ky as useIsPublishedDataRoomOwnerQuery,
  Yy as useIsPublishedDataRoomOwnerSuspenseQuery,
  ID as useLookalikeMediaDataRoomMainbarLazyQuery,
  PD as useLookalikeMediaDataRoomMainbarQuery,
  vD as useLookalikeMediaDataRoomMainbarSuspenseQuery,
  eD as useMatchNodeCreateMutation,
  tD as useMatchNodeDeleteMutation,
  oD as useMatchNodeNameEditMutation,
  _u as useMediaDataRoomActivationDownloadConfigLazyQuery,
  Bu as useMediaDataRoomActivationDownloadConfigQuery,
  ju as useMediaDataRoomActivationDownloadConfigSuspenseQuery,
  uD as useMediaDataRoomActivationLazyQuery,
  sD as useMediaDataRoomActivationQuery,
  rD as useMediaDataRoomActivationSuspenseQuery,
  cD as useMediaDataRoomActivationTypeLazyQuery,
  dD as useMediaDataRoomActivationTypeQuery,
  pD as useMediaDataRoomActivationTypeSuspenseQuery,
  lD as useMediaDataRoomAudienceInsightsLazyQuery,
  mD as useMediaDataRoomAudienceInsightsQuery,
  yD as useMediaDataRoomAudienceInsightsSuspenseQuery,
  hD as useMediaDataRoomDatasetHashesLazyQuery,
  DD as useMediaDataRoomDatasetHashesQuery,
  fD as useMediaDataRoomDatasetHashesSuspenseQuery,
  bD as useMediaDataRoomHashesLazyQuery,
  SD as useMediaDataRoomHashesQuery,
  gD as useMediaDataRoomHashesSuspenseQuery,
  iD as useMediaDataRoomLazyQuery,
  RD as useMediaDataRoomMainbarLazyQuery,
  ND as useMediaDataRoomMainbarQuery,
  QD as useMediaDataRoomMainbarSuspenseQuery,
  CD as useMediaDataRoomOrganizationsLazyQuery,
  $D as useMediaDataRoomOrganizationsQuery,
  AD as useMediaDataRoomOrganizationsSuspenseQuery,
  nD as useMediaDataRoomQuery,
  LD as useMediaDataRoomSummaryLazyQuery,
  MD as useMediaDataRoomSummaryQuery,
  zD as useMediaDataRoomSummarySuspenseQuery,
  aD as useMediaDataRoomSuspenseQuery,
  qD as useMediaInsightsInviteParticipantsMutation,
  HD as useMediaInviteParticipantsMutation,
  Xh as useMediaPublishDraftDataRoomMutation,
  TD as useMediaUnpublishAdvertiserDatasetMutation,
  wD as useMediaUnpublishPublisherDatasetMutation,
  kD as useMergeRemoteSubmittedDataRoomRequestMutation,
  FD as useMergeSubmittedDataRoomRequestMutation,
  OD as useMyDataRoomsLazyQuery,
  UD as useMyDataRoomsQuery,
  ED as useMyDataRoomsSuspenseQuery,
  xD as useOrganizationComputeTimeoutLazyQuery,
  JD as useOrganizationComputeTimeoutQuery,
  BD as useOrganizationComputeTimeoutSuspenseQuery,
  jD as useOrganizationDataRoomsLazyQuery,
  _D as useOrganizationDataRoomsQuery,
  WD as useOrganizationDataRoomsSuspenseQuery,
  VD as useOrganizationDetailsLazyQuery,
  GD as useOrganizationDetailsQuery,
  ZD as useOrganizationDetailsSuspenseQuery,
  XD as useOrganizationDomainsLazyQuery,
  KD as useOrganizationDomainsQuery,
  YD as useOrganizationDomainsSuspenseQuery,
  th as useOrganizationEnclaveWorkersLazyQuery,
  eh as useOrganizationEnclaveWorkersQuery,
  oh as useOrganizationEnclaveWorkersSuspenseQuery,
  ih as useOrganizationFeaturesLazyQuery,
  nh as useOrganizationFeaturesQuery,
  ah as useOrganizationFeaturesSuspenseQuery,
  uh as useOrganizationLicenseLazyQuery,
  sh as useOrganizationLicenseQuery,
  rh as useOrganizationLicenseSuspenseQuery,
  ch as useOrganizationLogoLazyQuery,
  dh as useOrganizationLogoQuery,
  ph as useOrganizationLogoSuspenseQuery,
  lh as useOrganizationMediaScopeLazyQuery,
  mh as useOrganizationMediaScopeQuery,
  yh as useOrganizationMediaScopeSuspenseQuery,
  hh as useOrganizationMicrosoftDspMemberLazyQuery,
  Dh as useOrganizationMicrosoftDspMemberQuery,
  fh as useOrganizationMicrosoftDspMemberSuspenseQuery,
  bh as useOrganizationNameLazyQuery,
  Sh as useOrganizationNameQuery,
  gh as useOrganizationNameSuspenseQuery,
  Rh as useOrganizationPageLazyQuery,
  Nh as useOrganizationPageQuery,
  Qh as useOrganizationPageSuspenseQuery,
  Ih as useOrganizationPreferencesLazyQuery,
  Ph as useOrganizationPreferencesQuery,
  vh as useOrganizationPreferencesSuspenseQuery,
  Ch as useOrganizationUserEmailsLazyQuery,
  $h as useOrganizationUserEmailsQuery,
  Ah as useOrganizationUserEmailsSuspenseQuery,
  Lh as useOrganizationsLazyQuery,
  Mh as useOrganizationsQuery,
  zh as useOrganizationsSuspenseQuery,
  qh as useOwnOrganizationUserEmailsLazyQuery,
  Hh as useOwnOrganizationUserEmailsQuery,
  Th as useOwnOrganizationUserEmailsSuspenseQuery,
  wh as usePollDatasetExportMutation,
  kh as usePollDatasetImportMutation,
  Fh as usePostNodeCreateMutation,
  Uh as usePostNodeDeleteMutation,
  Oh as usePostNodeNameEditMutation,
  Jh as usePreviewComputeNodeResultLazyQuery,
  Eh as usePreviewComputeNodeResultQuery,
  xh as usePreviewComputeNodeResultSuspenseQuery,
  Bh as usePreviewNodeCreateMutation,
  _h as usePreviewNodeDeleteMutation,
  jh as usePreviewNodeNameEditMutation,
  Wh as useProvisionDataLabMutation,
  Gh as useProvisionDataLabToMediaInsightsDcrMutation,
  Vh as usePublishDatasetMutation,
  Zh as usePublishDraftDataRoomMutation,
  Kh as usePublishDraftDataRoomRemoteMutation,
  Yh as usePublishMediaAdvertiserDatasetMutation,
  ef as usePublishMediaPublisherDatasetMutation,
  sf as usePublishedComputeNodeEditorLazyQuery,
  af as usePublishedComputeNodeEditorQuery,
  uf as usePublishedComputeNodeEditorSuspenseQuery,
  df as usePublishedComputeNodeJobLazyQuery,
  rf as usePublishedComputeNodeJobQuery,
  cf as usePublishedComputeNodeJobSuspenseQuery,
  of as usePublishedComputeNodeLazyQuery,
  mf as usePublishedComputeNodeNameLazyQuery,
  pf as usePublishedComputeNodeNameQuery,
  lf as usePublishedComputeNodeNameSuspenseQuery,
  Df as usePublishedComputeNodeParticipantsLazyQuery,
  yf as usePublishedComputeNodeParticipantsQuery,
  hf as usePublishedComputeNodeParticipantsSuspenseQuery,
  tf as usePublishedComputeNodeQuery,
  nf as usePublishedComputeNodeSuspenseQuery,
  Sf as usePublishedComputeNodeTypeLazyQuery,
  ff as usePublishedComputeNodeTypeQuery,
  bf as usePublishedComputeNodeTypeSuspenseQuery,
  Pf as usePublishedDataRoomActionsLazyQuery,
  Qf as usePublishedDataRoomActionsQuery,
  If as usePublishedDataRoomActionsSuspenseQuery,
  Nf as usePublishedDataRoomDataNodesLazyQuery,
  gf as usePublishedDataRoomDataNodesQuery,
  Rf as usePublishedDataRoomDataNodesSuspenseQuery,
  $f as usePublishedDataRoomDataRoomHashLazyQuery,
  vf as usePublishedDataRoomDataRoomHashQuery,
  Cf as usePublishedDataRoomDataRoomHashSuspenseQuery,
  Mf as usePublishedDataRoomDescriptionLazyQuery,
  Af as usePublishedDataRoomDescriptionQuery,
  Lf as usePublishedDataRoomDescriptionSuspenseQuery,
  zf as usePublishedDataRoomDuplicateMutation,
  qf as usePublishedDataRoomEnableImmutabilityLazyQuery,
  Hf as usePublishedDataRoomEnableImmutabilityQuery,
  Tf as usePublishedDataRoomEnableImmutabilitySuspenseQuery,
  kf as usePublishedDataRoomEnclaveConnectionParametersLazyQuery,
  wf as usePublishedDataRoomEnclaveConnectionParametersQuery,
  Ff as usePublishedDataRoomEnclaveConnectionParametersSuspenseQuery,
  Of as usePublishedDataRoomIsFavoriteLazyQuery,
  Uf as usePublishedDataRoomIsFavoriteQuery,
  Ef as usePublishedDataRoomIsFavoriteSuspenseQuery,
  xf as usePublishedDataRoomIsHiddenLazyQuery,
  Jf as usePublishedDataRoomIsHiddenQuery,
  Bf as usePublishedDataRoomIsHiddenSuspenseQuery,
  iS as usePublishedDataRoomLazyQuery,
  jf as usePublishedDataRoomLogoLazyQuery,
  _f as usePublishedDataRoomLogoQuery,
  Wf as usePublishedDataRoomLogoSuspenseQuery,
  Vf as usePublishedDataRoomLowLevelRepresentationLazyQuery,
  Gf as usePublishedDataRoomLowLevelRepresentationQuery,
  Zf as usePublishedDataRoomLowLevelRepresentationSuspenseQuery,
  Xf as usePublishedDataRoomNameLazyQuery,
  Kf as usePublishedDataRoomNameQuery,
  Yf as usePublishedDataRoomNameSuspenseQuery,
  tS as usePublishedDataRoomNodesLazyQuery,
  eS as usePublishedDataRoomNodesQuery,
  oS as usePublishedDataRoomNodesSuspenseQuery,
  uS as usePublishedDataRoomOverviewLazyQuery,
  sS as usePublishedDataRoomOverviewQuery,
  rS as usePublishedDataRoomOverviewSuspenseQuery,
  cS as usePublishedDataRoomParticipantsLazyQuery,
  dS as usePublishedDataRoomParticipantsQuery,
  pS as usePublishedDataRoomParticipantsSuspenseQuery,
  lS as usePublishedDataRoomPasswordRequirementsLazyQuery,
  mS as usePublishedDataRoomPasswordRequirementsQuery,
  yS as usePublishedDataRoomPasswordRequirementsSuspenseQuery,
  nS as usePublishedDataRoomQuery,
  hS as usePublishedDataRoomStopDataLazyQuery,
  DS as usePublishedDataRoomStopDataQuery,
  fS as usePublishedDataRoomStopDataSuspenseQuery,
  aS as usePublishedDataRoomSuspenseQuery,
  bS as usePublishedDataRoomTestingLazyQuery,
  SS as usePublishedDataRoomTestingQuery,
  gS as usePublishedDataRoomTestingSuspenseQuery,
  CS as usePublishedLookalikeMediaDataRoomActionsLazyQuery,
  $S as usePublishedLookalikeMediaDataRoomActionsQuery,
  AS as usePublishedLookalikeMediaDataRoomActionsSuspenseQuery,
  LS as usePublishedLookalikeMediaDataRoomDataLabDataLazyQuery,
  MS as usePublishedLookalikeMediaDataRoomDataLabDataQuery,
  zS as usePublishedLookalikeMediaDataRoomDataLabDataSuspenseQuery,
  qS as usePublishedLookalikeMediaDataRoomIsFavoriteLazyQuery,
  HS as usePublishedLookalikeMediaDataRoomIsFavoriteQuery,
  TS as usePublishedLookalikeMediaDataRoomIsFavoriteSuspenseQuery,
  kS as usePublishedLookalikeMediaDataRoomIsHiddenLazyQuery,
  wS as usePublishedLookalikeMediaDataRoomIsHiddenQuery,
  FS as usePublishedLookalikeMediaDataRoomIsHiddenSuspenseQuery,
  IS as usePublishedLookalikeMediaDataRoomLazyQuery,
  OS as usePublishedLookalikeMediaDataRoomOrganizationsLazyQuery,
  US as usePublishedLookalikeMediaDataRoomOrganizationsQuery,
  ES as usePublishedLookalikeMediaDataRoomOrganizationsSuspenseQuery,
  xS as usePublishedLookalikeMediaDataRoomOverviewLazyQuery,
  JS as usePublishedLookalikeMediaDataRoomOverviewQuery,
  BS as usePublishedLookalikeMediaDataRoomOverviewSuspenseQuery,
  PS as usePublishedLookalikeMediaDataRoomQuery,
  RS as usePublishedLookalikeMediaDataRoomStopDataLazyQuery,
  NS as usePublishedLookalikeMediaDataRoomStopDataQuery,
  QS as usePublishedLookalikeMediaDataRoomStopDataSuspenseQuery,
  vS as usePublishedLookalikeMediaDataRoomSuspenseQuery,
  jS as usePublishedMatchNodeConfigLazyQuery,
  _S as usePublishedMatchNodeConfigQuery,
  WS as usePublishedMatchNodeConfigSuspenseQuery,
  VS as usePublishedMatchNodeDependenciesLazyQuery,
  GS as usePublishedMatchNodeDependenciesQuery,
  ZS as usePublishedMatchNodeDependenciesSuspenseQuery,
  tb as usePublishedMediaDataRoomActionsLazyQuery,
  eb as usePublishedMediaDataRoomActionsQuery,
  ob as usePublishedMediaDataRoomActionsSuspenseQuery,
  ib as usePublishedMediaDataRoomIsFavoriteLazyQuery,
  nb as usePublishedMediaDataRoomIsFavoriteQuery,
  ab as usePublishedMediaDataRoomIsFavoriteSuspenseQuery,
  ub as usePublishedMediaDataRoomIsHiddenLazyQuery,
  sb as usePublishedMediaDataRoomIsHiddenQuery,
  rb as usePublishedMediaDataRoomIsHiddenSuspenseQuery,
  XS as usePublishedMediaDataRoomLazyQuery,
  cb as usePublishedMediaDataRoomOverviewLazyQuery,
  db as usePublishedMediaDataRoomOverviewQuery,
  pb as usePublishedMediaDataRoomOverviewSuspenseQuery,
  KS as usePublishedMediaDataRoomQuery,
  lb as usePublishedMediaDataRoomStopDataLazyQuery,
  mb as usePublishedMediaDataRoomStopDataQuery,
  yb as usePublishedMediaDataRoomStopDataSuspenseQuery,
  YS as usePublishedMediaDataRoomSuspenseQuery,
  hb as usePublishedMediaInsightsDcrActionsLazyQuery,
  Db as usePublishedMediaInsightsDcrActionsQuery,
  fb as usePublishedMediaInsightsDcrActionsSuspenseQuery,
  bb as usePublishedMediaInsightsDcrDataLabDataLazyQuery,
  Sb as usePublishedMediaInsightsDcrDataLabDataQuery,
  gb as usePublishedMediaInsightsDcrDataLabDataSuspenseQuery,
  Rb as usePublishedMediaInsightsDcrIsFavoriteLazyQuery,
  Nb as usePublishedMediaInsightsDcrIsFavoriteQuery,
  Qb as usePublishedMediaInsightsDcrIsFavoriteSuspenseQuery,
  Ib as usePublishedMediaInsightsDcrIsHiddenLazyQuery,
  Pb as usePublishedMediaInsightsDcrIsHiddenQuery,
  vb as usePublishedMediaInsightsDcrIsHiddenSuspenseQuery,
  Cb as usePublishedMediaInsightsDcrOrganizationsLazyQuery,
  $b as usePublishedMediaInsightsDcrOrganizationsQuery,
  Ab as usePublishedMediaInsightsDcrOrganizationsSuspenseQuery,
  Lb as usePublishedMediaInsightsDcrOverviewLazyQuery,
  Mb as usePublishedMediaInsightsDcrOverviewQuery,
  zb as usePublishedMediaInsightsDcrOverviewSuspenseQuery,
  qb as usePublishedMediaInsightsDcrStopDataLazyQuery,
  Hb as usePublishedMediaInsightsDcrStopDataQuery,
  Tb as usePublishedMediaInsightsDcrStopDataSuspenseQuery,
  kb as usePublishedNodeIdLazyQuery,
  wb as usePublishedNodeIdQuery,
  Fb as usePublishedNodeIdSuspenseQuery,
  Ob as usePublishedNodeTypenameLazyQuery,
  Ub as usePublishedNodeTypenameQuery,
  Eb as usePublishedNodeTypenameSuspenseQuery,
  jb as usePublishedNodesTypenamesLazyQuery,
  _b as usePublishedNodesTypenamesQuery,
  Wb as usePublishedNodesTypenamesSuspenseQuery,
  Vb as usePublishedPostComputeNodeLazyQuery,
  Gb as usePublishedPostComputeNodeQuery,
  Zb as usePublishedPostComputeNodeSuspenseQuery,
  Xb as usePublishedPreviewComputeNodeLazyQuery,
  Kb as usePublishedPreviewComputeNodeQuery,
  Yb as usePublishedPreviewComputeNodeSuspenseQuery,
  tg as usePublishedPrivacyFilterLazyQuery,
  eg as usePublishedPrivacyFilterQuery,
  og as usePublishedPrivacyFilterSuspenseQuery,
  ig as usePublishedS3ConnectionParamsLazyQuery,
  ng as usePublishedS3ConnectionParamsQuery,
  ag as usePublishedS3ConnectionParamsSuspenseQuery,
  ug as usePublishedS3ObjectUploadDependencyLazyQuery,
  sg as usePublishedS3ObjectUploadDependencyQuery,
  rg as usePublishedS3ObjectUploadDependencySuspenseQuery,
  cg as usePublishedScriptingComputeNodeLazyQuery,
  dg as usePublishedScriptingComputeNodeQuery,
  pg as usePublishedScriptingComputeNodeSuspenseQuery,
  lg as usePublishedSqlComputeNodeLazyQuery,
  mg as usePublishedSqlComputeNodeQuery,
  yg as usePublishedSqlComputeNodeSuspenseQuery,
  hg as usePublishedSyntheticComputeNodeLazyQuery,
  Dg as usePublishedSyntheticComputeNodeQuery,
  fg as usePublishedSyntheticComputeNodeSuspenseQuery,
  bg as usePublishedSyntheticNodeAccuracyLazyQuery,
  Sg as usePublishedSyntheticNodeAccuracyQuery,
  gg as usePublishedSyntheticNodeAccuracySuspenseQuery,
  Rg as usePublishedSyntheticNodeDataSourceLazyQuery,
  Ng as usePublishedSyntheticNodeDataSourceQuery,
  Qg as usePublishedSyntheticNodeDataSourceSuspenseQuery,
  Ig as usePublishedSyntheticNodeDependencyLazyQuery,
  Pg as usePublishedSyntheticNodeDependencyQuery,
  vg as usePublishedSyntheticNodeDependencySuspenseQuery,
  Cg as usePublishedSyntheticNodeIncludeStatisticsLazyQuery,
  $g as usePublishedSyntheticNodeIncludeStatisticsQuery,
  Ag as usePublishedSyntheticNodeIncludeStatisticsSuspenseQuery,
  Lg as usePublishedSyntheticNodeMaskingLazyQuery,
  Mg as usePublishedSyntheticNodeMaskingQuery,
  zg as usePublishedSyntheticNodeMaskingSuspenseQuery,
  xb as usePublishedTableLeafNodeUniquenessLazyQuery,
  Jb as usePublishedTableLeafNodeUniquenessQuery,
  Bb as usePublishedTableLeafNodeUniquenessSuspenseQuery,
  kg as usePublisherPortalOverviewLazyQuery,
  wg as usePublisherPortalOverviewQuery,
  Fg as usePublisherPortalOverviewSuspenseQuery,
  Ug as useRebaseSubmittedDataRoomRequestMutation,
  Og as useRebaseSubmittedRequestMutation,
  Eg as useRemoveScriptingNodeDependencyMutation,
  xg as useRequestComputeNodeActionsLazyQuery,
  Jg as useRequestComputeNodeActionsQuery,
  Bg as useRequestComputeNodeActionsSuspenseQuery,
  jg as useRequestComputeNodePermissionsLazyQuery,
  _g as useRequestComputeNodePermissionsQuery,
  Wg as useRequestComputeNodePermissionsSuspenseQuery,
  Xg as useRequestsForReportLazyQuery,
  Kg as useRequestsForReportQuery,
  Yg as useRequestsForReportSuspenseQuery,
  Vg as useRequestsLazyQuery,
  Gg as useRequestsQuery,
  Zg as useRequestsSuspenseQuery,
  eN as useResetJobIdsForDataLabMutation,
  tN as useRetrieveDraftComputationFormatMutation,
  oN as useRetrievePublishedComputationFormatMutation,
  nN as useRevokeAccessTokenMutation,
  iN as useS3NodeCreateMutation,
  aN as useS3NodeDeleteMutation,
  sN as useS3NodeNameEditMutation,
  uN as useScriptingNodeCreateMutation,
  rN as useScriptingNodeDeleteMutation,
  cN as useScriptingNodeInteractivityPublishedDependenciesLazyQuery,
  dN as useScriptingNodeInteractivityPublishedDependenciesQuery,
  pN as useScriptingNodeInteractivityPublishedDependenciesSuspenseQuery,
  mN as useScriptingNodeNameEditMutation,
  lN as useSendCollaborationRequestToDataPartnerMutation,
  yN as useSendCollaborationRequestToPublisherMutation,
  DN as useSendErrorReportMutation,
  hN as useSendExternalInvitationOrgAdminMutation,
  fN as useSetComputeNodesOrderMutation,
  SN as useSetDataNodesOrderMutation,
  bN as useSetDataRoomDescriptionMutation,
  gN as useSetDataRoomNameMutation,
  NN as useSetDemographicsDatasetForDataLabMutation,
  RN as useSetEmbeddingsDatasetForDataLabMutation,
  QN as useSetJobIdsForDataLabMutation,
  PN as useSetPrivacyFilterMutation,
  IN as useSetSegmentsDatasetForDataLabMutation,
  vN as useSetStatisticsForDataLabMutation,
  $N as useSetSyntheticNodeColumnsMutation,
  CN as useSetSyntheticNodeIncludeStatisticsMutation,
  AN as useSetTestModePublicationMutation,
  MN as useSetUserHasLoggedInBeforeMutation,
  LN as useSetUsersDatasetForDataLabMutation,
  HN as useSharedWithMeDataRoomsLazyQuery,
  zN as useSharedWithMeDataRoomsQuery,
  qN as useSharedWithMeDataRoomsSuspenseQuery,
  TN as useSignSubmittedDataRoomRequestMutation,
  wN as useSqlNodeCreateMutation,
  kN as useSqlNodeDeleteMutation,
  FN as useSqlNodeNameEditMutation,
  UN as useSqliteNodeCreateMutation,
  ON as useSqliteNodeDeleteMutation,
  EN as useSqliteNodeNameEditMutation,
  JN as useStartJobPollingMutation,
  xN as useStopDataRoomMutation,
  BN as useStoreActivatedDirectAudienceAsDatasetMutation,
  _N as useSubmitDataRoomRequestMutation,
  WN as useSubmittedDataRoomRequestSignaturesLazyQuery,
  jN as useSubmittedDataRoomRequestSignaturesQuery,
  GN as useSubmittedDataRoomRequestSignaturesSuspenseQuery,
  ZN as useSubmittedDataRoomRequestsLazyQuery,
  VN as useSubmittedDataRoomRequestsQuery,
  KN as useSubmittedDataRoomRequestsSuspenseQuery,
  YN as useSubmittedRequestComputeNodeActionsLazyQuery,
  XN as useSubmittedRequestComputeNodeActionsQuery,
  eR as useSubmittedRequestComputeNodeActionsSuspenseQuery,
  oR as useSubmittedRequestComputeNodePermissionsLazyQuery,
  tR as useSubmittedRequestComputeNodePermissionsQuery,
  nR as useSubmittedRequestComputeNodePermissionsSuspenseQuery,
  iR as useSubmittedRequestComputeNodeRunMutation,
  sR as useSubmittedRequestCreationDateLazyQuery,
  aR as useSubmittedRequestCreationDateQuery,
  uR as useSubmittedRequestCreationDateSuspenseQuery,
  dR as useSubmittedRequestRebaseLazyQuery,
  rR as useSubmittedRequestRebaseQuery,
  cR as useSubmittedRequestRebaseSuspenseQuery,
  mR as useSubmittedRequestSigneesLazyQuery,
  pR as useSubmittedRequestSigneesQuery,
  lR as useSubmittedRequestSigneesSuspenseQuery,
  yR as useSyntheticNodeCreateMutation,
  DR as useSyntheticNodeDeleteMutation,
  fR as useSyntheticNodeInteractivityPublishedDependenciesLazyQuery,
  hR as useSyntheticNodeInteractivityPublishedDependenciesQuery,
  SR as useSyntheticNodeInteractivityPublishedDependenciesSuspenseQuery,
  bR as useSyntheticNodeNameEditMutation,
  gR as useTestAllComputationsMutation,
  NR as useTestDraftComputationMutation,
  QR as useTestModePublicationLazyQuery,
  RR as useTestModePublicationQuery,
  PR as useTestModePublicationSuspenseQuery,
  IR as useUnpublishDatasetMutation,
  vR as useUpdateAdvertiserMarketFiltersMutation,
  $R as useUpdateDataPartnerDisplayConfigurationMutation,
  CR as useUpdateDraftDataRoomIsFavoriteMutation,
  AR as useUpdateDraftDataRoomIsHiddenMutation,
  MR as useUpdateDraftDataRoomShowOrganizationLogoMutation,
  LR as useUpdateDraftRawLeafNodeMutation,
  zR as useUpdateDraftRawLeafNodeNameMutation,
  qR as useUpdateDraftTableLeafNodeColumnMutation,
  HR as useUpdateDraftTableLeafNodeMutation,
  TR as useUpdateDraftTableLeafNodeNameMutation,
  wR as useUpdateOrganizationComputeTimeoutMutation,
  kR as useUpdateOrganizationDomainsMutation,
  FR as useUpdateOrganizationEnclaveWorkersMutation,
  UR as useUpdateOrganizationFlagsMutation,
  OR as useUpdateOrganizationLicenseMutation,
  ER as useUpdateOrganizationMediaScopeMutation,
  JR as useUpdateOrganizationMicrosoftDspMemberMutation,
  xR as useUpdateOrganizationNameMutation,
  BR as useUpdatePostComputeNodeDependencyMutation,
  _R as useUpdatePreviewComputeNodeDependencyMutation,
  jR as useUpdatePreviewComputeNodeQuotaMutation,
  GR as useUpdatePublishedDataRoomIsFavoriteMutation,
  WR as useUpdatePublishedDataRoomIsHiddenMutation,
  VR as useUpdatePublisherDisplayConfigurationMutation,
  ZR as useUpdateS3ConnectionParamsMutation,
  KR as useUpdateS3CredentialsDependencyMutation,
  XR as useUpdateS3UploadDependencyMutation,
  YR as useUpdateScriptContentMutation,
  eQ as useUpdateScriptingNodeOutputFolderMutation,
  tQ as useUpdateSqlComputeNodeMutation,
  oQ as useUpdateSqliteComputeNodeMutation,
  nQ as useUpdateStaticScriptNameMutation,
  iQ as useUpdateSyntheticNodeAccuracyMutation,
  aQ as useUpdateSyntheticNodeColumnMutation,
  sQ as useUpdateSyntheticNodeDataSourceMutation,
  uQ as useUpdateUserMutation,
  rQ as useUpsertOrganizationLogoMutation,
  cQ as useUserByEmailLazyQuery,
  dQ as useUserByEmailQuery,
  pQ as useUserByEmailSuspenseQuery,
  lQ as useUserDetailsLazyQuery,
  mQ as useUserDetailsQuery,
  yQ as useUserDetailsSuspenseQuery,
  hQ as useUserHasLoggedInBeforeLazyQuery,
  DQ as useUserHasLoggedInBeforeQuery,
  fQ as useUserHasLoggedInBeforeSuspenseQuery,
  bQ as useUserRoleLazyQuery,
  SQ as useUserRoleQuery,
  gQ as useUserRoleSuspenseQuery,
  RQ as useUsersLazyQuery,
  NQ as useUsersQuery,
  QQ as useUsersSuspenseQuery,
  PQ as useValidateDataRoomRequestMutation
};
//# sourceMappingURL=hooks.js.map
